/* Planet Tree · Neuer Personalisierer (Claude, 22.10.2026)
   Eigene Oberflaeche als Popup auf der bestehenden Engine (window.PTGuidedLight).
   Bewusst ES5 (var/function, keine Pfeile/Template-Strings/async) fuer aeltere iOS/Android. */
(function () {
  "use strict";
  var root = document.getElementById("ptn");
  var host = document.getElementById("pt-quick-b2c");
  if (!root || !host) return;
  /* Alte Vorlagen-Links (/#pt-vorlage=…) direkt im neuen Gestalter oeffnen, bevor pt-shop-tools seinen Dialog zeigt */
  var earlyTpl = /^#pt-vorlage=([a-f0-9]{64})$/.exec(location.hash || "");
  if (earlyTpl) { try { history.replaceState(null, "", location.pathname + location.search); } catch (e) { earlyTpl = null; } }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }
  function clear(e) { while (e.firstChild) e.removeChild(e.firstChild); }
  function on(e, ev, fn) { e.addEventListener(ev, fn, false); }
  function addCls(e, c) { if ((" " + e.className + " ").indexOf(" " + c + " ") < 0) e.className = (e.className ? e.className + " " : "") + c; }
  function rmCls(e, c) { e.className = (" " + e.className + " ").replace(" " + c + " ", " ").replace(/^\s+|\s+$/g, ""); }
  function euro(n) {
    var v = Math.round((Number(n) || 0) * 100) / 100;
    return v.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €";
  }
  function track(name, data) {
    if (STAFF_ON) return;
    try { if (window.PTGuidedSession && window.PTGuidedSession.track) window.PTGuidedSession.track(name, data || {}, "ptn:" + name + ":" + ((data && data.step) || "")); } catch (e) {}
  }
  function saveDraft() { if (!STAFF_ON) { try { if (window.PTGuidedSession && window.PTGuidedSession.save) window.PTGuidedSession.save(); } catch (e) {} } scheduleGreetPrep(); }

  var OCCASIONS = [
    { key: "geburtstag", label: "Geburtstag", icon: "🎂", collection: "beliebte-geschenke",
      words: ["Alles Liebe\nzum Geburtstag", "Happy Birthday!", "Auf dein neues\nLebensjahr", "Wachse weiter\nwie dieser Baum"] },
    { key: "geburt", label: "Geburt & Taufe", icon: "👶", collection: "alle-kinderbucher",
      words: ["Willkommen\nauf der Welt", "Ein Baum, der\nmit dir wächst", "Herzlich willkommen,\nkleines Wunder"] },
    { key: "hochzeit", label: "Hochzeit", icon: "💍", collection: "beliebte-geschenke",
      words: ["Alles Liebe\nzur Hochzeit", "Auf eure\ngemeinsamen Wurzeln", "Für eine Liebe,\ndie wächst"] },
    { key: "danke", label: "Danke", icon: "💚", collection: "beliebte-geschenke",
      words: ["Ein herzliches\nDankeschön", "Danke, dass es\ndich gibt", "Danke für alles"] },
    { key: "weihnachten", label: "Weihnachten", icon: "🎄", collection: "advent-und-weihnachten",
      words: ["Frohe Weihnachten", "Fröhliche Weihnachten\nund ein grünes neues Jahr", "Ein Geschenk,\ndas wächst"] },
    { key: "erinnerung", label: "Erinnerung", icon: "🕯️", collection: "beliebte-geschenke",
      words: ["In liebevoller\nErinnerung", "Unvergessen", "Was bleibt,\nist Liebe"] },
    { key: "einfach", label: "Einfach so", icon: "🌳", collection: "beliebte-geschenke",
      words: ["Einfach für dich", "Weil du mir\nwichtig bist", "Für dich –\neinfach so"] }
  ];
  var FORESTS = [
    { key: "by", title: "Bayerischer Zukunftswald", region: "Bayern", site: "Kommunaler Wald Stadt Alzenau \u00b7 Bayern", short: "Stadtwald Alzenau",
      body: "Im Stadtwald Alzenau unterst\u00fctzen wir die Wiederbewaldung gesch\u00e4digter Fl\u00e4chen und die Entwicklung vielf\u00e4ltiger, klimastabiler Mischw\u00e4lder.",
      tree: "H\u00e4ufigste Baumart: Stieleiche", report: "/pages/bayern-fruehjahr-2026", pos: [50.100222, 9.068389], place: "Alzenau", dir: "right" },
    { key: "mv", title: "Norddeutscher Klimawald", region: "Mecklenburg-Vorpommern", site: "Forstamt Schlemmin \u00b7 Landesforst Mecklenburg-Vorpommern", short: "Forstamt Schlemmin",
      body: "Gemeinsam mit dem Forstamt Schlemmin unterst\u00fctzen wir widerstandsf\u00e4hige heimische Pflanzfl\u00e4chen. Die Region begleitet Planet Tree seit den ersten Pflanzungen.",
      tree: "H\u00e4ufigste Baumart: Bergahorn", report: "/pages/mv-fruehjahr-2026", pos: [53.749361, 11.904306], place: "Schlemmin", dir: "right" },
    { key: "rp", title: "Eifel-Mischwald", region: "Rheinland-Pfalz", site: "Forstrevier Stadtkyll \u00b7 Eifel \u00b7 Rheinland-Pfalz", short: "Forstrevier Stadtkyll",
      body: "Im Forstrevier Stadtkyll unterst\u00fctzen wir die Wiederbewaldung und die Entwicklung klimastabiler Mischw\u00e4lder in der Eifel.",
      tree: "H\u00e4ufigste Baumart: Stieleiche", report: "/pages/eifel-fruehjahr-2026", pos: [50.31375, 6.428444], place: "Stadtkyll", dir: "left" }
  ];
  var STEPS = [
    { key: "names", label: "Namen" },
    { key: "sentence", label: "Satz" },
    { key: "words", label: "Widmung" },
    { key: "place", label: "Pflanzort" },
    { key: "trees", label: "Bäume" },
    { key: "design", label: "Motiv" },
    { key: "format", label: "Format" }
  ];

  /* ---------- Geburtsurkunde (#ptn data-ptn-mode="birth", Claude 23.10.2026) ----------
     Uebernommen aus dem alten Gestalter (pt-birth-editor.js): gleiche Felder und Pruefungen,
     Reh/Fuchs-Motiv mit Vorschlag nach Vorname, Vorschau lokal per Canvas.
     Bestellung: Engine schickt birth-v1 an den Server, der die echte Urkunde rendert. */
  var BIRTH = root.getAttribute("data-ptn-mode") === "birth";
  if (BIRTH) STEPS = [
    { key: "child", label: "Kind" },
    { key: "details", label: "Geburt" },
    { key: "place", label: "Pflanzort" },
    { key: "format", label: "Format" }
  ];
  /* ---------- Team-Korrektur (Claude 26.10.2026, Wunsch Leslie) ----------
     Link "Zertifikat ändern (Team)" in der Shopify-Bestellung -> /api2/cert/staff_edit/<bundle> (nur mit Mailsupport-Anmeldung)
     -> ?pt_staff_edit=<Schluessel>. Laedt das bestellte Zertifikat; aenderbar sind nur Inhalte, Etikett und Grusskarte.
     Speichern stempelt auf dem Server neu (gleicher Code/QR/Pflanzort), danach Uebersicht mit Downloads. Kein Warenkorb. */
  var STAFF = (function () { var m = /[?&]pt_staff_edit=([^&#]+)/.exec(location.search || ""); try { return m ? decodeURIComponent(m[1]) : ""; } catch (e) { return ""; } })();
  var STAFF_API = "https://partner.planet-tree.de/api2/cert/";
  var staff = { info: null, label: null, labelTouched: false, saving: false, result: null };
  /* Team-Ausstellung ohne Bestellung (Team-Zentrale /api2/cert/staff_admin -> ?pt_staff_issue=<Schluessel>[&tpl=<Vorlage>][&note=]):
     alle Inhalts-Schritte inkl. Pflanzort/Baeume, am Ende Kundenvorlage speichern (inkl. Logo) und/oder ausstellen (echter Code, gestempelte PDF). */
  var ISSUE = (function () { var m = /[?&]pt_staff_issue=([^&#]+)/.exec(location.search || ""); try { return m ? decodeURIComponent(m[1]) : ""; } catch (e) { return ""; } })();
  var ISSUE_TPL = parseInt((/[?&]tpl=(\d+)/.exec(location.search || "") || [])[1] || "0", 10) || 0;
  var STAFF_ON = !!(STAFF || ISSUE);
  if (ISSUE) {
    staff.note = (function () { var m = /[?&]note=([^&#]*)/.exec(location.search || ""); try { return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : ""; } catch (e) { return ""; } })();
    staff.tpl = null; staff.tplName = ""; staff.tplMsg = "";
    STEPS = STEPS.slice(0, BIRTH ? 3 : 6).concat([{ key: "issue", label: "Ausstellen" }]);
  }
  if (STAFF) STEPS = BIRTH ? [STEPS[0], STEPS[1], { key: "staff", label: "Speichern" }] : [STEPS[0], STEPS[1], STEPS[2], STEPS[5], { key: "staff", label: "Speichern" }];
  /* Schnellweg (Claude 28.10.2026, Test): Namen -> Satz -> "Fertig?" (Vorschau + alle Anpassungen sichtbar + Kasse) -> optional weiter wie gewohnt */
  var QUICK = !BIRTH && !STAFF && !ISSUE && window.PTN_QUICK !== 0 && !/[?&]view=lang(&|$)/.test(location.search || "");
  /* Claude 02.11.2026 (Leslie): wieder Schritt fuer Schritt mit "Weiter", Uebersicht "Fertig?" am Ende */
  if (QUICK) STEPS.push({ key: "quick", label: "Fertig?" });
  var B = { name: "", date: "", time: "", weight: "", height: "", place: "", motif: "reh", motifManual: false, nameGender: "unknown" };
  var B_MONTHS = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
  var B_DAYS = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
  var B_PAL = { reh: { frame: "#c1c684", text: "#f56bca", accent: "#bfc67d" }, fuchs: { frame: "#92872c", text: "#057cba", accent: "#e6a44e" } };
  var bAssets = root.getAttribute("data-ptn-birth-assets") || "";
  var bFontUrl = root.getAttribute("data-ptn-birth-font") || "";
  var bImg = "", bRev = 0, bTimer = 0, bToken = 0, bImgs = {}, bBgs = {}, bFontP = null, bMotifBox = null;
  var BW = 1200, BS = 1200 / 2480, BH = Math.round(3508 * 1200 / 2480);
  function pad2(n) { n = String(n); return n.length < 2 ? "0" + n : n; }
  function bTrim(s) { return String(s == null ? "" : s).replace(/^\s+|\s+$/g, ""); }
  function bToday() { var d = new Date(); return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate()); }
  function bParseDate(v) {
    v = bTrim(v);
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(v);
    if (m) return m[1] + "-" + pad2(m[2]) + "-" + pad2(m[3]);
    m = /^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})$/.exec(v);
    if (m) return m[3] + "-" + pad2(m[2]) + "-" + pad2(m[1]);
    return v;
  }
  function bDate(iso) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso || "")) return null;
    var p = iso.split("-"), y = +p[0], mo = +p[1], d = +p[2], v = new Date(y, mo - 1, d, 12);
    return v.getFullYear() === y && v.getMonth() === mo - 1 && v.getDate() === d ? v : null;
  }
  function bDateOk(iso) { return !!bDate(iso) && iso >= "1900-01-01" && iso <= bToday(); }
  function bDateText(iso) { var d = bDate(iso); return d ? pad2(d.getDate()) + "." + pad2(d.getMonth() + 1) + "." + d.getFullYear() : (iso || ""); }
  function bNorm(key, value) {
    var raw = bTrim(value);
    if (!raw) return "";
    if (key === "time") {
      var input = raw.toLowerCase().replace(/\s*(?:uhr|h)\s*$/, "").replace(/\s+/g, "");
      var m = input.match(/^(\d{1,2})(?:[:.,h]|uhr)(\d{1,2})$/), hour, minute;
      if (m) { hour = +m[1]; minute = +m[2]; }
      else if (/^\d{3,4}$/.test(input)) { hour = +input.slice(0, -2); minute = +input.slice(-2); }
      else if (/^\d{1,2}$/.test(input)) { hour = +input; minute = 0; }
      else return raw;
      return hour < 24 && minute < 60 ? pad2(hour) + ":" + pad2(minute) : raw;
    }
    if (key !== "weight" && key !== "height") return raw;
    var match = raw.toLowerCase().match(key === "weight" ? /^([\d.,\s'’]+)\s*(kilogramm(?:e)?|kilograms?|kilo|kg|gramm(?:e)?|grams?|g)?$/ : /^([\d.,\s'’]+)\s*(zentimeter|centimeters?|centimetres?|cm|millimeter|millimeters?|mm|meter|metres?|meters?|m)?$/);
    if (!match) return raw;
    var number = match[1].replace(/[\s'’]/g, ""), unit = match[2] || "";
    var kilograms = key === "weight" && /^(k|kil)/.test(unit);
    if (key === "weight" && !kilograms && /^\d{1,3}(?:[.,]\d{3})+$/.test(number)) number = number.replace(/[.,]/g, "");
    else if (/^\d{1,3}(?:\.\d{3})+,\d+$/.test(number)) number = number.replace(/\./g, "").replace(",", ".");
    else if (/^\d{1,3}(?:,\d{3})+\.\d+$/.test(number)) number = number.replace(/,/g, "");
    else number = number.replace(",", ".");
    if (!/^(?:\d+(?:\.\d+)?|\.\d+)$/.test(number)) return raw;
    var n = Number(number);
    /* "3,45" ohne Einheit meint Kilogramm */
    if (kilograms || (key === "weight" && !unit && n > 0 && n < 20)) n *= 1000;
    if (key === "height") {
      if (/^(m|meter|metre|meters|metres)$/.test(unit) || (!unit && n > 0 && n < 3)) n *= 100;
      else if (unit === "mm" || /^millimeter/.test(unit)) n /= 10;
    }
    if (!(n > 0 && n <= (key === "weight" ? 20000 : 200)) || (key === "height" && n < 3)) return raw;
    if (key === "weight" && Math.abs(n * 10 - Math.round(n * 10)) > 0.000001) return raw;
    return String(Number(n.toFixed(key === "weight" ? 1 : 3))).replace(".", ",");
  }
  function bData() {
    return { name: bTrim(B.name).replace(/\s+/g, " "), date: bParseDate(B.date), time: bNorm("time", B.time), weight: bNorm("weight", B.weight), height: bNorm("height", B.height),
      place: bTrim(B.place), motif: B.motif === "fuchs" ? "fuchs" : "reh", motifManual: !!B.motifManual, nameGender: B.nameGender || "unknown" };
  }
  /* Pruefung wie im alten Gestalter; liefert [Feld, Meldung] oder null */
  function bProblem() {
    var d = bData();
    if (!d.name) return ["name", "Bitte trage den Namen des Kindes ein."];
    if (!bDateOk(d.date)) return ["date", "Bitte ein gültiges Geburtsdatum bis heute eintragen."];
    if (d.time && !/^([01]\d|2[0-3]):[0-5]\d$/.test(d.time)) return ["time", "Bitte die Uhrzeit als Stunden:Minuten eintragen, z. B. 22:32."];
    if (d.weight && !(/^\d{1,5}(?:,\d)?$/.test(d.weight) && +d.weight.replace(",", ".") > 0 && +d.weight.replace(",", ".") <= 20000)) return ["weight", "Bitte das Gewicht in Gramm eintragen, z. B. 3450."];
    if (d.height && !(/^\d{1,3}(?:,\d+)?$/.test(d.height) && +d.height.replace(",", ".") > 0 && +d.height.replace(",", ".") <= 200)) return ["height", "Bitte die Größe in Zentimetern eintragen, z. B. 52."];
    return null;
  }
  function bReady() { var p = bProblem(); return !p || (p[0] !== "name" && p[0] !== "date"); }
  function bSave() { try { window.localStorage.setItem("ptn-birth-v1", JSON.stringify(B)); } catch (e) {} }
  if (BIRTH) {
    window.PTNeuBirthMode = true;
    try {
      var bStored = JSON.parse(window.localStorage.getItem("ptn-birth-v1") || "null");
      if (bStored && typeof bStored === "object") for (var bk in B) if (B.hasOwnProperty(bk) && bStored[bk] !== undefined && bStored[bk] !== null) B[bk] = bStored[bk];
    } catch (e) {}
  }
  function bLoad(url) {
    if (!bImgs[url]) bImgs[url] = new Promise(function (res, rej) {
      var im = new Image();
      im.crossOrigin = "anonymous";
      im.onload = function () { res(im); };
      im.onerror = function () { delete bImgs[url]; rej(new Error("Bild nicht geladen")); };
      im.src = url;
    });
    return bImgs[url];
  }
  function bFont() {
    if (bFontP) return bFontP;
    bFontP = new Promise(function (res) {
      var done = false;
      function fin() { if (!done) { done = true; res(); } }
      try {
        if (window.FontFace && document.fonts && document.fonts.add) {
          new window.FontFace("PTBirthAmatic", "url(" + JSON.stringify(bFontUrl) + ")").load().then(function (f) { document.fonts.add(f); fin(); }, fin);
        } else {
          var stl = document.createElement("style");
          stl.textContent = "@font-face{font-family:PTBirthAmatic;src:url(" + JSON.stringify(bFontUrl) + ") format('woff2')}";
          document.head.appendChild(stl);
          var probe = el("span", "", "Aa");
          probe.style.cssText = "position:absolute;left:-999px;top:0;font-family:PTBirthAmatic";
          document.body.appendChild(probe);
          setTimeout(fin, 1200);
        }
      } catch (e) { fin(); }
      setTimeout(fin, 5000);
    });
    return bFontP;
  }
  function bFit(c, value, size, width) {
    c.font = size + "px PTBirthAmatic";
    while (c.measureText(value).width > width && size > 32) { size -= 2; c.font = size + "px PTBirthAmatic"; }
    return size;
  }
  function bText(c, color, value, x, y, size, width) {
    if (!value) return;
    c.fillStyle = color; c.textAlign = "center"; c.textBaseline = "middle";
    bFit(c, value, size, width);
    c.fillText(value, x, y);
  }
  function bDot(c, x, y, w, h, r) {
    c.beginPath(); c.moveTo(x + r, y);
    c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r);
    c.closePath(); c.fill();
  }
  function bForest() { try { return (L && L.state().forest) || "by"; } catch (e) { return "by"; } }
  /* Hintergrund (Rahmen, Banner, Motiv, Linien, Fusszeile mit Pflanzort) je Motiv und Wald zwischenspeichern */
  function bBackground(motif, forest) {
    var k = motif + "|" + forest;
    if (bBgs[k]) return Promise.resolve(bBgs[k]);
    var p = B_PAL[motif];
    var foot = bLoad("https://partner.planet-tree.de/api2/cert/quick_footer_preview.png?forest=" + encodeURIComponent(forest) + "&decor=dot")["catch"](function () { return null; });
    return Promise.all([bLoad(bAssets + "pt-birth-" + motif + "-banner.png"), bLoad(bAssets + "pt-birth-" + motif + "-motif.png"), foot, bFont()]).then(function (a) {
      var cv = document.createElement("canvas"); cv.width = BW; cv.height = BH;
      var c = cv.getContext("2d");
      c.scale(BS, BS);
      c.fillStyle = "#fff"; c.fillRect(0, 0, 2480, 3508);
      c.fillStyle = p.frame; c.fillRect(65, 65, 2350, 3378);
      c.fillStyle = "#fff"; c.fillRect(143, 143, 2194, 3222);
      function fitImg(im, x, y, w, h) { var s = Math.min(w / im.width, h / im.height); c.drawImage(im, x + (w - im.width * s) / 2, y + (h - im.height * s) / 2, im.width * s, im.height * s); }
      function line(y) { c.fillStyle = p.accent; for (var x = 315; x < 2180; x += 35) bDot(c, x, y, 20, 7, 3); }
      fitImg(a[0], 275, 165, 1930, 440); line(650); line(1045);
      fitImg(a[1], 285, 1085, 870, 855); line(1970); line(2190);
      [740, 1740].forEach(function (x) {
        c.fillStyle = p.accent; c.beginPath();
        for (var k2 = 0; k2 < 10; k2++) {
          var rad = k2 % 2 === 0 ? 55 : 24, px = x + Math.sin(k2 * Math.PI / 5) * rad, py = 2080 - Math.cos(k2 * Math.PI / 5) * rad;
          if (k2) c.lineTo(px, py); else c.moveTo(px, py);
        }
        c.closePath(); c.fill();
      });
      bText(c, p.accent, "wurde ein Baum in", 1240, 2360, 178, 1840);
      bText(c, p.accent, "Deutschland gepflanzt.", 1240, 2540, 178, 1840);
      if (a[2]) c.drawImage(a[2], 237, 2742, 2006, 560);
      bBgs[k] = cv;
      return cv;
    });
  }
  /* Schnell: die Urkunde wird direkt in ein Canvas ueber der Engine-Vorschau gezeichnet
     (kein JPEG-Umweg, keine Engine-Verzoegerung). Hintergruende je Motiv/Wald werden vorab geladen. */
  var bCv = null, bCurBg = null, bCurKey = "", bRaf = 0;
  function bCanvas() {
    if (!bCv) {
      bCv = document.createElement("canvas");
      bCv.width = BW; bCv.height = BH;
      bCv.className = "ptn-bcanvas";
      bCv.setAttribute("aria-hidden", "true");
    }
    if (L && L.stage && bCv.parentNode !== L.stage) L.stage.appendChild(bCv);
    return bCv;
  }
  function bDraw() {
    if (!bCurBg) return;
    var cv = bCanvas(), c = cv.getContext("2d");
    var d = bData(), p = B_PAL[d.motif], dt = bDate(d.date);
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.globalAlpha = 1;
    c.drawImage(bCurBg, 0, 0);
    c.scale(BS, BS);
    /* Leere Pflichtfelder als blasse Platzhalter, damit man sieht, wohin Name und Datum kommen */
    c.globalAlpha = d.name ? 1 : 0.22;
    bText(c, p.text, d.name || "Name des Kindes", 1240, 842, 300, 1850);
    c.globalAlpha = dt ? 1 : 0.22;
    bText(c, p.text, dt ? B_DAYS[dt.getDay()] : "Wochentag", 1710, 1160, 145, 880);
    bText(c, p.text, dt ? dt.getDate() + ". " + B_MONTHS[dt.getMonth()] : "Geburtsdatum", 1710, 1360, 204, 880);
    bText(c, p.text, dt ? String(dt.getFullYear()) : "Jahr", 1710, 1570, 218, 880);
    c.globalAlpha = 1;
    if (/^\d{2}:\d{2}$/.test(d.time)) bText(c, p.text, d.time + " Uhr", 1710, 1790, 146, 860);
    bText(c, p.text, d.weight ? d.weight + " g" : "", 455, 2080, 144, 430);
    bText(c, p.text, d.place, 1240, 2080, 144, 860);
    bText(c, p.text, d.height ? d.height + " cm" : "", 2025, 2080, 144, 430);
  }
  function bRender() {
    bRaf = 0;
    var d = bData(), forest = bForest(), key = d.motif + "|" + forest, token = ++bToken;
    if (bBgs[key]) { bCurBg = bBgs[key]; bCurKey = key; bDraw(); return Promise.resolve(); }
    return bBackground(d.motif, forest).then(function (bg) {
      if (token !== bToken) return;
      bCurBg = bg; bCurKey = key; bDraw();
      bPreload();
    })["catch"](function () {});
  }
  /* Alle sechs Hintergruende (2 Motive x 3 Waelder) still im Voraus bauen, damit Motiv- und Waldwechsel sofort sind */
  var bPreloaded = false;
  function bPreload() {
    if (bPreloaded) return;
    bPreloaded = true;
    var list = [], fs = ["by", "mv", "rp"], ms = ["reh", "fuchs"];
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < fs.length; j++) list.push([ms[i], fs[j]]);
    (function next() {
      var it = list.shift();
      if (!it) return;
      bBackground(it[0], it[1]).then(function () { setTimeout(next, 30); }, function () { setTimeout(next, 30); });
    })();
  }
  function bSchedule() {
    if (bRaf) return;
    bRaf = 1;
    (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(function () { bRender(); });
  }
  var bGender = {}, bNameT = 0, bNameReq = 0;
  function bInferSoon() { clearTimeout(bNameT); bNameT = setTimeout(bInfer, 650); }
  function bInfer() {
    var full = bTrim(B.name), first = full.split(/\s+/)[0] || "";
    if (!first || B.motifManual) return;
    var key = first.toLowerCase(), req = ++bNameReq;
    function apply(g) {
      if (req !== bNameReq || B.motifManual || bTrim(B.name) !== full) return;
      B.nameGender = g;
      if (g === "male" || g === "female") {
        var m = g === "male" ? "fuchs" : "reh";
        if (m !== B.motif) { B.motif = m; bChanged(); bMotifSync(); track("ptn_birth_motif_auto", { motif: m }); }
      }
    }
    if (bGender[key]) { apply(bGender[key]); return; }
    try {
      var x = new XMLHttpRequest();
      x.open("POST", "https://partner.planet-tree.de/api2/cert/infer_name_gender", true);
      x.timeout = 4000;
      x.setRequestHeader("Content-Type", "application/json");
      x.onload = function () {
        if (x.status < 200 || x.status >= 300) return;
        var r = {}, g = "unknown";
        try { r = JSON.parse(x.responseText) || {}; } catch (e) {}
        var it = r.items || [];
        for (var i = 0; i < it.length; i++) if (String(it[i].name || "").toLowerCase() === key) g = it[i].gender || "unknown";
        if (g !== "male" && g !== "female") g = "unknown";
        bGender[key] = g;
        apply(g);
      };
      x.send(JSON.stringify({ lang: "de", names: [first], context: "Vorname eines neugeborenen Kindes; bei uneindeutigen Namen unknown." }));
    } catch (e) {}
  }
  var bSaveT = 0;
  function bChanged() {
    bSchedule();
    clearTimeout(bSaveT);
    bSaveT = setTimeout(function () { bSave(); saveDraft(); }, 500);
    bEngine();
    if (typeof updateBar === "function" && L) updateBar();
    if (nav) refreshNavLock();
    liveSync();
  }
  /* Engine-Status wie im alten Gestalter: Name als Empfaenger, keine Herzen, Rahmenfarbe passend zum Motiv */
  function bEngine() {
    if (!L) return;
    try { L.text("recipient", bData().name); if (L.hearts) L.hearts(false); if (L.border) L.border(B_PAL[bData().motif].frame); } catch (e) {}
  }
  function bSet(key, v) {
    B[key] = v;
    if (key === "name") bInferSoon();
    bChanged();
  }
  function bMotifSync() {
    if (!bMotifBox) return;
    var bs = bMotifBox.querySelectorAll("[data-motif]");
    for (var i = 0; i < bs.length; i++) {
      var onm = bs[i].getAttribute("data-motif") === B.motif;
      bs[i].setAttribute("aria-pressed", String(onm));
      if (onm) addCls(bs[i], "is-on"); else rmCls(bs[i], "is-on");
    }
  }
  /* Grusskarte zur Geburt wie im alten Gestalter: Text nur mit Vornamen, Bild = Reh/Fuchs der Urkunde */
  function bGiven(v) {
    var parts = bTrim(v).split(/\s+/), out = [];
    if (!parts[0]) return "";
    if (parts.length < 3) return parts[0];
    for (var i = 0; i < parts.length - 1; i++) if (!/^(von|van|de|der|zu)$/i.test(parts[i])) out.push(parts[i]);
    return out.join(" ");
  }
  var bGreetAutoImg = false, bGreetSetting = false, bGreetMotifKey = "";
  function bGreetMotifPhoto(force) {
    var m = bData().motif;
    if (!L || (!force && bGreetMotifKey === m && bGreetAutoImg)) return;
    bGreetMotifKey = m;
    bLoad(bAssets + "pt-birth-" + m + "-motif.png").then(function (im) {
      if (bData().motif !== m) return;
      var sc = Math.min(1, 1000 / Math.max(im.width, im.height));
      var cv = document.createElement("canvas");
      cv.width = Math.round(im.width * sc); cv.height = Math.round(im.height * sc);
      cv.getContext("2d").drawImage(im, 0, 0, cv.width, cv.height);
      bGreetSetting = true;
      try { L.greetingPhoto(cv.toDataURL("image/png")); } catch (e) {}
      bGreetSetting = false;
      bGreetAutoImg = true;
      try { onGreetChange(); } catch (e) {}
    })["catch"](function () {});
  }
  window.PTNeuBirth = {
    greetFallback: function () {
      var g = bGiven(B.name);
      return "Willkommen auf der Welt" + (g ? ", " + g : "") + "!\n\nEin Baum wächst mit dir. Mögest du starke Wurzeln finden, neugierig wachsen und viele kleine Wunder entdecken. Alles Liebe für deinen Lebensweg!";
    },
    greetPrompt: function () {
      var g = bGiven(B.name);
      return "Sehr kurze Grußkarte zur Geburt: insgesamt maximal 40 Wörter und 270 Zeichen einschließlich Anrede. Anrede: Willkommen auf der Welt, " + g + "! Nur diese Vornamen verwenden, niemals Nachnamen. Danach höchstens zwei kurze Sätze: Baum wächst mit dem Kind, liebe Wünsche fürs Leben. Kein Absender bekannt: keine Signatur, Verwandtschaft oder Namen erfinden.";
    },
    on: function () { return BIRTH; },
    data: bData,
    key: function () { return String(bRev); },
    image: function () { return ""; },
    restore: function (b) {
      if (!BIRTH || !b || typeof b !== "object") return;
      for (var k in B) if (B.hasOwnProperty(k) && b[k] !== undefined && b[k] !== null) B[k] = b[k];
      B.motifManual = b.motifManual === true;
      bSave(); bSchedule();
      bEngine();
      try { liveSync(); } catch (e) {}
    }
  };

  var L = null;
  var ui = { photos: {}, share: 0.46, occasion: null, step: 0, sender: "", recipient: "", message: "", verb: "hat", verbManual: false, busy: false };
  var isGiftPage = !!host.getAttribute("data-host-variant-id");
  try { var sv = parseFloat(window.localStorage.getItem("ptn-share2")); if (sv >= 0.22 && sv <= 0.72) ui.share = sv; } catch (e) {}

  /* ---------- Seite: Startbereich ---------- */
  /* data-ptn-static="1": Einstieg ist statisch im Theme (Startseiten-Hero), hier nur Klicks binden */
  var staticHero = root.getAttribute("data-ptn-static") === "1";
  var heroEl = staticHero ? (root.closest ? root.closest(".ptnh") : null) || root : null;
  var start = el("div", "ptn-start");
  var loading = el("div", "ptn-loading", "Dein Zertifikat wird vorbereitet …");
  if (staticHero) loading.style.display = "none";
  else { clear(root); root.appendChild(start); root.appendChild(loading); }

  /* ---------- Popup ---------- */
  var modal = el("div", "ptn-modal");
  modal.style.display = "none";
  var dialog = el("div", "ptn-dialog");
  dialog.setAttribute("role", "dialog");
  dialog.setAttribute("aria-modal", "true");
  dialog.setAttribute("aria-label", "Baumgeschenk gestalten");
  var top = el("div", "ptn-top");
  var topTitle = el("p", "ptn-top-title", BIRTH ? "Deine Geburtsurkunde" : "Dein Baumgeschenk");
  if (BIRTH) { addCls(modal, "ptn-birth"); dialog.setAttribute("aria-label", "Geburtsurkunde gestalten"); }
  var closeBtn = el("button", "ptn-close", "×");
  closeBtn.type = "button"; closeBtn.setAttribute("aria-label", "Schließen");
  top.appendChild(topTitle); top.appendChild(closeBtn);
  var stageWrap = el("div", "ptn-stage");
  var paper = el("div", "ptn-paper");
  var zoomBtn = el("button", "ptn-zoom", "🔍");
  zoomBtn.type = "button"; zoomBtn.setAttribute("aria-label", "Zertifikat größer ansehen");
  var sceneBox = el("div", "ptn-scene");
  var sceneMounted = false;
  stageWrap.appendChild(sceneBox); stageWrap.appendChild(zoomBtn);
  /* ---------- Format-Vorschau: sauber auf gleichem Hintergrund, Mappe klappt auf, Rahmen, Graspapier ---------- */
  var FRAME_IMG = {
    nature: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/Rahmen_natur_certfit_transparent_clean_q60.webp?v=1766103058&width=900",
    black: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/Rahmen_schwarz_certfit_transparent_clean_q60.webp?v=1766103058&width=900",
    white: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/Rahmen_weiss_certfit_transparent_filled.webp?v=1766152727&width=900",
    silver: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/Rahmen_silber_certfit_transparent_clean_q60.webp?v=1766103059&width=900"
  };
  var INFO_IMG = {
    by: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/ARRR2BSD_S2_BY.jpg?v=1777991829&width=1000",
    rp: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/G4V9RA5Q_S2_RP.jpg?v=1777991828&width=1000",
    mv: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/UE2VAAFZ_S2_MV.jpg?v=1777991828&width=1000"
  };
  var FOLDER_DEFS = '<svg class="ptn-folder-defs" aria-hidden="true" focusable="false"><defs>' +
    '<linearGradient id="ptn-fold-cover" x1="0" y1="0" x2="1" y2="1"><stop stop-color="#19714f"/><stop offset=".45" stop-color="#085739"/><stop offset="1" stop-color="#06442e"/></linearGradient>' +
    '<linearGradient id="ptn-fold-inner" x1="0" y1="0" x2="1" y2=".8"><stop stop-color="#19664a"/><stop offset="1" stop-color="#0a4f36"/></linearGradient></defs></svg>';
  function flapSvg(w, d, fill, slot) {
    return '<svg viewBox="0 0 ' + w + ' 510" preserveAspectRatio="none" focusable="false"><path d="' + d + '" fill="url(#' + fill + ')"/>' + (slot ? '<path class="ptn-fold-slot" d="M45 205V305"/>' : "") + "</svg>";
  }
  var FOLDER_FRONT_HTML =
    '<span class="ptn-flap ptn-flap--side ptn-flap--top"><span class="ptn-face ptn-board"></span><span class="ptn-face ptn-rev ptn-board"></span></span>' +
    '<span class="ptn-flap ptn-flap--side ptn-flap--bottom"><span class="ptn-face ptn-board"></span><span class="ptn-face ptn-rev ptn-board"></span></span>' +
    '<span class="ptn-flap ptn-flap--front"><span class="ptn-face">' + flapSvg(240, "M240 0H22L0 510H240Z", "ptn-fold-inner", true) + '</span><span class="ptn-face ptn-rev">' + flapSvg(240, "M240 0H22L0 510H240Z", "ptn-fold-inner", true) + "</span></span>" +
    '<span class="ptn-flap ptn-flap--cover"><span class="ptn-face">' + flapSvg(336, "M0 0H250L294 205C318 205 334 226 334 255S318 305 294 305L250 510H0Z", "ptn-fold-cover") + '</span><span class="ptn-face ptn-rev">' + flapSvg(336, "M0 0H250L294 205C318 205 334 226 334 255S318 305 294 305L250 510H0Z", "ptn-fold-inner") + "</span></span>";

  var obj = el("div", "ptn-obj");
  obj.setAttribute("data-look", "none");
  var folderBack = el("div", "ptn-folder ptn-folder--back");
  folderBack.innerHTML = FOLDER_DEFS + '<span class="ptn-folder-base ptn-board"></span>';
  var folderFront = el("div", "ptn-folder ptn-folder--front");
  folderFront.innerHTML = FOLDER_FRONT_HTML;
  var frameImg = el("img", "ptn-frameimg"); frameImg.alt = ""; frameImg.setAttribute("aria-hidden", "true");
  var infoImg = el("img", "ptn-infoimg"); infoImg.alt = "Muster-Infoblatt zum gewählten Pflanzort";
  var grassEl = el("span", "ptn-grass"); grassEl.setAttribute("aria-hidden", "true");
  var cardImg = el("div", "ptn-cardimg");
  var cardPic = el("img"); cardPic.alt = "Deine Gru\u00dfkarte";
  cardImg.appendChild(cardPic); cardImg.appendChild(el("span", "ptn-cardgrass"));
  var infoBtn = el("button", "ptn-stagebtn ptn-stagebtn--info", "↻ Infoblatt"); infoBtn.type = "button";
  var foldBtn = el("button", "ptn-stagebtn ptn-stagebtn--fold", "↻ Mappe öffnen"); foldBtn.type = "button";
  var lookKey = "", foldTimers = [];
  function setFold(phase) { obj.setAttribute("data-fold", phase); }
  function clearFold() { for (var i = 0; i < foldTimers.length; i++) clearTimeout(foldTimers[i]); foldTimers = []; }
  function reducedMotion() { try { return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) { return false; } }
  function playFolder() {
    clearFold();
    if (reducedMotion()) { setFold("focused"); return; }
    addCls(obj, "is-instant"); setFold("closed");
    void obj.offsetWidth;
    rmCls(obj, "is-instant");
    foldTimers.push(setTimeout(function () { setFold("cover"); }, 250));
    foldTimers.push(setTimeout(function () { setFold("front"); }, 1050));
    foldTimers.push(setTimeout(function () { setFold("open"); }, 1750));
    foldTimers.push(setTimeout(function () { setFold("focused"); }, 3000));
  }
  var certSig = null;
  /* Lade-Hinweis aus layout/theme.liquid (html.ptn-restoring) beim Oeffnen bzw. bei Fehlern entfernen */
  function restoringOff() { var d = document.documentElement; if (/\bptn-restoring\b/.test(d.className)) d.className = d.className.replace(/\s*\bptn-restoring\b/g, ""); }
  function applyLook() {
    if (!L) return;
    var st = L.state();
    var typing = (" " + modal.className + " ").indexOf(" is-typing ") >= 0;
    var fmt = (STEPS[ui.step].key === "format" || STEPS[ui.step].key === "quick") && !typing; /* Schnellweg-Uebersicht zeigt das fertige Geschenk (Grusskarte, Geschenk, Format) */
    var look = !fmt ? "none" : (st.gift ? "digital" : (st.delivery || "digital"));
    obj.setAttribute("data-look", look);
    if (fmt) addCls(modal, "is-format"); else rmCls(modal, "is-format");
    if (fmt && st.paper === "grass") addCls(obj, "is-grass"); else rmCls(obj, "is-grass");
    if (fmt && st.greeting && greetSrc) addCls(stageWrap, "has-card"); else rmCls(stageWrap, "has-card");
    if (st.paper === "grass") addCls(stageWrap, "card-grass"); else rmCls(stageWrap, "card-grass");
    var hasGift = fmt && !!st.gift && giftRender();
    if (hasGift) addCls(stageWrap, "has-gift"); else rmCls(stageWrap, "has-gift");
    if ((ui.front === "card" && !(fmt && st.greeting && greetSrc)) || (ui.front === "gift" && !hasGift) || (ui.front === "certtop" && !hasGift && !(fmt && st.greeting && greetSrc)) || !fmt) ui.front = "cert";
    /* Claude 28.10.2026 (Leslie): Format, Papier oder Rahmen geaendert -> Zertifikat nach vorn (sonst sieht man die Aenderung nicht) */
    if (fmt) { var cSig = (st.gift ? "g" : (st.delivery || "digital")) + "|" + (st.paper || "white") + "|" + (st.frame || ""); if (certSig !== null && cSig !== certSig) ui.front = "cert"; certSig = cSig; }
    stageWrap.setAttribute("data-front", ui.front || "cert");
    if (look === "framed") { var fs = FRAME_IMG[st.frame] || FRAME_IMG.nature; if (frameImg.getAttribute("src") !== fs) frameImg.src = fs; }
    var showInfo = fmt && ui.info;
    if (showInfo) { var is = INFO_IMG[st.forest] || INFO_IMG.by; if (infoImg.getAttribute("src") !== is) infoImg.src = is; addCls(obj, "is-info"); }
    else rmCls(obj, "is-info");
    infoBtn.textContent = showInfo ? (BIRTH ? "↻ Urkunde" : "↻ Zertifikat") : "↻ Infoblatt";
    infoBtn.setAttribute("aria-pressed", String(!!showInfo));
    if (look !== lookKey) {
      var prev = lookKey; lookKey = look;
      if (look === "print") playFolder(); else { clearFold(); setFold("focused"); }
    }
    carPaint();
  }
  on(infoBtn, "click", function () { ui.info = !ui.info; applyLook(); track("ptn_info_flip", { on: ui.info }); });
  on(foldBtn, "click", function () { playFolder(); track("ptn_fold_replay", {}); });

  paper.appendChild(infoImg); paper.appendChild(grassEl);
  obj.appendChild(folderBack); obj.appendChild(paper); obj.appendChild(frameImg); obj.appendChild(folderFront);
  var objWrap = el("div", "ptn-objwrap"); objWrap.appendChild(obj);
  stageWrap.insertBefore(objWrap, stageWrap.firstChild);
  var giftBox = el("div", "ptn-giftart");
  var giftPh = el("img", "ptn-giftart-ph"); giftPh.alt = "";
  var giftImg = el("img", "ptn-giftart-img"); giftImg.alt = "Dein Geschenk";
  giftBox.appendChild(giftPh); giftBox.appendChild(giftImg);
  giftBox.setAttribute("role", "button"); giftBox.setAttribute("aria-label", "Geschenk hervorheben");
  cardImg.setAttribute("role", "button");
  var stageShade = el("div", "ptn-stageshade");
  stageWrap.appendChild(infoBtn); stageWrap.appendChild(foldBtn); stageWrap.appendChild(stageShade); stageWrap.appendChild(giftBox); stageWrap.appendChild(cardImg);
  /* ---------- Karussell (Claude 28.10.2026): Zertifikat, Geschenk, Grusskarte - vorne gross, die anderen daneben ---------- */
  var carDots = el("div", "ptn-cardots"); carDots.setAttribute("aria-hidden", "true");
  var carPrev = el("button", "ptn-carbtn ptn-carbtn--prev", "\u2039"); carPrev.type = "button"; carPrev.setAttribute("aria-label", "Vorheriges");
  var carNext = el("button", "ptn-carbtn ptn-carbtn--next", "\u203a"); carNext.type = "button"; carNext.setAttribute("aria-label", "N\u00e4chstes");
  stageWrap.appendChild(carDots); stageWrap.appendChild(carPrev); stageWrap.appendChild(carNext);
  /* Baum-Botschaft-Handy: immer dabei (Leslie 28.10.), vorne antippen = echte Ueberraschung abspielen */
  var BBC = !BIRTH && !STAFF_ON && !ISSUE;
  var bbPhone = el("div", "ptn-bbphone"); bbPhone.setAttribute("role", "button"); bbPhone.setAttribute("tabindex", "0");
  bbPhone.setAttribute("aria-label", "Baum-Botschaft f\u00fcrs Handy ansehen \u2013 immer inklusive");
  var bbScr = el("span", "ptn-bbphone-scr"), bbT = el("span", "ptn-bbphone-t"), bbV = el("span", "ptn-bbphone-v");
  bbScr.appendChild(bbT); bbScr.appendChild(bbV); bbScr.appendChild(el("span", "ptn-bbphone-play"));
  bbPhone.appendChild(bbScr); bbPhone.appendChild(el("span", "ptn-bbphone-cap", "Immer inklusive \u00b7 Baum-Botschaft"));
  if (BBC) stageWrap.appendChild(bbPhone);
  var CAR_EL = { cert: objWrap, gift: giftBox, card: cardImg, bb: bbPhone };
  function carItems() {
    var c = " " + stageWrap.className + " ", a = ["cert"];
    if (c.indexOf(" has-gift ") >= 0) a.push("gift");
    if (c.indexOf(" has-card ") >= 0) a.push("card");
    if (BBC) a.push("bb");
    return a;
  }
  function bbPaint() {
    if (!BBC) return;
    if (!bbScr.style.backgroundImage && typeof BBX_BASE === "string") bbScr.style.backgroundImage = "url(" + BBX_BASE + "pt-bb-cart-thumb.jpg)";
    var f = String(ui.recipient || "").replace(/\s+/g, " ").replace(/^\s+|\s+$/g, ""), v = String(ui.sender || "").replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "");
    bbT.textContent = f ? "Psst, " + (f.length > 16 ? f.slice(0, 15) + "\u2026" : f) + "!" : "Psst!";
    bbV.textContent = v ? (v.length > 22 ? v.slice(0, 21) + "\u2026" : v) + (/(\bund\b|&|\bfamilie\b)/i.test(v) || ui.verb === "haben" ? " haben" : " hat") + " was f\u00fcr dich!" : "Hier ist was f\u00fcr dich!";
    var w = parseFloat(bbPhone.style.width) || 150;
    bbT.style.fontSize = Math.max(9, Math.round(w * 0.105)) + "px"; bbV.style.fontSize = Math.max(8, Math.round(w * 0.09)) + "px";
  }
  /* Claude 28.10.2026 (Leslie: "nicht harmonisch"): alle Teile auf derselben Mittelachse wie das Zertifikat, vorne gross, an den Seiten gleich hoch */
  var GEO = ["left", "top", "right", "bottom", "width", "height", "margin", "transform", "-webkit-transform", "z-index", "transform-origin", "-webkit-transform-origin"];
  function imp(n, k, v) { n.style.setProperty(k, v, "important"); }
  function carGeoClear() { for (var k in CAR_EL) if (CAR_EL.hasOwnProperty(k)) for (var j = 0; j < GEO.length; j++) CAR_EL[k].style.removeProperty(GEO[j]); }
  function carGeo() {
    var W2 = stageWrap.clientWidth, cw = objWrap.offsetWidth, ch = objWrap.offsetHeight;
    if (!W2 || !ch) return;
    var cx = objWrap.offsetLeft + cw / 2, cy = objWrap.offsetTop + ch / 2;
    /* breite Buehne (Desktop): vorderes Teil etwas kleiner, damit die Seiten sichtbar bleiben */
    var zm = (" " + modal.className + " ").indexOf(" is-zoom ") >= 0;
    var fs = Math.min(1, W2 * (W2 < 600 ? (zm ? 0.9 : 0.68) : zm ? 0.78 : 0.62) / cw), cw0 = cw; ch = ch * fs; cw = cw * fs;
    var dx = Math.round(W2 * (W2 < 600 ? (zm ? 0.46 : 0.41) : 0.37)), sideH = ch * (zm ? 0.5 : 0.58);
    var cd = (function () { var h = ch * 0.9, w = h * 0.707; if (w > W2 * 0.72) { w = W2 * 0.72; h = w / 0.707; } return [w, h]; })();
    var dims = { cert: [cw0, ch / fs], card: cd, bb: [ch * 0.47, ch * 0.94], gift: [Math.min(W2 * 0.8, ch * 1.05), ch * 0.98] };
    for (var k in CAR_EL) {
      if (!CAR_EL.hasOwnProperty(k)) continue;
      var n = CAR_EL[k], pos = n.getAttribute("data-car"), d = dims[k];
      if (!pos || !d) continue;
      if (k !== "cert") {
        imp(n, "width", Math.round(d[0]) + "px"); imp(n, "height", Math.round(d[1]) + "px");
        imp(n, "left", Math.round(cx - d[0] / 2) + "px"); imp(n, "top", Math.round(cy - d[1] / 2) + "px");
        imp(n, "right", "auto"); imp(n, "bottom", "auto"); imp(n, "margin", "0");
      }
      var s = (k === "gift" ? sideH * 1.12 : sideH) / d[1];
      var t = pos === "front" ? (k === "cert" && fs < 0.999 ? "scale(" + fs.toFixed(3) + ")" : "none") : pos === "back" ? "translateX(" + Math.round(dx * 1.1) + "px) translateY(" + Math.round(-sideH * 0.24) + "px) scale(" + (s * 0.9).toFixed(3) + ")" : "translateX(" + (pos === "right" ? dx : -dx) + "px) scale(" + s.toFixed(3) + ")";
      imp(n, "transform-origin", "50% 50%"); imp(n, "-webkit-transform-origin", "50% 50%");
      imp(n, "transform", t); imp(n, "-webkit-transform", t);
      imp(n, "z-index", pos === "front" ? "6" : pos === "back" ? "2" : "3");
    }
  }
  on(bbPhone, "click", function (e) { e.stopPropagation(); if (!carOn()) return; if (ui.front !== "bb") { setFront("bb"); return; } track("ptn_bbx_open", { src: "carousel" }); bbxShow(); });
  on(bbPhone, "keydown", function (e) { if (e.keyCode === 13 || e.keyCode === 32) { e.preventDefault(); bbPhone.click(); } });
  function carOn() { return (" " + modal.className + " ").indexOf(" is-format ") >= 0 && (" " + modal.className + " ").indexOf(" is-typing ") < 0 && carItems().length > 1; }
  function carPaint() {
    var items = carItems(), k;
    if (!carOn()) {
      rmCls(stageWrap, "is-car");
      for (k in CAR_EL) if (CAR_EL.hasOwnProperty(k)) CAR_EL[k].removeAttribute("data-car");
      carGeoClear();
      return;
    }
    addCls(stageWrap, "is-car");
    var f = items.indexOf(ui.front === "certtop" ? "cert" : ui.front); if (f < 0) f = 0;
    ui.front = items[f]; stageWrap.setAttribute("data-front", ui.front);
    var n = items.length;
    for (k in CAR_EL) if (CAR_EL.hasOwnProperty(k)) CAR_EL[k].removeAttribute("data-car");
    for (var i = 0; i < n; i++) {
      var rel = (i - f + n) % n;
      CAR_EL[items[i]].setAttribute("data-car", rel === 0 ? "front" : rel === 1 ? "right" : rel === n - 1 ? "left" : "back");
    }
    carGeo(); bbPaint(); setTimeout(function () { carGeo(); bbPaint(); }, 400);
    clear(carDots);
    for (var d = 0; d < n; d++) carDots.appendChild(el("span", d === f ? "is-on" : ""));
  }
  function carGo(dir) {
    var items = carItems(); if (items.length < 2) return;
    var f = items.indexOf(ui.front === "certtop" ? "cert" : ui.front); if (f < 0) f = 0;
    setFront(items[(f + dir + items.length) % items.length]);
  }
  on(carPrev, "click", function (e) { e.stopPropagation(); carGo(-1); });
  on(carNext, "click", function (e) { e.stopPropagation(); carGo(1); });
  var carX = null, carY = 0;
  stageWrap.addEventListener("touchstart", function (e) { if (!carOn() || !e.touches || e.touches.length !== 1) { carX = null; return; } carX = e.touches[0].clientX; carY = e.touches[0].clientY; }, false);
  stageWrap.addEventListener("touchmove", function (e) { if (carX === null || !e.touches || !e.touches.length) return; var mx = Math.abs(e.touches[0].clientX - carX), my = Math.abs(e.touches[0].clientY - carY); if (mx > 8 && mx > my && e.cancelable) e.preventDefault(); }, (function () { var p = false; try { window.addEventListener("ptntest", null, Object.defineProperty({}, "passive", { get: function () { p = true; } })); } catch (e) {} return p ? { passive: false } : false; })());
  stageWrap.addEventListener("touchend", function (e) {
    if (carX === null || !e.changedTouches || !e.changedTouches.length) return;
    var dx = e.changedTouches[0].clientX - carX, dy = e.changedTouches[0].clientY - carY; carX = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) { carGo(dx < 0 ? 1 : -1); track("ptn_car_swipe", {}); }
  }, false);
  ui.front = "cert";
  var giftKey = "";
  /* Geschenk wie im Original darstellen (freigestelltes Motiv mit Etikett), sonst Produktfoto */
  function giftRender() {
    var ex = null; try { ex = L.exportState(); } catch (e) {}
    if (!ex || !ex.gift) return false;
    var v = null, vs = ex.gift.variants || [];
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(ex.variant)) v = vs[i];
    var key = JSON.stringify([ex.gift.handle, ex.variant, ex.sender, ex.recipient, ex.forest]);
    if (key === giftKey) return true;
    giftKey = key;
    var art = false;
    try {
      if (window.PTGuidedGiftMedia && window.PTGuidedGiftMedia.render) {
        window.PTGuidedGiftMedia.render(giftPh, ex.gift, v, ex);
        var svg = giftBox.querySelector(".ptgl-gift-art");
        art = !!(svg && !svg.hasAttribute("hidden"));
      }
    } catch (e) { art = false; }
    var src = (v && v.image) || ex.gift.image || "";
    if (art) { giftImg.style.display = "none"; }
    else if (src) { giftImg.style.display = ""; if (giftImg.getAttribute("src") !== src) giftImg.src = src; }
    else return false;
    return true;
  }
  function setFront(f) {
    ui.front = f;
    stageWrap.setAttribute("data-front", f);
    track("ptn_front", { obj: f });
    carPaint();
  }
  on(cardImg, "click", function (e) { e.stopPropagation(); if (carOn()) { if (ui.front !== "card") setFront("card"); return; } setFront(ui.front === "card" ? "cert" : "card"); });
  on(giftBox, "click", function (e) { e.stopPropagation(); if (carOn()) { if (ui.front !== "gift") setFront("gift"); return; } setFront(ui.front === "gift" ? "cert" : "gift"); });
  on(stageShade, "click", function (e) { e.stopPropagation(); setFront("cert"); });
  /* Zertifikat nach vorn holen, wenn Geschenk/Grusskarte davor liegen (nur Format-Schritt) */
  on(obj, "click", function (e) {
    if (carOn()) { if (ui.front !== "cert") { e.stopPropagation(); setFront("cert"); } return; }
    if ((" " + modal.className + " ").indexOf(" is-format ") < 0) return;
    var c = " " + stageWrap.className + " ";
    if (c.indexOf(" has-gift ") < 0 && c.indexOf(" has-card ") < 0) return;
    e.stopPropagation();
    setFront(ui.front === "certtop" ? "cert" : "certtop");
  });
  setFold("focused");
  var mainCol = el("div", "ptn-main");
  var nav = el("ol", "ptn-nav");
  var body = el("div", "ptn-body");
  var navCap = el("p", "ptn-nav-cap");
  navCap.setAttribute("aria-hidden", "true");
  mainCol.appendChild(nav); mainCol.appendChild(navCap); mainCol.appendChild(body);
  var bar = el("div", "ptn-bar");
  var barBack = el("button", "ptn-back", "←");
  barBack.type = "button"; barBack.setAttribute("aria-label", "Zurück");
  var barPrice = el("div", "ptn-bar-price");
  var barNext = el("button", "ptn-next", "Weiter");
  barNext.type = "button";
  bar.appendChild(barBack); bar.appendChild(barPrice); bar.appendChild(barNext);
  var flashEl = el("p", "ptn-flash"); flashEl.setAttribute("role", "alert"); flashEl.style.display = "none";
  var side = el("div", "ptn-side");
  var grab = el("div", "ptn-grab");
  grab.setAttribute("aria-hidden", "true");
  grab.appendChild(el("span", ""));
  side.appendChild(grab); side.appendChild(mainCol); side.appendChild(bar);
  dialog.appendChild(top); dialog.appendChild(stageWrap); dialog.appendChild(side); dialog.appendChild(flashEl);
  modal.appendChild(dialog);
  document.body.appendChild(modal);

  /* ---------- Griff: Groesse von Zertifikat und Formular per Finger ---------- */
  var drag = null;
  function dragStart(y) { if (window.innerWidth >= 900) return; drag = { y: y, share: ui.share, h: (vv ? vv.height : window.innerHeight) - 48 }; addCls(modal, "is-dragging"); }
  function dragMove(y) {
    if (!drag) return;
    ui.share = Math.max(0.22, Math.min(0.72, drag.share + (y - drag.y) / drag.h));
    fit();
  }
  function dragEnd() {
    if (!drag) return;
    drag = null; rmCls(modal, "is-dragging");
    try { window.localStorage.setItem("ptn-share2", String(Math.round(ui.share * 100) / 100)); } catch (e) {}
    track("ptn_resize", { share: Math.round(ui.share * 100) });
  }
  grab.addEventListener("touchstart", function (e) { if (e.touches.length === 1) dragStart(e.touches[0].clientY); }, { passive: true });
  grab.addEventListener("touchmove", function (e) { if (drag && e.touches.length === 1) { e.preventDefault(); dragMove(e.touches[0].clientY); } }, { passive: false });
  grab.addEventListener("touchend", dragEnd, false);
  grab.addEventListener("touchcancel", dragEnd, false);
  on(grab, "mousedown", function (e) { dragStart(e.clientY); e.preventDefault(); });
  on(document, "mousemove", function (e) { if (drag) dragMove(e.clientY); });
  on(document, "mouseup", dragEnd);

  /* ---------- Startbildschirm ---------- */
  function renderStart() {
    if (staticHero) { updateHero(); return; }
    clear(start);
    var gt = host.getAttribute("data-host-title");
    start.appendChild(el("p", "ptn-kicker", isGiftPage ? ((gt ? gt + " · " : "") + "mit Baumpflanzung") : "Baumgeschenke ab 15 €"));
    start.appendChild(el("h1", "ptn-h1", "Zu welchem Anlass möchtest du einen Baum schenken?"));
    start.appendChild(el("p", "ptn-sub", "Wir pflanzen deinen Baum mit offiziellen Forstpartnern in Deutschland. Dazu gibt es ein persönliches Zertifikat – sofort als PDF oder gedruckt."));
    var grid = el("div", "ptn-occasions");
    OCCASIONS.forEach(function (o) {
      var b = el("button", "ptn-occasion");
      b.type = "button";
      b.appendChild(el("span", "ptn-occasion-icon", o.icon));
      b.appendChild(el("span", "ptn-occasion-label", o.label));
      on(b, "click", function () { chooseOccasion(o); });
      grid.appendChild(b);
    });
    start.appendChild(grid);
    var trust = el("ul", "ptn-trust");
    ["Echter Baum in Deutschland", "Zertifikat mit QR-Code & Pflanzort", "PDF sofort · Druck in 1–3 Tagen"].forEach(function (t) { trust.appendChild(el("li", "", t)); });
    start.appendChild(trust);
  }
  var pendingOccasion = null, pendingOpen = null, pendingLang = "";
  function heroBusy(btn) {
    if (!heroEl) return;
    addCls(heroEl, "is-loading");
    if (btn) addCls(btn, "is-loading");
  }
  function heroIdle() {
    if (!heroEl) return;
    rmCls(heroEl, "is-loading");
    var b = heroEl.querySelectorAll(".is-loading");
    for (var i = 0; i < b.length; i++) rmCls(b[i], "is-loading");
  }
  /* ---------- Live-Hero: Namen und Anlass direkt auf der Seite, Zertifikat zeigt es sofort ---------- */
  var liveBox = heroEl ? heroEl.querySelector("[data-ptn-live]") : null;
  var liveFields = heroEl ? heroEl.querySelectorAll("[data-ptn-livefield]") : [];
  /* Claude 03.11.2026 (Leslie): Startbild zeigt in der Saison nur das Weihnachts-Muster; ohne Namen bleibt es bei Weihnachten stehen */
  var xMuster = !!(liveBox && liveBox.hasAttribute && liveBox.hasAttribute("data-ptn-xmuster"));
  function isXmasOcc(o) { return !!(o && o.key === "weihnachten"); }
  /* Claude 03.11.2026 (Leslie): Startseite nur Textzeile + Auswahlliste, keine weiteren Knoepfe */
  var heroLangSel = heroEl ? heroEl.querySelector("[data-ptn-langsel]") : null, heroLangLbl = heroEl ? heroEl.querySelector("[data-ptn-langlabel]") : null;
  if (heroLangSel) on(heroLangSel, "change", function () { var lgv = heroLangSel.value; if (L) setLang(lgv); else { pendingLang = lgv; liveSync(); } });
  /* Claude 28.10.2026 (Leslie): Namen sind Pflicht, bevor "Zertifikat ansehen" oeffnet; Textlink "Profimodus" = alle Schritte wie vor dem Schnellweg */
  function liveField(k) { for (var i = 0; i < liveFields.length; i++) if (liveFields[i].getAttribute("data-ptn-livefield") === k) return liveFields[i]; return null; }
  var nameHint = null;
  function namesMissing() {
    if (!QUICK || BIRTH || !liveFields.length) return null;
    var miss = [], ks = ["sender", "recipient"];
    for (var i = 0; i < ks.length; i++) {
      var f = liveField(ks[i]); if (!f) continue;
      var v = String(ui[ks[i]] || f.value || "").replace(/\s/g, "");
      if (!v && !(ui.photos && ui.photos[ks[i]])) miss.push(f);
    }
    return miss.length ? miss : null;
  }
  function clearNameHint() {
    if (nameHint && nameHint.parentNode) nameHint.parentNode.removeChild(nameHint);
    nameHint = null;
    for (var i = 0; i < liveFields.length; i++) if (liveFields[i].parentNode) rmCls(liveFields[i].parentNode, "ptn-miss");
  }
  function showNameHint(miss, src) {
    clearNameHint();
    var both = miss.length > 1, k0 = miss[0].getAttribute("data-ptn-livefield");
    for (var i = 0; i < miss.length; i++) if (miss[i].parentNode) addCls(miss[i].parentNode, "ptn-miss");
    nameHint = el("p", "ptn-namehint", both ? "Bitte zuerst eintragen, von wem und f\u00fcr wen der Baum ist." : (k0 === "sender" ? "Bitte noch eintragen, von wem der Baum ist." : "Bitte noch eintragen, f\u00fcr wen der Baum ist."));
    nameHint.setAttribute("role", "alert");
    var row = miss[0].parentNode && miss[0].parentNode.parentNode;
    if (row && row.parentNode) row.parentNode.insertBefore(nameHint, row.nextSibling);
    var f0 = miss[0];
    try { f0.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (e) { try { f0.scrollIntoView(); } catch (e2) {} }
    try { f0.focus({ preventScroll: true }); } catch (e3) { try { f0.focus(); } catch (e4) {} }
    track("ptn_names_required", { source: src || "", missing: both ? "both" : k0 });
  }
  for (var nf = 0; nf < liveFields.length; nf++) on(liveFields[nf], "input", function () { if (nameHint && !namesMissing()) clearNameHint(); else if (this.value.replace(/\s/g, "") && this.parentNode) rmCls(this.parentNode, "ptn-miss"); });
  window.__ptnQuick = QUICK;
  function setPro() {
    window.__ptnPro = true;
    if (!QUICK) return;
    window.__ptnQuick = false;
    var qi = stepIx("quick"), hasQ = STEPS[qi] && STEPS[qi].key === "quick";
    QUICK = false; ui.qEdit = false; ui.qPart = null; ui.qLong = false;
    if (hasQ) { STEPS.splice(qi, 1); if (ui.step > qi) ui.step--; }
  }
  (function () {
    if (!QUICK || BIRTH || !heroEl) return;
    var c = heroEl.querySelector('[data-ptn-open="hero-cta"],[data-ptnb-cta]');
    if (!c || !c.parentNode) return;
    var pl = el("button", "ptn-prolink", "Profimodus"); pl.type = "button";
    pl.setAttribute("title", "Alle Gestaltungsschritte nacheinander");
    if (c.hasAttribute("data-ptnb-cta") && heroEl.getAttribute("data-ptnb-default") === "plain") pl.hidden = true;
    c.parentNode.insertBefore(pl, c.nextSibling);
    on(pl, "click", function (e) {
      if (e && e.preventDefault) e.preventDefault();
      clearNameHint(); track("ptn_pro", {}); setPro();
      try { updateHero(); } catch (er) {}
      openStart("pro");
    });
  })();
  function liveShow() {
    if (!liveBox || !L || !L.stage) return;
    if (L.stage.parentNode !== liveBox && !opened) liveBox.appendChild(L.stage);
    var lvOther = (ui.lang || "de") !== "de";
    if (ui.sender || ui.recipient || lvOther || (ui.occasion && !(xMuster && isXmasOcc(ui.occasion))) || (BIRTH && (B.name || B.date))) addCls(liveBox, "is-live");
    else rmCls(liveBox, "is-live");
  }
  function liveSync() {
    for (var i = 0; i < liveFields.length; i++) {
      var f = liveFields[i].getAttribute("data-ptn-livefield");
      var fv = BIRTH ? (f === "bdate" ? (liveFields[i].type === "date" ? (bDateOk(B.date) ? B.date : "") : bDateText(B.date)) : B.name) : (ui[f] || "");
      if (document.activeElement !== liveFields[i] && liveFields[i].value !== fv) liveFields[i].value = fv;
    }
    if (heroEl) {
      var chips = heroEl.querySelectorAll("[data-ptn-occasion]");
      for (var c = 0; c < chips.length; c++) chips[c].setAttribute("aria-pressed", ui.occasion && ui.occasion.key === chips[c].getAttribute("data-ptn-occasion") ? "true" : "false");
      if (heroLangSel) {
        var lgNow = pendingLang || ui.lang || "de", lgN = langName(lgNow);
        if (heroLangSel.value !== lgNow) heroLangSel.value = lgNow;
        if (heroLangLbl) heroLangLbl.textContent = lgN[2] + " Zertifikat auf " + lgN[1] + (lgNow === "de" ? " · 3 weitere Sprachen" : "");
      }
    }
    liveShow();
  }
  for (var lf = 0; lf < liveFields.length; lf++) (function (inp) {
    var key = inp.getAttribute("data-ptn-livefield");
    var tracked = false;
    on(inp, "input", function () {
      if (BIRTH) {
        if (key === "bdate") bSet("date", bParseDate(inp.value)); else bSet("name", inp.value.replace(/[\r\n]+/g, " "));
        if (!tracked) { tracked = true; track("ptn_hero_type", { field: key }); }
        liveShow();
        return;
      }
      ui[key] = inp.value;
      if (L) { L.text(key, inp.value); if (key === "sender") autoVerb(); }
      if (!tracked) { tracked = true; track("ptn_hero_type", { field: key }); }
      liveShow(); saveDraft();
    });
    on(inp, "keydown", function (e) { if (e.keyCode === 13) { e.preventDefault(); var nx = key === "bname" ? heroEl.querySelector('[data-ptn-livefield="bdate"]') : key === "sender" ? heroEl.querySelector('[data-ptn-livefield="recipient"]') : null; if (nx && !nx.value) nx.focus(); else { inp.blur(); openStart("hero-enter"); } } });
  })(liveFields[lf]);
  /* Claude 29.10.2026: Weiterschenken aus der Baum-Botschaft - ?ptv=<Von>&ptf=<Fuer> fuellt das Startbild und oeffnet den Gestalter */
  (function () {
    var s = location.search || "", mv = /[?&]ptv=([^&#]*)/.exec(s), mf = /[?&]ptf=([^&#]*)/.exec(s);
    if ((!mv && !mf) || BIRTH || !liveFields.length) return;
    var dec = function (m) { try { return m ? decodeURIComponent(m[1].replace(/\+/g, " ")).replace(/[<>\u0000-\u001f]/g, "").slice(0, 40) : ""; } catch (e) { return ""; } };
    var vals = { sender: dec(mv), recipient: dec(mf) };
    for (var k in vals) if (vals.hasOwnProperty(k) && vals[k]) { var f = liveField(k); if (!f) continue; f.value = vals[k]; ui[k] = vals[k]; if (L) { L.text(k, vals[k]); if (k === "sender") autoVerb(); } }
    try { history.replaceState(history.state, "", location.pathname + (s.replace(/[?&](ptv|ptf)=[^&#]*/g, "").replace(/^&/, "?") || "") + location.hash); } catch (e) {}
    track("ptn_weiter_prefill", { both: vals.sender && vals.recipient ? 1 : 0 });
    setTimeout(function () { try { liveShow(); saveDraft(); if (vals.sender && vals.recipient) openStart("weiter"); else { var miss = liveField(vals.sender ? "recipient" : "sender"); if (miss) { miss.scrollIntoView({ block: "center" }); miss.focus(); } } } catch (e) {} }, 60);
  })();
  /* Anlass im Live-Hero: Widmung sofort auf dem Zertifikat, Popup erst ueber den Knopf */
  /* Weihnachtsdesign nur beim Anlass Weihnachten; Eigene Aenderungen der Kundin bleiben, beim Wechsel des Anlasses geht nur zurueck, was noch wie automatisch gesetzt ist. */
  var XMAS_DESIGN = { motif: "oak-tree", deco: "fir-corners", border: "#8e1f27", claim: "zu Weihnachten für" };
  function xmasDesign() {
    if (!L || BIRTH || !L.deco) return;
    var isX = !!(ui.occasion && ui.occasion.key === "weihnachten");
    if (isX === !!ui.xmasOn) return;
    ui.xmasOn = isX;
    var st = L.state(), c = claimNow(), de = claimLang() === "de";
    try {
      if (isX) {
        if (!st.deco) L.deco(XMAS_DESIGN.deco);
        if (String(st.border || "").toLowerCase() === "#337451") L.border(XMAS_DESIGN.border);
        if (st.hearts !== false) L.hearts(false);
        if (de && c.key === "standard") L.claim("custom", XMAS_DESIGN.claim, c.art || "");
      } else {
        if (/^xmas-/.test(st.motif || "")) L.motif("oak-tree");
        if (st.deco === XMAS_DESIGN.deco) L.deco("");
        if (String(st.border || "").toLowerCase() === XMAS_DESIGN.border) L.border("#337451");
        if (st.hearts === false) L.hearts(true);
        if (c.key === "custom" && c.custom === XMAS_DESIGN.claim) L.claim("standard", "", c.art || "");
      }
    } catch (e) {}
  }
  function applyOccasionLive(o) {
    var changed = ui.occasion !== o;
    ui.occasion = o;
    xmasDesign();
    if (changed || !ui.message) { if (!ui.message || isSuggestion(ui.message)) { ui.message = wordsFor(o)[0]; if (L) L.text("message", ui.message); } }
    track("ptn_occasion", { occasion: o.key, live: true });
    scheduleGreetPrep(); saveDraft(); liveSync();
  }
  function occasionByKey(k) {
    k = String(k || "").toLowerCase();
    var alias = { "geburt & taufe": "geburt", "taufe": "geburt", "einfach so": "einfach", "dankeschön": "danke" };
    k = alias[k] || k;
    for (var i = 0; i < OCCASIONS.length; i++) if (OCCASIONS[i].key === k || OCCASIONS[i].label.toLowerCase() === k) return OCCASIONS[i];
    return null;
  }
  /* Allgemeiner Einstieg ohne Anlass (Button, Bild, Sticky, alte Links) */
  function openStart(src) {
    if (window.__ptnPro && QUICK) setPro();
    if (src !== "pro" && src !== "api") { var nmiss = namesMissing(); if (nmiss) { heroIdle(); showNameHint(nmiss, src); return; } }
    clearNameHint();
    if (!L) { pendingOpen = src || "cta"; wake(); return; }
    track("ptn_entry", { source: src || "cta" });
    if (BIRTH) { openModal(ui.step > 0 && bReady() ? ui.step : (bReady() ? 1 : 0)); return; }
    if ((liveBox || liveFields.length) && ui.step === 0 && ui.sender && ui.recipient) { openModal(QUICK ? 0 : stepIx("words")); return; }
    openModal(ui.sender && ui.recipient ? ui.step : 0);
  }
  function updateHero() {
    if (!heroEl) return;
    /* Entwurf vorhanden: Haupt-CTA fuehrt direkt zurueck zum Entwurf */
    var lab = heroEl.querySelector(".ptnh-cta-label");
    if (lab) {
      if (!lab.getAttribute("data-def")) lab.setAttribute("data-def", lab.textContent);
      var nm = String(BIRTH ? B.name : (ui.recipient || "")).replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "").split(" ")[0].slice(0, 18);
      if (BIRTH) lab.textContent = nm ? "Urkunde für " + nm + " gestalten" : lab.getAttribute("data-def");
      else lab.textContent = (ui.recipient || ui.sender) ? (nm ? "Weiter: Baum für " + nm : "Entwurf weiter gestalten") : lab.getAttribute("data-def");
    }
    var on2 = heroEl.querySelectorAll("[data-ptn-occasion]");
    for (var i = 0; i < on2.length; i++) on2[i].setAttribute("aria-pressed", ui.occasion && ui.occasion.key === on2[i].getAttribute("data-ptn-occasion") ? "true" : "false");
  }
  /* Klicks auf Einstiege: Hero-Anlaesse, Buttons und alte Anker der Startseite (#pt-inline-personalizer, data-ptf-start …) */
  var LEGACY_SEL = 'a[href="#pt-inline-personalizer"],a[href="#pt-quick-b2c"],a[href="#ptn"],[data-ptf-start],[data-ptf-occasion],[data-ptf-choose-region],[data-ptk-buy],[data-pts-buy],[data-ptd-buy],a[href="#mein-geschenk"]';
  var prodMode = root.getAttribute("data-ptn-product") || "";
  var buybox = null;
  function closestSel(t, sel) {
    while (t && t !== document && t.nodeType === 1) {
      var m = t.matches || t.msMatchesSelector || t.webkitMatchesSelector;
      if (m && m.call(t, sel)) return t;
      t = t.parentNode;
    }
    return null;
  }
  /* Hinweis "Immer inklusive: Baum-Botschaft" auf der Seite (snippets/pt-bb-mini) -> echte Ueberraschung bzw. Beispielvideo */
  document.addEventListener("click", function (e) {
    var bx = closestSel(e.target, "[data-ptn-bbx]");
    if (!bx) return;
    if (e.preventDefault) e.preventDefault();
    track("ptn_bbx_open", { src: "page" });
    /* Claude 30.10.2026: Engine startet auf der Startseite erst bei Beruehrung -> kurz warten statt altem Beispielvideo */
    if (BIRTH) { bbxVideo(); return; }
    var bw = 0;
    (function bxGo() { if (!L && window.PTGuidedLight) boot(); if (L) { bbxShow(); return; } if (++bw < 40) setTimeout(bxGo, 100); else bbxVideo(); })();
  }, false);
  window.addEventListener("click", function (e) {
    var t = e.target;
    var b = closestSel(t, "[data-ptn-occasion],[data-ptn-open],[data-ptn-resume]");
    var legacy = !b && staticHero ? closestSel(t, LEGACY_SEL) : null;
    if (!b && !legacy) return;
    if (modal.contains && modal.contains(t)) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (e.stopPropagation) e.stopPropagation();
    if (legacy && buybox) { buybox.legacy(legacy); return; }
    if (legacy && legacy.getAttribute("data-ptf-start") === "print" && L && L.delivery) { try { L.delivery("print"); } catch (er) {} }
    if (b && b.hasAttribute("data-ptn-occasion")) {
      var o = occasionByKey(b.getAttribute("data-ptn-occasion"));
      heroBusy(b);
      if (o && (liveBox || liveFields.length)) { heroIdle(); if (L) applyOccasionLive(o); else pendingOccasion = o; return; }
      if (o) { track("ptn_entry", { source: "hero-occasion", occasion: o.key }); chooseOccasion(o); } else openStart("hero-occasion");
      return;
    }
    if (legacy && legacy.hasAttribute("data-ptf-occasion")) {
      var o2 = occasionByKey(legacy.getAttribute("data-ptf-occasion"));
      if (o2) { chooseOccasion(o2); return; }
    }
    if (legacy && legacy.hasAttribute("data-ptf-choose-region")) {
      var act = document.querySelector('[data-ptf-region][aria-pressed="true"]');
      var fk = act && act.getAttribute("data-ptf-region");
      if (fk && L) { try { L.forest(fk); } catch (er) {} if (!ui.sender || !ui.recipient) { openStart("forest-map"); return; } openModal(stepIx("place")); return; }
    }
    heroBusy(b && b.getAttribute("data-ptn-open") === "hero-cta" ? b : null);
    openStart((b && (b.getAttribute("data-ptn-open") || "resume")) || "legacy-link");
  }, true);
  /* ---------- Kaufbox auf Geschenkseiten: Variante, mit Baum (Gestalter) oder nur Geschenk (direkt in den Warenkorb) ---------- */
  if (prodMode) buybox = (function () {
    var variants = [];
    try { variants = JSON.parse(root.querySelector("[data-ptnb-variants]").textContent) || []; } catch (e) {}
    var handle = root.getAttribute("data-handle") || "";
    var add = Number(root.getAttribute("data-tree-add")) || 1200;
    var sel = root.querySelector("[data-ptnb-variant]");
    var vid = host.getAttribute("data-host-variant-id") || (sel && sel.value) || (variants[0] && String(variants[0].id)) || "";
    var mode = root.getAttribute("data-ptnb-default") === "plain" ? "plain" : "tree", busy = false, chosen = {};
    var upsell = root.getAttribute("data-ptnb-upsell") === "1", upsellShown = false;
    var errEl = root.querySelector("[data-ptnb-error]");
    var extrasEl = root.querySelector("[data-ptnb-extras]");
    function q(s2) { return root.querySelector(s2); }
    function txt(e2, t) { if (e2) e2.textContent = t; }
    function cur() { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(vid)) return variants[i]; return variants[0] || { price: 0 }; }
    function cents(c) { return euro((Number(c) || 0) / 100); }
    function treePrice() { var v = cur(); return prodMode === "cert" ? v.price : v.price + add; }
    function extrasSum() {
      var sum = 0, ex = extrasList();
      for (var i = 0; i < ex.length; i++) if (chosen[ex[i].key]) sum += Math.round((Number(ex[i].price) || 0) * 100);
      return sum;
    }
    function extrasList() { try { return (L && L.state && L.state().extras) || []; } catch (e) { return []; } }
    function renderExtras() {
      if (!extrasEl) return;
      var ex = mode === "plain" ? extrasList() : [];
      clear(extrasEl);
      if (!ex.length) { extrasEl.hidden = true; return; }
      extrasEl.hidden = false;
      extrasEl.appendChild(el("p", "ptnb-extras-title", "Dazu passend (optional)"));
      extrasEl.appendChild(buildExtras(ex, {
        isOn: function (k) { return !!chosen[k]; },
        toggle: function (k, v) { chosen[k] = v; track("ptn_extra", { key: k, on: v, plain: true }); paint(); },
        changed: function () { paint(); }
      }));
    }
    function paint(keepExtras) {
      var v = cur(), tp = treePrice(), pp = v.price + (mode === "plain" ? extrasSum() : 0);
      txt(q('[data-ptnb-price="tree"]'), cents(tp));
      txt(q('[data-ptnb-price="plain"]'), cents(v.price));
      var ms = root.querySelectorAll("[data-ptnb-mode]");
      for (var i = 0; i < ms.length; i++) {
        var onm = ms[i].getAttribute("data-ptnb-mode") === mode;
        ms[i].className = "ptnb-mode" + (onm ? " is-on" : "");
        ms[i].setAttribute("aria-checked", onm ? "true" : "false");
      }
      var plain = mode === "plain";
      var nmb = q("[data-ptnb-names]"); if (nmb) nmb.hidden = plain;
      var prl = q(".ptn-prolink"); if (prl) prl.hidden = plain;
      var bbm = q(".ptn-bbmini"); if (bbm) bbm.hidden = plain;
      if (plain) clearNameHint();
      txt(q("[data-ptnb-cta-label]"), plain ? "In den Warenkorb" : (prodMode === "cert" ? "Zertifikat gestalten" : "Jetzt gestalten"));
      txt(q("[data-ptnb-cta-price]"), plain ? cents(pp) : (prodMode === "cert" ? "ab " : "") + cents(tp));
      var st = document.querySelector("[data-ptnb-sticky-label]"), sp = document.querySelector("[data-ptnb-sticky-price]");
      txt(st, plain ? "Geschenk in den Warenkorb" : (prodMode === "cert" ? "Zertifikat gestalten" : "Geschenk + Baum gestalten"));
      txt(sp, plain ? cents(pp) : cents(tp));
      if (!keepExtras) renderExtras();
    }
    function fireVariant(v) {
      var detail = { id: Number(v.id), price: (Number(v.price) || 0) / 100, title: v.title };
      var ev;
      try { ev = new CustomEvent("pt:inline-variant", { detail: detail }); }
      catch (e) { try { ev = document.createEvent("CustomEvent"); ev.initCustomEvent("pt:inline-variant", false, false, detail); } catch (e2) { ev = null; } }
      if (ev) document.dispatchEvent(ev);
    }
    function setVariant(id) {
      vid = String(id);
      host.setAttribute("data-host-variant-id", vid);
      if (sel && sel.value !== vid) sel.value = vid;
      if (L && L.selectGift) { try { L.selectGift(handle, Number(vid)); } catch (e) {} }
      try { if (history.replaceState) history.replaceState(history.state, "", location.pathname + "?variant=" + vid + location.hash); } catch (e) {}
      fireVariant(cur());
      paint();
    }
    if (sel) on(sel, "change", function () { setVariant(sel.value); track("ptn_variant", { variant: sel.value }); });
    var modeBtns = root.querySelectorAll("[data-ptnb-mode]");
    for (var mi = 0; mi < modeBtns.length; mi++) on(modeBtns[mi], "click", function () { setMode(this.getAttribute("data-ptnb-mode")); });
    function setMode(m) { mode = m === "plain" ? "plain" : "tree"; if (errEl) errEl.hidden = true; track("ptn_mode", { mode: mode }); paint(); }
    function showErr(t) { if (errEl) { errEl.textContent = t; errEl.hidden = false; } }
    function addPlain() {
      if (busy) return;
      var S2 = window.PTGuidedSession;
      if (!L || !S2 || !S2.plain) { showErr("Einen Moment bitte – der Shop lädt noch. Bitte gleich nochmal tippen."); return; }
      busy = true; addCls(root, "is-busy");
      txt(q("[data-ptnb-cta-label]"), "Wird in den Warenkorb gelegt …");
      var ex = extrasList().filter(function (x) { return chosen[x.key]; });
      track("ptn_entry", { source: "product-plain" });
      Promise.resolve(S2.plain({ handle: handle }, Number(vid), ex)).then(function () {
        setTimeout(function () { if (location.pathname !== "/cart") location.href = "/cart"; }, 1500);
      })["catch"](function (e) {
        busy = false; rmCls(root, "is-busy"); paint(true);
        showErr((e && e.message) || "Das hat nicht geklappt. Bitte versuche es noch einmal.");
      });
    }
    /* Upsell: wer nur das Geschenk nimmt, bekommt einmal das Angebot "mit Baum" */
    function showUpsell() {
      upsellShown = true;
      track("ptn_upsell_show", {});
      var v = cur();
      var ov = el("div", "ptnu");
      ov.setAttribute("role", "dialog"); ov.setAttribute("aria-modal", "true"); ov.setAttribute("aria-label", "Als Baumgeschenk verschenken?");
      var box = el("div", "ptnu-box");
      var x = el("button", "ptnu-x", "\u00d7"); x.type = "button"; x.setAttribute("aria-label", "Schlie\u00dfen");
      box.appendChild(x);
      var img = el("img", "ptnu-img"); img.alt = "Muster-Zertifikat"; img.src = CDN + "zertifikat-portrait-02-zertifikat.jpg?v=1790466009&width=400";
      box.appendChild(img);
      box.appendChild(el("p", "ptnu-kicker", "Unser Tipp"));
      box.appendChild(el("h3", "ptnu-h", "Mach daraus ein Baumgeschenk"));
      box.appendChild(el("p", "ptnu-p", "F\u00fcr nur " + cents(add) + " mehr pflanzen wir einen echten Baum im deutschen Wald \u2013 mit pers\u00f6nlichem Zertifikat auf den Namen der beschenkten Person. Das Zertifikat liegt deinem Geschenk gedruckt bei."));
      var yes = el("button", "ptnu-yes"); yes.type = "button";
      yes.appendChild(el("span", "", "Ja, mit Baum verschenken"));
      yes.appendChild(el("span", "ptnu-price", cents(v.price + add)));
      var no = el("button", "ptnu-no", "Nein danke, nur das Geschenk (" + cents(v.price + extrasSum()) + ")"); no.type = "button";
      box.appendChild(yes); box.appendChild(no);
      ov.appendChild(box);
      function close() { if (ov.parentNode) ov.parentNode.removeChild(ov); }
      on(x, "click", function () { close(); track("ptn_upsell_close", {}); });
      on(ov, "click", function (e) { if (e.target === ov) { close(); track("ptn_upsell_close", {}); } });
      on(yes, "click", function () { close(); track("ptn_upsell_yes", {}); setMode("tree"); cta(); });
      on(no, "click", function () { close(); track("ptn_upsell_no", {}); addPlain(); });
      document.body.appendChild(ov);
    }
    function cta() {
      if (mode === "plain" && upsell && !upsellShown && prodMode !== "cert") { showUpsell(); return; }
      if (mode === "plain") { addPlain(); return; }
      openStart(prodMode === "cert" ? "product-cert" : "product-tree");
    }
    on(q("[data-ptnb-cta]"), "click", cta);
    var stb = document.querySelector("[data-ptnb-sticky]");
    if (stb) on(stb, "click", cta);
    function scrollToBox() {
      var r = root.getBoundingClientRect(), y = (window.pageYOffset || 0) + r.top - 90;
      try { window.scrollTo({ top: y, behavior: "smooth" }); } catch (e) { window.scrollTo(0, y); }
    }
    paint();
    return {
      ready: function () { paint(); },
      legacy: function (lk) {
        var buy = lk.getAttribute("data-ptk-buy") || lk.getAttribute("data-pts-buy") || lk.getAttribute("data-ptd-buy");
        if (buy === "tree" || buy === "") { setMode("tree"); cta(); return; }
        if (buy === "gift" || buy === "plain") { setMode("plain"); }
        scrollToBox();
      }
    };
  })();
  /* Sticky-CTA (mobil): sichtbar, sobald der Hero aus dem Bild ist */
  (function () {
    var st = document.querySelector("[data-ptn-sticky]");
    if (!st || !heroEl) return;
    var tools = document.getElementById("pt-shop-tools");
    function place() {
      var h = tools && tools.offsetHeight ? tools.offsetHeight : 0;
      st.style.bottom = (h + 10) + "px";
    }
    var cta = heroEl.querySelector(".ptnh-cta,[data-ptnb-cta]");
    function check() {
      var r = (cta || heroEl).getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var th = tools && tools.offsetHeight ? tools.offsetHeight : 0;
      var rb = heroEl.getBoundingClientRect();
      /* erst nach dem Vorbeiscrollen am Haupt-Knopf – oder wenn der ganze Einstieg ausserhalb des Bildes ist */
      var show = (r.bottom < 10 || rb.top > vh - th - 20) && !opened;
      if (show) { place(); addCls(st, "is-visible"); st.setAttribute("aria-hidden", "false"); st.querySelector("button").removeAttribute("tabindex"); }
      else { rmCls(st, "is-visible"); st.setAttribute("aria-hidden", "true"); st.querySelector("button").setAttribute("tabindex", "-1"); }
    }
    var ticking = false;
    on(window, "scroll", function () { if (ticking) return; ticking = true; (window.requestAnimationFrame || setTimeout)(function () { ticking = false; check(); }); });
    on(window, "resize", check);
    setTimeout(check, 600);
  })();
  function chooseOccasion(o) {
    if (!L) { pendingOccasion = o; loading.style.display = staticHero ? "none" : ""; wake(); return; }
    var changed = ui.occasion !== o;
    ui.occasion = o;
    xmasDesign();
    track("ptn_occasion", { occasion: o.key });
    if (L && (changed || !ui.message)) {
      var known = false;
      known = isSuggestion(ui.message);
      if (!ui.message || known) { ui.message = wordsFor(o)[0]; L.text("message", ui.message); }
    }
    scheduleGreetPrep();
    openModal(ui.sender && ui.recipient ? ui.step : 0);
  }

  /* ---------- Popup oeffnen/schliessen ---------- */
  var opened = false, scrollY = 0;
  /* Layout am sichtbaren Bereich ausrichten (iOS: Tastatur verkleinert nur den visualViewport) */
  var vv = window.visualViewport || null;
  var REGIONS = { names: [0.03, 0.45], message: [0.50, 0.80], bname: [0.16, 0.32], bdate: [0.29, 0.53], bdetail: [0.46, 0.65] };
  function typingRegion() {
    var a = document.activeElement;
    if (!opened || !a || !modal.contains(a)) return null;
    var r = a.getAttribute && a.getAttribute("data-region");
    return r || null;
  }
  function fit() {
    if (!opened) return;
    checkNav();
    var h = vv ? vv.height : window.innerHeight;
    var w = vv ? vv.width : window.innerWidth;
    modal.style.height = Math.round(h) + "px";
    modal.style.top = (vv ? Math.round(vv.offsetTop) : 0) + "px";
    var desktop = window.innerWidth >= 900;
    var region = desktop ? null : typingRegion();
    var sceneOn = false;
    if (sceneOn) {
      if (!sceneMounted && L && L.mountScene) { try { L.mountScene(sceneBox); sceneMounted = true; } catch (e) {} }
      if (sceneMounted) addCls(modal, "show-scene"); else sceneOn = false;
    } else rmCls(modal, "show-scene");
    if (sceneOn) {
      if (desktop) { sceneBox.style.width = ""; sceneBox.style.height = ""; }
      else {
        var zoomS = (" " + modal.className + " ").indexOf(" is-zoom ") >= 0;
        var shS = zoomS ? 0.78 : Math.max(ui.share, 0.5);
        sceneBox.style.width = Math.round(w - 24) + "px";
        sceneBox.style.height = Math.max(180, Math.round((h - 48) * shS)) + "px";
      }
      refreshScene();
    }
    var stage = (L && L.stage) || paper.querySelector(".ptg-light-stage");
    if (region) {
      addCls(modal, "is-typing");
      var boxH = Math.max(110, Math.round(h * Math.max(0.3, Math.min(0.5, ui.share * 0.8))));
      var boxW = Math.min(Math.round(w - 32), 420);
      var r = REGIONS[region];
      var certH = boxH / (r[1] - r[0]);
      var certW = certH / 1.4145;
      if (certW > boxW) { certW = boxW; certH = certW * 1.4145; }
      paper.style.width = boxW + "px"; paper.style.height = boxH + "px"; paper.style.maxWidth = "none";
      addCls(paper, "is-crop");
      if (stage && stage.style) {
        stage.style.width = Math.round(certW) + "px"; stage.style.height = Math.round(certH) + "px";
        stage.style.left = Math.round((boxW - certW) / 2) + "px";
        stage.style.top = Math.round(-r[0] * certH) + "px";
      }
    } else {
      rmCls(modal, "is-typing");
      rmCls(paper, "is-crop");
      paper.style.height = "";
      if (stage && stage.style) { stage.style.width = ""; stage.style.height = ""; stage.style.left = ""; stage.style.top = ""; }
      if (desktop) {
        var sw = stageWrap.clientWidth - 64, shh = stageWrap.clientHeight - 44;
        var dpw = Math.round(Math.min(sw, shh / 1.4145));
        if (dpw > 200) { paper.style.width = dpw + "px"; paper.style.maxWidth = "none"; } else { paper.style.width = ""; paper.style.maxWidth = ""; }
      }
      else {
        var zoom = (" " + modal.className + " ").indexOf(" is-zoom ") >= 0;
        var share = zoom ? 0.78 : ui.share;
        var pw = Math.round((h - 48) * share / 1.4145);
        pw = Math.max(110, Math.min(pw, Math.round(w * (zoom ? 0.92 : 0.86))));
        paper.style.width = pw + "px"; paper.style.maxWidth = "none";
      }
    }
    applyLook();
  }
  var sceneT = 0, sceneKey = "";
  function refreshScene() {
    clearTimeout(sceneT);
    sceneT = setTimeout(function () {
      if (!L || !sceneMounted) return;
      var k = sceneBox.offsetWidth + "x" + sceneBox.offsetHeight;
      if (k === sceneKey) return;
      sceneKey = k;
      try { L.refresh(); } catch (e) {}
    }, 90);
  }
  var fitT = 0;
  function fitSoon() { clearTimeout(fitT); fitT = setTimeout(function () { fit(); keepFocusVisible(); }, 60); }
  function keepFocusVisible() {
    var a = document.activeElement;
    if (!a || !mainCol.contains(a)) return;
    var target = a, up = a;
    for (var q = 0; q < 3 && up; q++) { up = up.parentNode; if (up && (" " + up.className + " ").indexOf(" ptn-field ") >= 0) { target = up; break; } }
    var off = 0, n = target;
    while (n && n !== mainCol) { off += n.offsetTop; n = n.offsetParent; }
    var mt = mainCol.scrollTop, mh = mainCol.clientHeight;
    if (off < mt + 4 || off + target.offsetHeight > mt + mh - 4) mainCol.scrollTop = Math.max(0, off - 8);
  }
  /* iOS/Android: Tastatur per "Fertig"/Wischen geschlossen -> Feld bleibt fokussiert. Dann Fokus loesen, damit Zoom/Tippmodus endet. */
  var kbBase = vv ? Math.max(vv.height, window.innerHeight || 0) : 0, kbOpen = false;
  function kbCheck() {
    if (!vv || window.innerWidth >= 900) return;
    var hh = vv.height;
    if (hh > kbBase) kbBase = hh;
    if ((window.innerHeight || 0) > kbBase && !kbOpen) kbBase = window.innerHeight;
    if (hh < kbBase - 150) { kbOpen = true; return; }
    if (kbOpen && hh > kbBase - 80) {
      kbOpen = false;
      var a = document.activeElement;
      if (opened && a && modal.contains(a) && (a.tagName === "INPUT" || a.tagName === "TEXTAREA")) { try { a.blur(); } catch (e) {} }
    }
  }
  if (vv) { vv.addEventListener("resize", function () { kbCheck(); fitSoon(); }); vv.addEventListener("scroll", fitSoon); }
  on(window, "orientationchange", function () { kbOpen = false; setTimeout(function () { kbBase = vv ? Math.max(vv.height, window.innerHeight || 0) : 0; }, 400); });
  on(modal, "focusin", fitSoon);
  on(modal, "focusout", function () { setTimeout(fitSoon, 120); });
  function openModal(step) {
    xmasDesign();
    if (!L) return;
    restoringOff();
    if (liveBox && L.stage && L.stage.parentNode !== paper) { paper.appendChild(L.stage); try { L.refresh(); } catch (e) {} }
    if (!opened) {
      opened = true;
      scrollY = window.pageYOffset || 0;
      addCls(document.documentElement, "ptn-lock");
      modal.style.display = "";
      fit();
      try { if (window.history && history.pushState) history.pushState({ ptn: 1 }, ""); } catch (e) {}
      track("ptn_open", {});
    }
    heroIdle();
    goStep(step || 0);
  }
  function closeModal(fromHistory) {
    if (!opened) return;
    /* Team-Modi: Schliessen fuehrt zurueck zur Uebersicht (Bestellung bzw. Team-Zentrale) */
    if (STAFF_ON && staff.info) { location.href = staffBackUrl(); return; }
    opened = false;
    modal.style.display = "none";
    rmCls(document.documentElement, "ptn-lock");
    window.scrollTo(0, scrollY);
    track("ptn_close", { step: STEPS[ui.step].key });
    saveDraft();
    updateHero();
    if (liveBox && L && L.stage) { liveBox.appendChild(L.stage); liveSync(); }
    if (!fromHistory) { try { if (history.state && history.state.ptn) history.back(); } catch (e) {} }
  }
  function zoomOff() { if ((" " + modal.className + " ").indexOf(" is-zoom ") < 0) return false; rmCls(modal, "is-zoom"); fit(); carPaint(); return true; }
  on(closeBtn, "click", function () { if (zoomOff()) return; closeModal(false); });
  on(window, "popstate", function () { if (opened) closeModal(true); });
  on(document, "keydown", function (e) {
    if (!opened || e.keyCode !== 27) return;
    /* Esc schliesst zuerst ein offenes Unterfenster (PayPal-Dialog, Grusskarte, Geschenk, Grossansicht) */
    if (document.querySelector("dialog[open]")) return;
    var lb = dialog.querySelector(".ptn-lightbox"); if (lb) { lb.parentNode.removeChild(lb); return; }
    var sh = dialog.querySelectorAll(".ptn-sheet"); if (sh.length) { var x = sh[sh.length - 1].querySelector(".ptn-sheet-close"); if (x) x.click(); return; }
    if (zoomOff()) return;
    closeModal(false);
  });
  on(window, "resize", function () { if (opened) fit(); });
  on(window, "orientationchange", function () { setTimeout(fit, 300); });

  /* ---------- Schritte ---------- */
  function stepIx(k) { for (var i = 0; i < STEPS.length; i++) if (STEPS[i].key === k) return i; return 0; }
  function goStep(i) {
    ui.step = Math.max(0, Math.min(STEPS.length - 1, i));
    modal.setAttribute("data-step", STEPS[ui.step].key);
    renderNav();
    renderStep();
    updateBar();
    mainCol.scrollTop = 0;
    fit();
    track("ptn_step", { step: STEPS[ui.step].key });
    saveDraft();
  }
  function canAdvance(step) {
    if (BIRTH) return STEPS[step].key !== "child" || bReady();
    if (STEPS[step].key === "names") return !!((ui.photos.sender || ui.sender.replace(/\s/g, "")) && (ui.photos.recipient || ui.recipient.replace(/\s/g, "")));
    return true;
  }
  function quickShort() { return QUICK && !ui.qLong; }
  function renderNav() {
    clear(nav);
    var qi = QUICK ? stepIx("quick") : -1;
    if (quickShort()) {
      /* Schnellweg: nur Namen, Satz, Fertig - beim Aendern aus der Uebersicht zeigt die Ueberschrift, was gerade angepasst wird */
      STEPS.slice(0, qi + 1).forEach(function (s, i) {
        var cur = ui.qEdit ? i === qi : i === ui.step;
        var li = el("li", "ptn-nav-item" + (cur ? " is-current" : "") + (i < Math.min(ui.step, qi) ? " is-done" : ""));
        var b = el("button", "", s.label); b.type = "button";
        b.disabled = i > ui.step && !canAdvance(0);
        on(b, "click", function () { ui.qEdit = false; if (i <= ui.step || canAdvance(0)) goStep(i); });
        li.appendChild(b); nav.appendChild(li);
      });
      navCap.textContent = ui.qEdit ? "Anpassen \u00b7 " + STEPS[ui.step].label : "Schritt " + (Math.min(ui.step, qi) + 1) + " von " + (qi + 1) + " \u00b7 " + STEPS[ui.step].label;
      checkNav();
      return;
    }
    STEPS.forEach(function (s, i) {
      var li = el("li", "ptn-nav-item" + (i === ui.step ? " is-current" : "") + (i < ui.step ? " is-done" : ""));
      var b = el("button", "", s.label);
      b.setAttribute("aria-label", "Schritt " + (i + 1) + " von " + STEPS.length + ": " + s.label);
      b.type = "button";
      b.disabled = i > ui.step && !canAdvance(0);
      on(b, "click", function () { if (i <= ui.step || canAdvance(0)) goStep(i); });
      li.appendChild(b); nav.appendChild(li);
    });
    navCap.textContent = "Schritt " + (ui.step + 1) + " von " + STEPS.length + " \u00b7 " + STEPS[ui.step].label;
    checkNav();
  }
  /* Passen die Schrittnamen nicht in eine Zeile (kleines Handy, gro\u00dfe Systemschrift),
     zeigen wir nur die Balken und darunter "Schritt 3 von 6 \u00b7 Pflanzort". */
  function checkNav() {
    rmCls(nav, "is-compact");
    var btns = nav.querySelectorAll("button"), tight = false;
    for (var i = 0; i < btns.length; i++) if (btns[i].scrollWidth > btns[i].clientWidth + 1) tight = true;
    if (tight) addCls(nav, "is-compact");
  }
  function refreshNavLock() {
    var btns = nav.querySelectorAll("button");
    for (var i = 1; i < btns.length; i++) btns[i].disabled = i > ui.step && !canAdvance(0);
  }
  function head(title, sub) {
    body.appendChild(el("h2", "ptn-h2", title));
    if (sub) body.appendChild(el("p", "ptn-hint", sub));
  }
  var fieldSeq = 0;
  function field(label, value, placeholder, onInput, opts) {
    var wrap = el("div", "ptn-field");
    var lab = el("label", "ptn-field-label", label);
    var fid = "ptn-f" + (++fieldSeq);
    lab.htmlFor = fid;
    wrap.appendChild(lab);
    var multi = opts && opts.multiline;
    var inp = multi ? el("textarea", "ptn-input ptn-input--multi") : el("input", "ptn-input");
    if (!multi) inp.type = "text";
    inp.id = fid;
    inp.value = value || "";
    inp.placeholder = placeholder || "";
    inp.setAttribute("autocomplete", "off");
    inp.setAttribute("autocorrect", "off");
    inp.setAttribute("autocapitalize", (opts && opts.region === "names") ? "words" : (multi ? "sentences" : "words"));
    if (opts && opts.maxLength) inp.maxLength = opts.maxLength;
    if (opts && opts.rows) inp.rows = Math.max(opts.rows, Math.min((opts && opts.lines) || 1, (value || "").split("\n").length));
    if (opts && opts.region) inp.setAttribute("data-region", opts.region);
    var maxLines = (opts && opts.lines) || 0;
    on(inp, "input", function () {
      var v = inp.value;
      if (maxLines) {
        var parts = v.split("\n");
        if (parts.length > maxLines) { v = parts.slice(0, maxLines).join("\n"); inp.value = v; }
        if (multi) { inp.rows = Math.min(maxLines, Math.max((opts && opts.rows) || 1, v.split("\n").length)); }
      }
      onInput(v);
    });
    if (maxLines) on(inp, "keydown", function (e) {
      if (e.keyCode === 13 && inp.value.split("\n").length >= maxLines) e.preventDefault();
    });
    var box = el("div", "ptn-inbox");
    box.appendChild(inp);
    wrap.appendChild(box);
    return { wrap: wrap, input: inp, box: box, label: label };
  }
  function renderStep() {
    clear(body);
    verbBox = null;
    var key = STEPS[ui.step].key;
    if (key !== "staff" && key !== "issue") staff.result = null;
    ui.claimInline = false;
    if (QUICK && !BIRTH && (key === "sentence" || key === "words") && !ui.message && !ui.msgOff && L) { ui.message = wordsFor(ui.occasion || OCCASIONS[OCCASIONS.length - 1])[0]; L.text("message", ui.message); }
    if (key === "child") stepChild();
    else if (key === "details") stepDetails();
    else if (key === "names") stepNames();
    else if (key === "sentence") stepSentence();
    else if (key === "words") stepWords();
    else if (key === "quick") stepQuick();
    else if (key === "place") stepPlace();
    else if (key === "trees") stepTrees();
    else if (key === "design") stepDesign();
    else if (key === "staff") stepStaff();
    else if (key === "issue") stepIssue();
    else stepFormat();
    if (QUICK && !ui.qEdit && /^(sentence|words|place|trees|design)$/.test(key) && canAdvance(0)) {
      var sk = el("button", "ptn-skip", "Alles so lassen – direkt zur Übersicht ›"); sk.type = "button";
      on(sk, "click", function () { track("ptn_skip_overview", { from: key }); goStep(stepIx("quick")); });
      body.appendChild(sk);
    }
  }

  var verbBox = null;
  function setVerb(v, manual) {
    ui.verb = v; if (manual) ui.verbManual = true;
    if (L) L.verb(v);
    renderVerb();
  }
  function autoVerb() {
    if (ui.verbManual) return;
    var s = ui.sender.replace(/^\s+|\s+$/g, "");
    var plural = /(\s(und|&|\+)\s)|&|,|^(familie|wir|die |eure|euer|team|alle|oma und opa|mama und papa)/i.test(s);
    var v = plural ? "haben" : "hat";
    if (v !== ui.verb) setVerb(v, false);
  }
  function renderVerb() {
    if (!verbBox) return;
    clear(verbBox);
    [["hat", "Ich schenke allein"], ["haben", "Wir schenken gemeinsam"]].forEach(function (v) {
      var b = el("button", "ptn-seg" + (ui.verb === v[0] ? " is-on" : ""));
      b.type = "button";
      b.setAttribute("aria-pressed", String(ui.verb === v[0]));
      b.appendChild(el("strong", "", v[0]));
      b.appendChild(el("small", "", v[1]));
      on(b, "click", function () { setVerb(v[0], true); saveDraft(); });
      verbBox.appendChild(b);
    });
    renderClaim();
  }

  /* ---------- Satz nach hat/haben (wie im alten Personalisierer: Engine L.claim / L.claimOptions) ---------- */
  var CLAIM_KEYS = [["standard", "Standard"], ["birthday", "Geburtstag"], ["wedding", "Hochzeit"], ["birth", "Geburt"], ["thanks", "Dankeschön"], ["memory", "Erinnerung"]];
  var CLAIM_TXT = {
    de: { standard: "für", birthday: "zum Geburtstag für", wedding: "zur Hochzeit von", birth: "zur Geburt von", thanks: "als Dankeschön für", memory: "in Erinnerung an", ph: "zum Jubiläum für" },
    en: { standard: "for", birthday: "for the birthday of", wedding: "for the wedding of", birth: "for the birth of", thanks: "as a thank-you to", memory: "in memory of", ph: "for the anniversary of" },
    fr: { standard: "pour", birthday: "pour l'anniversaire de", wedding: "pour le mariage de", birth: "pour la naissance de", thanks: "pour remercier", memory: "en mémoire de", ph: "pour le jubilé de" },
    es: { standard: "para", birthday: "por el cumpleaños de", wedding: "por la boda de", birth: "por el nacimiento de", thanks: "como agradecimiento a", memory: "en memoria de", ph: "por el aniversario de" }
  };
  var claimBox = null;
  function claimNow() {
    var ex = null; try { ex = L && L.exportState ? L.exportState() : null; } catch (e) {}
    return { key: (ex && ex.claimPhraseKey) || "standard", custom: (ex && ex.claimCustomPrefix) || "", art: (ex && ex.recipientArticle) || "" };
  }
  function claimLang() { var l = ui.lang || "de"; return CLAIM_TXT[l] ? l : "de"; }
  function claimPhrase(c) {
    var t = CLAIM_TXT[claimLang()];
    var p = c.key === "custom" ? (c.custom || t.standard) : (t[c.key] || t.standard);
    if (claimLang() === "de" && c.art && c.key !== "wedding" && c.key !== "birth") p += " " + c.art;
    return p;
  }
  function claimSentence() {
    var c = claimNow(), l = claimLang(), pl = ui.verb === "haben";
    var from = (ui.sender || "Lotta").replace(/\s+/g, " "), to = (ui.recipient || "Paul").replace(/\s+/g, " ");
    var v = l === "en" ? (pl ? "have planted a tree" : "has planted a tree") : l === "fr" ? (pl ? "ont planté un arbre" : "a planté un arbre") : l === "es" ? (pl ? "han plantado un árbol" : "ha plantado un árbol") : (pl ? "haben" : "hat");
    return from + " " + v + " " + claimPhrase(c) + " " + to + (l === "de" ? " einen Baum pflanzen lassen" : " …");
  }
  function setClaim(key, custom, art) {
    if (!L || !L.claim) return;
    try { L.claim(key, custom || "", art || ""); } catch (e) {}
    saveDraft();
  }
  function claimResetForLang() {
    var c = claimNow();
    if (c.key === "custom" || c.art) setClaim(c.key === "custom" ? "standard" : c.key, "", "");
  }
  var sentPv = null;
  function renderClaim() {
    if (sentPv && sentPv.parentNode) sentPv.textContent = claimSentence();
    if (!claimBox) return;
    clear(claimBox);
    var c = claimNow(), l = claimLang(), isDe = l === "de";
    if (!ui.claimInline) {
      var t = el("button", "ptn-claim-toggle"); t.type = "button";
      t.setAttribute("aria-expanded", String(!!ui.claimOpen));
      var changed = c.key !== "standard" || c.art;
      t.appendChild(el("span", "", ui.claimOpen ? "Satz-Optionen schließen" : (changed ? "Satz: „" + (ui.verb === "haben" ? "haben " : "hat ") + claimPhrase(c) + "“ · ändern" : "Satz ändern, z. B. „zum Geburtstag für“ (freiwillig)")));
      on(t, "click", function () { ui.claimOpen = !ui.claimOpen; renderClaim(); });
      claimBox.appendChild(t);
      if (!ui.claimOpen) return;
    }
    var panel = el("div", "ptn-claim-panel");
    var chips = el("div", "ptn-chips ptn-claim-chips");
    var presetVal = c.key === "custom" ? "custom:" + c.custom : "";
    var opts = null; try { opts = L.claimOptions(); } catch (e) {}
    var presets = [];
    if (isDe && opts && opts.choices) opts.choices.forEach(function (o) { if (o.value.indexOf("custom:") === 0) presets.push(o); });
    var isPreset = false;
    presets.forEach(function (o) { if (o.value === presetVal) isPreset = true; });
    CLAIM_KEYS.concat([["custom", "Eigener Satz"]]).forEach(function (k) {
      var onNow = k[0] === "custom" ? (c.key === "custom" && !isPreset) : c.key === k[0];
      var b = el("button", "ptn-chip" + (onNow ? " is-on" : ""), k[1]); b.type = "button";
      b.setAttribute("aria-pressed", String(onNow));
      on(b, "click", function () {
        if (k[0] === "custom") { ui.claimCustomOpen = true; setClaim("custom", c.key === "custom" && !isPreset ? c.custom : "", c.art); }
        else { ui.claimCustomOpen = false; setClaim(k[0], "", (k[0] === "wedding" || k[0] === "birth") ? "" : c.art); }
        renderClaim();
      });
      chips.appendChild(b);
    });
    panel.appendChild(chips);
    if (presets.length) {
      var sl = el("label", "ptn-claim-label", "Weitere Anlässe");
      var sel = el("select", "ptn-claim-select"); sel.id = "ptn-claim-preset"; sl.htmlFor = sel.id;
      var o0 = el("option", "", "Anlass wählen …"); o0.value = ""; sel.appendChild(o0);
      presets.forEach(function (o) { var op = el("option", "", o.label); op.value = o.value; sel.appendChild(op); });
      sel.value = isPreset ? presetVal : "";
      on(sel, "change", function () { if (!sel.value) return; ui.claimCustomOpen = false; setClaim("custom", sel.value.slice(7), c.art); renderClaim(); });
      panel.appendChild(sl); panel.appendChild(sel);
    }
    if (c.key === "custom" && (!isPreset || ui.claimCustomOpen)) {
      var il = el("label", "ptn-claim-label", "Dein Text nach „" + (ui.verb === "haben" ? "haben" : "hat") + "“" + (isDe ? "" : " (in der Sprache des Zertifikats)"));
      if (!isDe) il.textContent = "Dein Text nach „" + claimSentence().split(" ").slice(1, l === "en" ? 5 : 4).join(" ") + "“ (in der Sprache des Zertifikats)";
      var inp = el("input", "ptn-claim-input"); inp.type = "text"; inp.id = "ptn-claim-custom"; il.htmlFor = inp.id;
      inp.maxLength = 38; inp.autocomplete = "off"; inp.setAttribute("autocapitalize", "none"); inp.spellcheck = false;
      inp.placeholder = CLAIM_TXT[l].ph; inp.value = c.custom || "";
      on(inp, "input", function () { if (L && L.claim) { try { L.claim("custom", inp.value, claimNow().art); } catch (e) {} } pv.textContent = claimSentence(); if (sentPv && sentPv.parentNode) sentPv.textContent = pv.textContent; });
      on(inp, "change", function () { saveDraft(); });
      panel.appendChild(il); panel.appendChild(inp);
    }
    if (isDe && opts && opts.articles && c.key !== "wedding" && c.key !== "birth") {
      var al = el("label", "ptn-claim-label", "Wort vor dem Namen (z. B. „für die Oma“)");
      var as = el("select", "ptn-claim-select"); as.id = "ptn-claim-art"; al.htmlFor = as.id;
      opts.articles.forEach(function (a) { var op = el("option", "", a.label); op.value = a.value; as.appendChild(op); });
      as.value = c.art || "";
      on(as, "change", function () { var n = claimNow(); setClaim(n.key, n.custom, as.value); renderClaim(); });
      panel.appendChild(al); panel.appendChild(as);
    }
    var pv = el("p", "ptn-claim-preview", claimSentence());
    pv.setAttribute("aria-live", "polite");
    panel.appendChild(el("span", "ptn-claim-label", "So steht es auf dem Zertifikat:"));
    panel.appendChild(pv);
    claimBox.appendChild(panel);
  }

  /* ---------- Sprache des Zertifikats (Server rendert DE/EN/FR/ES) ---------- */
  var LANGS = [["de", "Deutsch", "🇩🇪"], ["en", "English", "🇬🇧"], ["fr", "Français", "🇫🇷"], ["es", "Español", "🇪🇸"]];
  var WORDS = {
    en: {
      geburtstag: ["Happy Birthday!", "Wishing you a\nwonderful birthday", "Grow on\nlike this tree"],
      geburt: ["Welcome\nto the world", "A tree that\ngrows with you", "Welcome,\nlittle miracle"],
      hochzeit: ["Congratulations\non your wedding", "To your\nshared roots", "For a love\nthat grows"],
      danke: ["A heartfelt\nthank you", "Thank you for\nbeing you", "Thank you\nfor everything"],
      weihnachten: ["Merry Christmas", "Merry Christmas and\na green New Year", "A gift\nthat grows"],
      erinnerung: ["In loving\nmemory", "Never forgotten", "What remains\nis love"],
      einfach: ["Just for you", "Because you\nmean a lot to me", "For you –\njust because"]
    },
    fr: {
      geburtstag: ["Joyeux\nanniversaire !", "Tous mes vœux\npour ton anniversaire", "Grandis encore\ncomme cet arbre"],
      geburt: ["Bienvenue\nau monde", "Un arbre qui\ngrandit avec toi", "Bienvenue,\npetit miracle"],
      hochzeit: ["Tous nos vœux\nde bonheur", "À vos racines\ncommunes", "Pour un amour\nqui grandit"],
      danke: ["Un grand\nmerci", "Merci d’être\nlà", "Merci pour tout"],
      weihnachten: ["Joyeux Noël", "Joyeux Noël et\nune année verte", "Un cadeau\nqui grandit"],
      erinnerung: ["En souvenir\naffectueux", "Inoubliable", "Ce qui reste,\nc’est l’amour"],
      einfach: ["Juste pour toi", "Parce que tu\ncomptes pour moi", "Pour toi,\ntout simplement"]
    },
    es: {
      geburtstag: ["¡Feliz\ncumpleaños!", "Muchas felicidades\nen tu día", "Sigue creciendo\ncomo este árbol"],
      geburt: ["Bienvenido\nal mundo", "Un árbol que\ncrece contigo", "Bienvenido,\npequeño milagro"],
      hochzeit: ["Felicidades\npor vuestra boda", "Por vuestras\nraíces compartidas", "Por un amor\nque crece"],
      danke: ["Muchísimas\ngracias", "Gracias por\nestar ahí", "Gracias por todo"],
      weihnachten: ["Feliz Navidad", "Feliz Navidad y\nun año nuevo verde", "Un regalo\nque crece"],
      erinnerung: ["En cariñoso\nrecuerdo", "Siempre en\nnuestro corazón", "Lo que queda\nes el amor"],
      einfach: ["Solo para ti", "Porque eres\nimportante para mí", "Para ti,\nporque sí"]
    }
  };
  function wordsFor(o) {
    var l = ui.lang || "de";
    return (l !== "de" && WORDS[l] && WORDS[l][o.key]) || o.words;
  }
  function isSuggestion(msg) {
    if (!msg) return true;
    for (var i = 0; i < OCCASIONS.length; i++) {
      var o = OCCASIONS[i];
      if (o.words.indexOf(msg) >= 0) return true;
      for (var l in WORDS) if (WORDS.hasOwnProperty(l) && WORDS[l][o.key] && WORDS[l][o.key].indexOf(msg) >= 0) return true;
    }
    return false;
  }
  function langName(code) { for (var i = 0; i < LANGS.length; i++) if (LANGS[i][0] === code) return LANGS[i]; return LANGS[0]; }
  function setLang(code) {
    if (!L || !L.lang) return;
    ui.lang = code;
    L.lang(code);
    if (code !== "de") claimResetForLang();
    if (isSuggestion(ui.message)) {
      var o = ui.occasion || OCCASIONS[OCCASIONS.length - 1];
      ui.message = wordsFor(o)[0];
      L.text("message", ui.message);
    }
    track("ptn_lang", { lang: code });
    if (opened) { renderStep(); updateBar(); }
    saveDraft(); liveSync();
  }
  /* kompakt: kleine Flagge rechts neben "Von", Auswahl als kleines Menue */
  function langMini() {
    var cur = langName(ui.lang || "de");
    var box = el("div", "ptn-langmini");
    var t = el("button", "ptn-langmini-btn"); t.type = "button";
    t.setAttribute("aria-label", "Sprache des Zertifikats: " + cur[1] + " \u2013 \u00e4ndern");
    t.appendChild(el("span", "ptn-langmini-flag", cur[2]));
    t.appendChild(el("span", "", (ui.lang || "de").toUpperCase() + " \u25be"));
    on(t, "click", function (e) {
      e.preventDefault();
      var sh = sheet("Sprache des Zertifikats", "ptn-sheet--lang");
      LANGS.forEach(function (lg) {
        var b = el("button", "ptn-langmini-opt" + ((ui.lang || "de") === lg[0] ? " is-on" : ""), lg[2] + "  " + lg[1]); b.type = "button";
        on(b, "click", function (ev) { ev.preventDefault(); sh.close(); if ((ui.lang || "de") !== lg[0]) setLang(lg[0]); });
        sh.body.appendChild(b);
      });
      sh.body.appendChild(el("p", "ptn-langmini-hint", "Texte und Zertifikat erscheinen in der gew\u00e4hlten Sprache. Den Gru\u00dftext kannst du jederzeit selbst anpassen."));
    });
    box.appendChild(t);
    return box;
  }
  /* Claude 03.11.2026 (Leslie): Sprachwahl sichtbar in Schritt 1 */
  function langControl() {
    var box = el("div", "ptn-lang"), now = ui.lang || "de";
    box.appendChild(el("span", "ptn-field-label", "Zertifikat auf"));
    var row = el("div", "ptn-lang-row");
    LANGS.forEach(function (lg) {
      var b = el("button", "ptn-mini" + (now === lg[0] ? " is-on" : ""), lg[2] + " " + lg[1]); b.type = "button";
      b.setAttribute("aria-pressed", String(now === lg[0]));
      on(b, "click", function () { if ((ui.lang || "de") !== lg[0]) setLang(lg[0]); });
      row.appendChild(b);
    });
    box.appendChild(row);
    if (now !== "de") box.appendChild(el("p", "ptn-hint", "Namen und Widmung schreibst du wie gewünscht – alle festen Texte auf Zertifikat und Infoblatt erscheinen in der gewählten Sprache. Die Vorschau lädt dann einen Moment."));
    return box;
  }

  function stepNames() {
    head("Wer schenkt wem einen Baum?");
    var f1 = field("Von", ui.sender, "Dein Name, z. B. Anna", function (v) { ui.sender = v; if (L) L.text("sender", v); autoVerb(); updateBar(); refreshNavLock(); }, { maxLength: 70, multiline: true, rows: 1, lines: 2, region: "names" });
    body.appendChild(photoSlot("sender", f1));
    var f2 = field("F\u00fcr", ui.recipient, "z. B. Paul", function (v) { ui.recipient = v; if (L) L.text("recipient", v); updateBar(); refreshNavLock(); }, { maxLength: 70, multiline: true, rows: 1, lines: 2, region: "names" });
    body.appendChild(photoSlot("recipient", f2));
    body.appendChild(el("p", "ptn-tip", "Tipp: „Anna & Tom“ oder „Familie Müller“ geht auch."));
    body.appendChild(langControl());
  }

  /* Claude 24.10.2026: hat/haben, Satz und Sprache als eigener Schritt – Schritt 1 nur noch Namen */
  function stepSentence() {
    head("So steht es auf dem Zertifikat", "Passt der Satz? Dann einfach auf „Weiter“.");
    sentPv = el("p", "ptn-sent-pv", claimSentence());
    sentPv.setAttribute("aria-live", "polite");
    body.appendChild(sentPv);
    body.appendChild(el("span", "ptn-field-label", "Schenkst du allein oder gemeinsam?"));
    verbBox = el("div", "ptn-verb");
    verbBox.setAttribute("role", "group");
    verbBox.setAttribute("aria-label", "hat oder haben");
    body.appendChild(verbBox);
    claimBox = el("div", "ptn-claim");
    body.appendChild(claimBox);
    ui.claimInline = true; /* Claude 03.11.2026 (Leslie): Satz-Optionen direkt offen */
    renderVerb();
  }

  function stepQuick() {
    if (!L) return;
    if (!ui.message) { ui.message = wordsFor(ui.occasion || OCCASIONS[OCCASIONS.length - 1])[0]; L.text("message", ui.message); }
    var st = L.state(), ex = {}; try { ex = L.exportState() || {}; } catch (e) {}
    head("Fertig! So sieht dein Zertifikat aus");
    var fo = null; for (var i = 0; i < FORESTS.length; i++) if (FORESTS[i].key === ex.forest) fo = FORESTS[i];
    var mo = null, all = []; try { all = L.motifs() || []; } catch (e) {}
    for (var j = 0; j < all.length; j++) if (all[j].key === st.motif || all[j].key === ex.motif) mo = all[j];
    var n = Number(ex.trees || 1), msg = String(ui.message || "").replace(/\s*\n\s*/g, " ");
    var snd = String(ui.sender || "").replace(/\s*\n\s*/g, " & "), rcp = String(ui.recipient || "").replace(/\s*\n\s*/g, " & ");
    var claim = ""; try { claim = String(L.claimText() || ""); } catch (e) {}
    var gt = st.gift ? (typeof st.gift === "string" ? st.gift : ((st.giftDetails && st.giftDetails.title) || "Dein Geschenk")) : "";
    /* [Symbol, Titel, Wert, Schritt, Aktion, Ziel im Schritt] */
    var rows = [];
    rows.push(["👤", "Namen", (ui.photos.sender ? "Bild" : snd) + " → " + (ui.photos.recipient ? "Bild" : rcp), "names", "ändern", ""]);
    rows.push(["💬", "Satz", ((ui.photos.sender ? "" : snd + " ") + (claim || "hat f\u00fcr") + " " + (ui.photos.recipient ? "" : rcp) + " \u2026").replace(/\s+/g, " "), "sentence", "\u00e4ndern", ""]);
    rows.push(["✍️", "Widmung", msg || "keine", "words", "ändern", ""]);
    rows.push(["🌲", "Pflanzort", fo ? fo.title + " · " + fo.region : "Bayern", "place", "ändern", ""]);
    rows.push(["🌳", "Bäume", n + (n === 1 ? " Baum" : " Bäume"), "trees", "mehr pflanzen", ""]);
    rows.push(["🎨", "Motiv & Farbe", ((mo && (mo.label || mo.name || mo.title)) || "Eiche") + (st.deco ? " · mit Verzierung" : ""), "design", "ändern", ""]);
    if (!st.gift) rows.push(["📄", "Format", (st.deliveryLabel || "Digital als PDF"), "format", "gedruckt oder gerahmt?", ".ptn-formats"]);
    rows.push(["💌", "Grußkarte", st.greeting ? "ist dabei" : "noch keine (+" + euro(st.greetingPrice || 3.5) + ")", "format", st.greeting ? "ändern" : "hinzufügen", ".ptn-greetrow"]);
    if (!st.gift && !isGiftPage) rows.push(["🎁", "Geschenk dazu", "noch keins", "format", "Geschenke ansehen", ".ptn-gifts"]);
    var list = el("div", "ptn-qlist");
    /* Claude 28.10.2026 (Leslie): Papierart (gedruckt) bzw. Optik (digital) direkt umschalten */
    var pDig = !st.gift && st.delivery === "digital", pKey = st.paper || "white";
    var prow = el("div", "ptn-qrow ptn-qrow--paper");
    prow.appendChild(el("span", "ptn-qic", "📃"));
    var ptx = el("span", "ptn-qtx"); ptx.appendChild(el("small", "", pDig ? "Optik" : "Papierart")); ptx.appendChild(el("strong", "", pKey === "grass" ? "Graspapier" : "Weißes Papier")); prow.appendChild(ptx);
    var pseg = el("span", "ptn-qseg");
    [["white", "Weiß"], ["grass", pDig ? "Gras" : "Gras +1 €"]].forEach(function (o) {
      var pb = el("button", "ptn-qsegb" + (pKey === o[0] ? " is-on" : ""), o[1]); pb.type = "button"; pb.setAttribute("aria-pressed", String(pKey === o[0]));
      on(pb, "click", function () { if ((L.state().paper || "white") === o[0]) return; L.paper(o[0]); track("ptn_paper", { paper: o[0], delivery: st.delivery, quick: 1 }); afterLook(); });
      pseg.appendChild(pb);
    });
    prow.appendChild(pseg);
    var pAfter = st.gift ? "design" : "format";
    rows.forEach(function (r) {
      var b = el("button", "ptn-qrow"); b.type = "button";
      b.appendChild(el("span", "ptn-qic", r[0]));
      var t = el("span", "ptn-qtx"); t.appendChild(el("small", "", r[1])); t.appendChild(el("strong", "", r[2])); b.appendChild(t);
      b.appendChild(el("span", "ptn-qgo", r[4] + " \u203a"));
      on(b, "click", function () {
        ui.qPart = { ".ptn-formats": "format", ".ptn-greetrow": "greet", ".ptn-gifts": "gift", ".ptn-giftbox": "gift" }[r[5]] || null;
        track("ptn_quick_edit", { to: r[3] + (ui.qPart ? ":" + ui.qPart : "") }); ui.qEdit = true; goStep(stepIx(r[3]));
      });
      list.appendChild(b);
      if (r[3] === pAfter && (st.gift || r[5] === ".ptn-formats")) list.appendChild(prow);
    });
    if (!prow.parentNode) list.appendChild(prow);
    body.appendChild(list);
    if (st.gift) {  /* Claude 28.10.2026: Geschenk, Etikett und Zusatzoptionen direkt sichtbar */
      body.appendChild(el("p", "ptn-qgift-h", "🎁 Dein Geschenk mit Baum"));
      renderSelectedGift(st);
      formatExtras(st);
    }
    var more = el("button", "ptn-qmore", "Schritt f\u00fcr Schritt weiter gestalten \u203a"); more.type = "button";
    on(more, "click", function () { track("ptn_quick_edit", { to: "words" }); ui.qEdit = false; ui.qPart = null; ui.qLong = true; goStep(stepIx("words")); });
    var pp = el("button", "ptn-paypal ptn-qpp"); pp.type = "button";
    pp.appendChild(el("span", "ptn-paypal-pre", "Oder direkt bezahlen mit"));
    pp.appendChild(el("strong", "ptn-paypal-logo", "PayPal"));
    on(pp, "click", function () { track("ptn_quick_paypal", {}); buy("paypal"); });
    /* Claude 02.11.2026 (Leslie): erst Hinweis, dann Baum-Botschaft, dann PayPal - ganz unten der Warenkorb-Knopf */
    bbxCard();
    /* Claude 02.11.2026 (Leslie): Versand-Hinweis direkt vor PayPal; bei digital deutlich "nichts gedruckt" */
    if (!st.gift && st.delivery === "digital") {
      var dg = el("div", "ptn-tip ptn-tip--digital");
      dg.appendChild(el("strong", "", "📄 Nur digital – es wird nichts gedruckt oder verschickt."));
      dg.appendChild(el("span", "", " Du bekommst das Zertifikat sofort als PDF per E-Mail – zum Selbst-Ausdrucken oder Weiterleiten."));
      var dgb = el("button", "ptn-tip-link", "Lieber gedruckt in der Mappe oder gerahmt? Format ändern ›"); dgb.type = "button";
      on(dgb, "click", function () { track("ptn_quick_edit", { to: "format:format", src: "digital_hint" }); ui.qPart = "format"; ui.qEdit = true; goStep(stepIx("format")); });
      dg.appendChild(dgb);
      body.appendChild(dg);
    } else body.appendChild(el("p", "ptn-tip", st.gift ? "📦 Das Geschenk kommt mit gedrucktem Zertifikat per Post – den Baum pflanzen wir im heimischen Wald." : "📦 Das Zertifikat wird gedruckt und per Post verschickt."));
    body.appendChild(pp);
  }
  function stepWords() {
    head("Deine persönlichen Worte", "Tippe auf einen Vorschlag oder schreib selbst.");
    var o = ui.occasion || OCCASIONS[OCCASIONS.length - 1];
    var chips = el("div", "ptn-chips");
    var f = field("Widmung", ui.message, "z. B. Alles Liebe zum Geburtstag", function (v) { ui.message = v; ui.msgOff = !v; if (L) L.text("message", v); markChips(); }, { multiline: true, rows: 2, maxLength: 80, lines: 2, region: "message" });
    function markChips() {
      var all = chips.querySelectorAll(".ptn-chip");
      for (var i = 0; i < all.length; i++) {
        var v = all[i].getAttribute("data-v");
        all[i].className = "ptn-chip" + (v === null ? " ptn-chip--ghost" : "") + ((v === ui.message) || (v === null && !ui.message) ? " is-on" : "");
      }
    }
    wordsFor(o).forEach(function (w) {
      var c = el("button", "ptn-chip", w.replace(/\n/g, " "));
      c.type = "button"; c.setAttribute("data-v", w);
      on(c, "click", function () { ui.message = w; f.input.value = w; if (L) L.text("message", w); markChips(); saveDraft(); });
      chips.appendChild(c);
    });
    var none = el("button", "ptn-chip ptn-chip--ghost", "Ohne Widmung");
    none.type = "button";
    on(none, "click", function () { ui.message = ""; ui.msgOff = true; f.input.value = ""; if (L) L.text("message", ""); markChips(); saveDraft(); });
    chips.appendChild(none);
    body.appendChild(chips);
    body.appendChild(photoSlot("message", f));
    var occ = el("div", "ptn-occ-inline");
    occ.appendChild(el("span", "ptn-field-label", "Anderer Anlass"));
    OCCASIONS.forEach(function (x) {
      if (x === o) return;
      var b = el("button", "ptn-mini", x.icon + " " + x.label); b.type = "button";
      on(b, "click", function () { ui.occasion = x; xmasDesign(); if (wordsFor(x).length) { ui.message = wordsFor(x)[0]; if (L) L.text("message", ui.message); } renderStep(); updateBar(); saveDraft(); });
      occ.appendChild(b);
    });
    body.appendChild(occ);
    markChips();
  }

  function stepPlace() {
    var st = L.state();
    head(BIRTH && bData().name ? "Wo soll der Baum für " + bData().name.split(" ")[0] + " wachsen?" : "Wo soll dein Baum wachsen?", "Unsere Forstpartner pflanzen und pflegen vor Ort. " + (BIRTH ? "Der Pflanzort steht auf der Urkunde." : "Der Pflanzort steht auf deinem Zertifikat."));
    var list = el("div", "ptn-forests");
    FORESTS.forEach(function (fo) {
      var sel = st.forest === fo.key;
      var row = el("div", "ptn-forest-row");
      var b = el("button", "ptn-forest" + (sel ? " is-on" : ""));
      b.type = "button";
      b.setAttribute("aria-pressed", String(sel));
      b.appendChild(el("strong", "", fo.title));
      b.appendChild(el("span", "", fo.short + " · " + fo.region));
      on(b, "click", function () { L.forest(fo.key); renderStep(); updateBar(); saveDraft(); });
      var info = el("button", "ptn-forest-info", "Infos & Karte \u203a");
      info.type = "button";
      info.setAttribute("aria-label", "Mehr über den " + fo.title + " und Karte");
      on(info, "click", function () { forestSheet(fo); });
      row.appendChild(b); row.appendChild(info);
      list.appendChild(row);
    });
    body.appendChild(list);
    var mapLink = el("button", "ptn-link ptn-link--map", "Alle Pflanzorte auf der Karte ansehen");
    mapLink.type = "button";
    on(mapLink, "click", function () { forestSheet(null); });
    body.appendChild(mapLink);
  }

  var TREE_ICON = '<svg viewBox="0 0 20 24" width="16" height="20" aria-hidden="true" focusable="false"><path d="M10 1.5c3.6 0 6.5 2.9 6.5 6.4 0 .7-.1 1.3-.3 1.9 1.5.9 2.5 2.5 2.5 4.3 0 2.8-2.3 5-5.1 5H6.4c-2.8 0-5.1-2.2-5.1-5 0-1.8 1-3.4 2.5-4.3-.2-.6-.3-1.2-.3-1.9 0-3.5 2.9-6.4 6.5-6.4z" fill="currentColor"/><rect x="9" y="15" width="2" height="8" rx="1" fill="currentColor"/></svg>';
  function stepTrees() {
    var st = L.state();
    var extra = st.extraTreePrice || 12;
    head("Wie viele Bäume sollen wachsen?", "Jeder Baum wird von unseren Forstpartnern gepflanzt und gepflegt. Alle Bäume stehen gemeinsam auf einem Zertifikat.");
    var grid = el("div", "ptn-treegrid");
    [1, 3, 5, 10].forEach(function (n) {
      var sel = st.trees === n;
      var b = el("button", "ptn-treeopt" + (sel ? " is-on" : ""));
      b.type = "button"; b.setAttribute("aria-pressed", String(sel));
      var ic = el("span", "ptn-treeopt-icons"); var html = ""; for (var k = 0; k < Math.min(n, 5); k++) html += TREE_ICON; ic.innerHTML = html; b.appendChild(ic);
      b.appendChild(el("strong", "", n === 1 ? "1 Baum" : n + " Bäume"));
      b.appendChild(el("span", "ptn-treeopt-price", euro(st.total + (n - st.trees) * extra)));
      on(b, "click", function () { L.trees(n); renderStep(); updateBar(); saveDraft(); });
      grid.appendChild(b);
    });
    body.appendChild(grid);
    var trees = el("div", "ptn-trees");
    trees.appendChild(el("span", "ptn-field-label", "Andere Anzahl"));
    var srow = el("div", "ptn-stepper");
    var minus = el("button", "", "−"); minus.type = "button"; minus.setAttribute("aria-label", "Einen Baum weniger");
    var count = el("span", "ptn-count", String(st.trees));
    var plus = el("button", "", "+"); plus.type = "button"; plus.setAttribute("aria-label", "Einen Baum mehr");
    minus.disabled = st.trees <= 1;
    on(minus, "click", function () { L.trees(Math.max(1, L.state().trees - 1)); renderStep(); updateBar(); saveDraft(); });
    on(plus, "click", function () { L.trees(L.state().trees + 1); renderStep(); updateBar(); saveDraft(); });
    srow.appendChild(minus); srow.appendChild(count); srow.appendChild(plus);
    trees.appendChild(srow);
    trees.appendChild(el("p", "ptn-hint", "Jeder weitere Baum " + euro(extra) + "."));
    body.appendChild(trees);
  }

  var MOTIF_GROUPS = [["trees", "Bäume"], ["flowers", "Blumen"], ["gifts", "Geschenke"], ["forest", "Wald & Tiere"], ["decor", "Anlässe & Deko"]];
  (function () { var d = new Date(), m = d.getMonth(); if (m === 10 || m === 11 || (m === 0 && d.getDate() <= 6)) MOTIF_GROUPS.unshift(["xmas", "🎄 Weihnachten"]); else MOTIF_GROUPS.push(["xmas", "Weihnachten"]); })();
  var BORDERS = [["#337451", "Waldgrün"], ["#1f5a3a", "Tannengrün"], ["#8e1f27", "Weihnachtsrot"], ["#264b64", "Blau"], ["#93495b", "Beere"], ["#b28b45", "Gold"], ["#565650", "Grau"]];
  var DECO_GROUPS = [["xmas", "🎄 Weihnachten"], ["party", "🎈 Geburtstag & Feier"], ["love", "💍 Hochzeit & Liebe"], ["baby", "👶 Geburt"], ["nature", "🌳 Wald & Blumen"], ["memory", "🕯️ Erinnerung"]];
  var DECO_BY_OCC = { weihnachten: "xmas", geburtstag: "party", hochzeit: "love", geburt: "baby", danke: "nature", einfach: "nature", erinnerung: "memory" };
  function stepDesign() {
    var st = L.state();
    head("Gestalte dein Zertifikat", "Motiv, Rahmenfarbe und Verzierung – alles optional.");
    /* Verzierung oben, nach Themen. Der Reiter folgt dem Anlass, automatisch gesetzt wird nur bei Weihnachten. */
    var topDecos = [];
    try { topDecos = (L.decos && L.decos()) || []; } catch (e) {}
    if (topDecos.length) {
      var secTop = el("div", "ptn-sec");
      secTop.appendChild(el("span", "ptn-field-label", "Verzierung oben"));
      var topTabs = el("div", "ptn-tabs"), topGrid = el("div", "ptn-decos"), topHint = el("p", "ptn-hint", "Die Verzierung liegt über deinem Bild. Stört sie? Wähle „Keine“ oder mach dein Bild kleiner.");
      topHint.style.display = "none"; topHint.style.marginTop = "10px";
      var occKey = ui.occasion ? ui.occasion.key : "", decoNow = L.state().deco || "", dNowM = new Date().getMonth(), decoTab = "";
      topDecos.forEach(function (d) { if (d.key === decoNow) decoTab = d.group; });
      if (!decoTab) decoTab = DECO_BY_OCC[occKey] || (dNowM === 10 || dNowM === 11 ? "xmas" : "nature");
      var drawTop = function () {
        clear(topTabs); clear(topGrid);
        var nowTop = L.state().deco || "";
        setTimeout(function () { topHint.style.display = L.decoOver && L.decoOver() ? "" : "none"; }, 150);
        DECO_GROUPS.forEach(function (g) {
          var t = el("button", "ptn-tab" + (decoTab === g[0] ? " is-on" : ""), g[1]); t.type = "button";
          on(t, "click", function () { decoTab = g[0]; drawTop(); });
          topTabs.appendChild(t);
        });
        [{ key: "", label: "Keine" }].concat(topDecos.filter(function (d) { return d.group === decoTab; })).forEach(function (d) {
          var b = el("button", "ptn-decobtn" + (d.key === nowTop ? " is-on" : "") + (d.key ? "" : " is-none"));
          b.type = "button"; b.setAttribute("aria-pressed", String(d.key === nowTop));
          if (d.image) { var im = el("img"); im.src = d.image; im.alt = ""; im.setAttribute("loading", "lazy"); b.appendChild(im); }
          b.appendChild(el("span", "", d.label));
          if (d.full) b.appendChild(el("span", "ptn-decofull", "durchgehend"));
          on(b, "click", function () { L.deco(d.key); drawTop(); saveDraft(); track("ptn_deco", { deco: d.key || "keine" }); });
          topGrid.appendChild(b);
        });
      };
      drawTop();
      secTop.appendChild(topTabs); secTop.appendChild(topGrid);
      secTop.appendChild(topHint);
      body.appendChild(secTop);
    }
    /* Motiv */
    var all = [];
    try { all = L.motifs() || []; } catch (e) {}
    var cur = null;
    for (var i = 0; i < all.length; i++) if (all[i].key === st.motif) cur = all[i];
    if (!ui.motifGroup) ui.motifGroup = cur ? cur.group : "trees";
    var sec = el("div", "ptn-sec");
    sec.appendChild(el("span", "ptn-field-label", "Motiv in der Mitte"));
    var tabs = el("div", "ptn-tabs");
    var grid = el("div", "ptn-motifs");
    function drawMotifs() {
      clear(tabs); clear(grid);
      var now = L.state().motif;
      MOTIF_GROUPS.forEach(function (g) {
        var t = el("button", "ptn-tab" + (ui.motifGroup === g[0] ? " is-on" : ""), g[1]); t.type = "button";
        on(t, "click", function () { ui.motifGroup = g[0]; drawMotifs(); });
        tabs.appendChild(t);
      });
      all.forEach(function (m) {
        if (m.group !== ui.motifGroup) return;
        var b = el("button", "ptn-motif" + (m.key === now ? " is-on" : ""));
        b.type = "button"; b.setAttribute("aria-pressed", String(m.key === now)); b.setAttribute("aria-label", m.label);
        var im = el("img"); im.src = m.image; im.alt = ""; im.setAttribute("loading", "lazy");
        b.appendChild(im); b.appendChild(el("span", "", m.label));
        on(b, "click", function () { L.motif(m.key); drawMotifs(); saveDraft(); track("ptn_motif", { motif: m.key }); });
        grid.appendChild(b);
      });
    }
    drawMotifs();
    sec.appendChild(tabs); sec.appendChild(grid);
    body.appendChild(sec);
    /* Rahmenfarbe */
    var sec2 = el("div", "ptn-sec");
    sec2.appendChild(el("span", "ptn-field-label", "Rahmenfarbe"));
    var sw = el("div", "ptn-swatches");
    function drawSw() {
      clear(sw);
      var now = String(L.state().border || "").toLowerCase();
      var known = false;
      BORDERS.forEach(function (c) {
        var on_ = now === c[0]; if (on_) known = true;
        var b = el("button", "ptn-swatch" + (on_ ? " is-on" : "")); b.type = "button";
        b.style.backgroundColor = c[0]; b.setAttribute("aria-label", c[1]); b.setAttribute("aria-pressed", String(on_)); b.title = c[1];
        on(b, "click", function () { L.border(c[0]); drawSw(); saveDraft(); });
        sw.appendChild(b);
      });
      var custom = el("label", "ptn-swatch ptn-swatch--custom" + (!known ? " is-on" : ""));
      custom.title = "Eigene Farbe";
      if (!known) custom.style.backgroundColor = now;
      var ci = el("input"); ci.type = "color"; ci.value = /^#[0-9a-f]{6}$/.test(now) ? now : "#337451"; ci.setAttribute("aria-label", "Eigene Rahmenfarbe");
      on(ci, "input", function () { L.border(ci.value); custom.style.backgroundColor = ci.value; });
      on(ci, "change", function () { L.border(ci.value); drawSw(); saveDraft(); });
      custom.appendChild(ci);
      sw.appendChild(custom);
    }
    drawSw();
    sec2.appendChild(sw);
    body.appendChild(sec2);
    /* Verzierung */
    var sec3 = el("div", "ptn-sec");
    sec3.appendChild(el("span", "ptn-field-label", "Verzierung"));
    var seg = el("div", "ptn-verb ptn-deco");
    function drawDeco() {
      clear(seg);
      var h = L.state().hearts !== false;
      [[true, "♥", "Herzen"], [false, "•", "Punkte"]].forEach(function (o) {
        var b = el("button", "ptn-seg" + (h === o[0] ? " is-on" : "")); b.type = "button"; b.setAttribute("aria-pressed", String(h === o[0]));
        b.appendChild(el("strong", "", o[1])); b.appendChild(el("span", "", o[2]));
        on(b, "click", function () { L.hearts(o[0]); drawDeco(); saveDraft(); });
        seg.appendChild(b);
      });
    }
    drawDeco();
    sec3.appendChild(seg);
    body.appendChild(sec3);
  }

  /* Claude 26.10.2026 (Wunsch Leslie): Hinweis "Baum-Botschaft immer inklusive" im Format-Schritt mit Beispiel im Smartphone.
     Video = assets/pt-bb-demo.mp4 (wie Teaser auf Startseite), Live-Demo /pages/fuer-dich?demo=1 im neuen Tab (Gestaltung bleibt erhalten). */
  var BBX_BASE = (function () {
    var sc = document.querySelector('script[src*="/pt-neu.js"]'), u = sc ? sc.getAttribute("src") : "";
    return u ? u.replace(/pt-neu\.js.*$/, "") : "";
  })();
  /* Claude 27.10.2026 (Leslie): statt Beispielvideo die ECHTE Ueberraschung mit den eingegebenen Namen, Wald und Baumzahl (pt-bb-mock.js, echtes Zertifikat
     wird nebenbei gerendert). Geburtsurkunde bleibt beim Beispielvideo. */
  function bbxShow() {
    if (!BIRTH && L && L.payload) {
      var go = function () { var ok = false; try { ok = !!(window.ptBbMock && window.ptBbMock.openEngine(L)); } catch (e) {} if (ok) track("ptn_bbx_open", { real: 1 }); else bbxVideo(); };
      if (window.ptBbMock) { go(); return; }
      /* Template + versionierte Skript-Adresse holen (unversionierte Asset-URLs liefert das CDN noch alt aus) */
      var x = new XMLHttpRequest(); x.open("GET", "/pages/fuer-dich?view=bbmock", true);
      x.onload = function () {
        var t = null; if (x.status === 200) { var dv = document.createElement("div"); dv.innerHTML = x.responseText; t = dv.querySelector("#pt-bb-mock-tpl"); }
        if (!t || !t.getAttribute("data-mock")) { bbxVideo(); return; }
        document.body.appendChild(t);
        var s = document.createElement("script"); s.src = t.getAttribute("data-mock"); s.onload = go; s.onerror = bbxVideo; document.body.appendChild(s);
      };
      x.onerror = bbxVideo; x.send();
      return;
    }
    bbxVideo();
  }
  function bbxVideo() {
    var ov = document.getElementById("ptn-bbx-ov");
    if (!ov) {
      ov = el("div", "ptn-bbx-ov"); ov.id = "ptn-bbx-ov";
      ov.setAttribute("role", "dialog"); ov.setAttribute("aria-modal", "true"); ov.setAttribute("aria-label", "Beispiel: die Baum-Botschaft");
      var box = el("div", "ptn-bbx-box");
      var x = el("button", "ptn-bbx-x", "×"); x.type = "button"; x.setAttribute("aria-label", "Schließen");
      var ph = el("div", "ptn-bbx-phone"), scr = el("div", "ptn-bbx-screen");
      var v = document.createElement("video");
      v.setAttribute("playsinline", ""); v.setAttribute("controls", ""); v.setAttribute("preload", "none");
      v.poster = BBX_BASE + "pt-bb-demo-poster.jpg"; v.src = BBX_BASE + "pt-bb-demo.mp4";
      scr.appendChild(v); ph.appendChild(el("span", "ptn-bbx-notch")); ph.appendChild(scr);
      var cap = el("p", "ptn-bbx-cap", "So sieht die Überraschung beim Beschenkten aus – mit euren Namen und Annes Stimme.");
      var live = el("a", "ptn-bbx-live", "👀 Live ausprobieren ↗"); live.href = "/pages/fuer-dich?demo=1"; live.target = "_blank"; live.rel = "noopener";
      on(live, "click", function () { track("ptn_bbx_live", {}); });
      box.appendChild(x); box.appendChild(ph); box.appendChild(cap); box.appendChild(live); ov.appendChild(box);
      document.body.appendChild(ov);
      var close = function () { try { v.pause(); } catch (e) {} ov.style.display = "none"; };
      on(x, "click", close);
      on(ov, "click", function (e) { if (e.target === ov) close(); });
      on(document, "keydown", function (e) { if (ov.style.display !== "none" && (e.key === "Escape" || e.keyCode === 27)) close(); });
    }
    ov.style.display = "";
    var vid = ov.querySelector("video");
    try { vid.currentTime = 0; var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
    track("ptn_bbx_open", {});
  }
  function bbxCard() {
    var c = el("button", "ptn-bbx"); c.type = "button";
    c.setAttribute("aria-label", "Beispiel ansehen: die Baum-Botschaft, immer inklusive");
    var ph = el("span", "ptn-bbx-mini");
    var im = el("img"); im.alt = ""; im.src = BBX_BASE + "pt-bb-demo-poster.jpg"; im.setAttribute("loading", "lazy");
    ph.appendChild(im); ph.appendChild(el("span", "ptn-bbx-play", "▶"));
    var t = el("span", "ptn-bbx-text");
    t.appendChild(el("small", "ptn-bbx-eyebrow", "Immer inklusive 🎁"));
    t.appendChild(el("strong", "", "Die Baum-Botschaft fürs Handy"));
    t.appendChild(el("span", "ptn-bbx-desc", "Försterin Anne zeigt mit euren Namen, wo der Baum wächst – zum Verschicken per WhatsApp, SMS oder E-Mail."));
    t.appendChild(el("span", "ptn-bbx-opt", "✏️ Optional mit Foto, Brief, Sprachnachricht oder Video – geht auch noch nach dem Kauf."));
    var bbxTo = BIRTH ? "" : String(ui.recipient || "").replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "");
    t.appendChild(el("span", "ptn-bbx-link", bbxTo ? "▶ Überraschung für " + (bbxTo.length > 22 ? bbxTo.slice(0, 21) + "…" : bbxTo) + " ansehen & anpassen" : "▶ Beispiel ansehen"));
    c.appendChild(ph); c.appendChild(t);
    on(c, "click", bbxShow);
    body.appendChild(c);
  }

  function stepFormatPart(part) {
    var st = L.state();
    if (part === "greet") {
      head("Grußkarte dazu?", "Mit passendem Bild und Text zum Anlass – alles anpassbar.");
      formatGreeting(st); return;
    }
    if (part === "gift") {
      head(st.gift ? "Dein Geschenk" : "Ein Geschenk dazu?", st.gift ? "Baum und gedrucktes Zertifikat liegen dem Geschenk bei." : "Optional – Baum und Zertifikat sind immer dabei.");
      if (st.gift) { renderSelectedGift(st); formatExtras(st); } else renderGiftIdeas();
      return;
    }
    head("Wie möchtest du schenken?", "Baumpflanzung und Zertifikat sind immer dabei.");
    previewControls(st);
    formatOptions(st);
    formatPaper(st);
  }
  function formatOptions(st) {
      var opts = el("div", "ptn-formats");
      [["digital", "Digital als PDF", "Sofort nach dem Kauf herunterladen", st.digital],
       ["print", "Gedruckt", "In einer Urkundenmappe", st.print],
       ["framed", "Gerahmt", "Fertig zum Aufstellen oder Aufhängen", st.framed]].forEach(function (f) {
        var sel = st.delivery === f[0];
        var b = el("button", "ptn-format" + (sel ? " is-on" : ""));
        b.type = "button"; b.setAttribute("aria-pressed", String(sel));
        var t = el("span", "ptn-format-text");
        t.appendChild(el("strong", "", f[1])); t.appendChild(el("small", "", f[2]));
        b.appendChild(t); b.appendChild(el("span", "ptn-format-price", euro(f[3] + (f[0] !== "digital" && st.paper === "grass" ? 1 : 0))));
        on(b, "click", function () {
          Promise.resolve(L.delivery(f[0])).then(function () { applyLook(); renderStep(); updateBar(); saveDraft(); }).catch(function (e) { flash(e && e.message); });
        });
        opts.appendChild(b);
      });
      body.appendChild(opts);
      if (st.delivery !== "digital") body.appendChild(el("p", "ptn-hint", "Zzgl. Versand · Lieferung in 1–3 Werktagen."));
      if (st.delivery === "framed") formatFrames(st);
  }
  function stepFormat() {
    if (QUICK && ui.qEdit && ui.qPart) { stepFormatPart(ui.qPart); return; }
    var st = L.state();
    head(BIRTH ? "Wie möchtest du die Urkunde überreichen?" : "Wie möchtest du schenken?", BIRTH ? "Baumpflanzung und Geburtsurkunde sind immer dabei." : "Baumpflanzung und Zertifikat sind immer dabei.");
    previewControls(st);
    if (st.gift) {
      renderSelectedGift(st);
    } else formatOptions(st);
    formatPaper(st);
    formatExtras(st);
    formatGreeting(st);
    var pp = el("button", "ptn-paypal");
    pp.type = "button";
    pp.appendChild(el("span", "ptn-paypal-pre", "Direkt bezahlen mit"));
    pp.appendChild(el("strong", "ptn-paypal-logo", "PayPal"));
    on(pp, "click", function () { buy("paypal"); });
    if (!st.gift && !isGiftPage) renderGiftIdeas();
    bbxCard();  /* Claude 02.11.2026 (Leslie): Baum-Botschaft unten direkt vor PayPal */
    body.appendChild(pp);
    var tl = el("button", "ptn-tpl-hint"); tl.type = "button";
    tl.appendChild(el("strong", "", "Bestellst du öfter?"));
    tl.appendChild(el("span", "", " Als Vorlage für nächstes Mal speichern ›"));
    on(tl, "click", tplSheet);
    if (!BIRTH) body.appendChild(tl);
  }
  /* ---------- Geburtsurkunde: Schritte ---------- */
  function bErrorBox(wrap) {
    var e = el("p", "ptn-ferr");
    e.style.display = "none";
    e.setAttribute("role", "alert");
    wrap.appendChild(e);
    return function (msg) { e.textContent = msg || ""; e.style.display = msg ? "" : "none"; };
  }
  function bCheckField(key, show) {
    var p = bProblem();
    show(p && p[0] === key ? p[1] : "");
  }
  function stepChild() {
    head("Für wen wächst der Baum?", "Name und Geburtstag stehen groß auf der Urkunde.");
    var f1 = field("Vorname und Name des Kindes", B.name, "z. B. Mila Sophie Meier", function (v) { bSet("name", v.replace(/[\r\n]+/g, " ")); }, { maxLength: 60, multiline: true, rows: 1, lines: 1, region: "bname" });
    body.appendChild(f1.wrap);
    var f2 = field("Geburtsdatum", "", "TT.MM.JJJJ", function (v) { bSet("date", bParseDate(v)); }, { region: "bdate" });
    var native = false;
    try { f2.input.type = "date"; native = f2.input.type === "date"; } catch (e) {}
    if (native) { f2.input.min = "1900-01-01"; f2.input.max = bToday(); f2.input.value = bDateOk(B.date) ? B.date : ""; addCls(f2.input, "ptn-input--date"); }
    else { f2.input.value = bDateText(B.date); f2.input.setAttribute("inputmode", "numeric"); }
    var showDate = bErrorBox(f2.wrap);
    on(f2.input, "blur", function () { if (f2.input.value) bCheckField("date", showDate); });
    on(f2.input, "input", function () { showDate(""); });
    body.appendChild(f2.wrap);
    var mw = el("div", "ptn-field ptn-bmotif-field");
    mw.appendChild(el("p", "ptn-field-label", "Motiv"));
    bMotifBox = el("div", "ptn-bmotifs");
    bMotifBox.setAttribute("role", "group");
    bMotifBox.setAttribute("aria-label", "Motiv der Urkunde");
    [["reh", "Reh"], ["fuchs", "Fuchs"]].forEach(function (m) {
      var b = el("button", "ptn-bmotif");
      b.type = "button";
      b.setAttribute("data-motif", m[0]);
      var im = el("img"); im.alt = ""; im.src = bAssets + "pt-birth-" + m[0] + "-motif.png"; im.setAttribute("loading", "lazy");
      var sw = el("span", "ptn-bmotif-sw"); sw.style.background = B_PAL[m[0]].frame;
      b.appendChild(im); b.appendChild(el("strong", "", m[1])); b.appendChild(sw);
      on(b, "click", function () { B.motif = m[0]; B.motifManual = true; bNameReq++; bMotifSync(); bChanged(); track("ptn_birth_motif", { motif: m[0] }); });
      bMotifBox.appendChild(b);
    });
    mw.appendChild(bMotifBox);
    body.appendChild(mw);
    bMotifSync();
    body.appendChild(el("p", "ptn-tip", "Das Motiv schlagen wir passend zum Vornamen vor – du kannst es jederzeit wechseln."));
  }
  function stepDetails() {
    var nm = bData().name.split(" ")[0];
    head(nm ? "Was gehört noch zu " + nm + "s Geburt?" : "Was gehört noch zur Geburt?", "Alles freiwillig – leere Felder bleiben auf der Urkunde einfach frei.");
    function unitField(key, label, ph, unit, mode) {
      var f = field(label, B[key], ph, function (v) { bSet(key, v); }, { maxLength: key === "place" ? 40 : 12, region: "bdetail" });
      if (mode) f.input.setAttribute("inputmode", mode);
      if (unit) { addCls(f.wrap, "has-unit"); f.box.appendChild(el("span", "ptn-unit", unit)); }
      var show = bErrorBox(f.wrap);
      on(f.input, "blur", function () {
        var n = bNorm(key, f.input.value);
        if (n !== f.input.value) { f.input.value = n; bSet(key, n); }
        bCheckField(key, show);
      });
      on(f.input, "input", function () { show(""); });
      return f;
    }
    var row = el("div", "ptn-brow");
    var ft = unitField("time", "Uhrzeit", "z. B. 22:32", "Uhr", "decimal");
    var fp = unitField("place", "Geburtsort", "z. B. Hanau", "", "");
    row.appendChild(ft.wrap); row.appendChild(fp.wrap);
    body.appendChild(row);
    var row2 = el("div", "ptn-brow");
    row2.appendChild(unitField("weight", "Gewicht", "z. B. 3450", "g", "decimal").wrap);
    row2.appendChild(unitField("height", "Größe", "z. B. 52", "cm", "decimal").wrap);
    body.appendChild(row2);
    body.appendChild(el("p", "ptn-tip", "Gewicht geht in Gramm oder Kilo („3,45 kg“), die Uhrzeit auch ohne Doppelpunkt („2232“)."));
  }
  /* ---------- Vorlagen: fuer naechstes Mal speichern (Server + Geraet), Link teilen ---------- */
  var TPL_API = "https://partner.planet-tree.de/api2/cert/template/", TPL_KEY = "pt_certificate_templates_v1";
  function tplToken() {
    var c = window.crypto || window.msCrypto;
    if (!c || !c.getRandomValues) throw new Error("Dein Browser kann gerade keinen sicheren Vorlagenlink erstellen.");
    var a = new Uint8Array(32); c.getRandomValues(a);
    var s = ""; for (var i = 0; i < a.length; i++) s += ("0" + a[i].toString(16)).slice(-2);
    return s;
  }
  function tplPost(path, data) {
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest();
      x.open("POST", TPL_API + path, true);
      x.setRequestHeader("Content-Type", "application/json");
      x.timeout = 60000;
      x.onload = function () {
        var j = null; try { j = JSON.parse(x.responseText); } catch (e) {}
        if (x.status >= 200 && x.status < 300 && j && j.ok) res(j);
        else rej(new Error(j && typeof j.detail === "string" ? j.detail : "Das hat gerade nicht geklappt. Bitte erneut versuchen."));
      };
      x.onerror = x.ontimeout = function () { rej(new Error("Die Verbindung ist gerade unterbrochen. Bitte erneut versuchen.")); };
      x.send(JSON.stringify(data));
    });
  }
  function tplRemember(t) {
    try {
      var list = JSON.parse(localStorage.getItem(TPL_KEY) || "[]"); if (!(list instanceof Array)) list = [];
      list = [t].concat(list.filter(function (x) { return x && x.token !== t.token; }));
      localStorage.setItem(TPL_KEY, JSON.stringify(list)); return true;
    } catch (e) { return false; }
  }
  function tplLink(token) {
    /* Auf der Testseite bleibt der Link hier, sonst der gewohnte Startseiten-Link */
    if (/\/pages\/baum-verschenken-neu/.test(location.pathname)) return location.origin + location.pathname + "?vorlage=" + token;
    return location.origin + "/?vorlage=" + token;
  }
  function tplShare(box, t) {
    clear(box);
    var link = tplLink(t.token);
    box.appendChild(el("p", "ptn-tpl-ok", "✓ Gespeichert. Du findest die Vorlage auf diesem Gerät unter „Designs“ – und überall mit deinem persönlichen Link:"));
    var inp = el("input", "ptn-input ptn-tpl-link"); inp.type = "text"; inp.readOnly = true; inp.value = link;
    box.appendChild(inp);
    var row = el("div", "ptn-tpl-acts");
    var cp = el("button", "ptn-sheet-secondary", "Link kopieren"); cp.type = "button";
    on(cp, "click", function () {
      function sel() { inp.focus(); inp.select(); try { inp.setSelectionRange(0, inp.value.length); } catch (e) {} var ok = false; try { ok = document.execCommand("copy"); } catch (e) {} cp.textContent = ok ? "Kopiert ✓" : "Link markiert – bitte kopieren"; }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(function () { cp.textContent = "Kopiert ✓"; }, sel); else sel();
    });
    var mailBox = el("div", "ptn-tpl-mailbox");
    var mlab = el("label", "ptn-field-label", "Link per E-Mail an mich senden"); mlab.htmlFor = "ptn-tpl-mail";
    var mrow = el("div", "ptn-tpl-mailrow");
    var mail = el("input", "ptn-input"); mail.id = "ptn-tpl-mail"; mail.type = "email"; mail.placeholder = "deine@email.de"; mail.setAttribute("autocomplete", "email");
    var send = el("button", "ptn-tpl-send", "Senden"); send.type = "button";
    var mmsg = el("p", "ptn-hint ptn-tpl-mailmsg");
    mrow.appendChild(mail); mrow.appendChild(send);
    mailBox.appendChild(mlab); mailBox.appendChild(mrow); mailBox.appendChild(mmsg);
    mailBox.appendChild(el("p", "ptn-hint", "Wir senden nur diesen Link – keine Werbung, deine Adresse nutzen wir für nichts anderes."));
    on(send, "click", function () {
      var v = (mail.value || "").replace(/\s+/g, "");
      if (!/^[^@]+@[^@]+\.[a-z]{2,}$/i.test(v)) { mmsg.textContent = "Bitte gib eine g\u00fcltige E-Mail-Adresse ein."; return; }
      send.disabled = true; send.textContent = "\u2026"; mmsg.textContent = "";
      tplPost("email", { token: t.token, email: v, path: /\/pages\/baum-verschenken-neu/.test(location.pathname) ? "/pages/baum-verschenken-neu" : "/" }).then(function () {
        send.textContent = "Gesendet \u2713"; mmsg.textContent = "Die E-Mail ist unterwegs an " + v + ".";
        track("ptn_template_mail", {});
      }, function (e) { send.disabled = false; send.textContent = "Senden"; mmsg.textContent = e.message; });
    });
    row.appendChild(cp);
    box.appendChild(row);
    box.appendChild(mailBox);
    box.appendChild(el("p", "ptn-hint", "Wer den Link hat, kann die enthaltenen Namen und Bilder sehen."));
  }
  function tplDefaultTitle() {
    var who = (ui.sender || "").replace(/\s+/g, " ").trim();
    var occ = ui.occasion ? ui.occasion.label : "";
    if (who && occ) return (who + " – " + occ).slice(0, 80);
    if (ui.recipient) return ("Zertifikat für " + ui.recipient.replace(/\s+/g, " ")).slice(0, 80);
    return "Mein Baumzertifikat";
  }
  function tplSheet() {
    var sh = sheet("Als Vorlage speichern", "ptn-sheet--tpl");
    var box = el("div", "ptn-tpl");
    box.appendChild(el("p", "", "Ideal, wenn du öfter bestellst – z. B. mit Firmenlogo: Beim nächsten Mal ist alles schon ausgefüllt."));
    var lab = el("label", "ptn-field-label", "Name deiner Vorlage"); lab.htmlFor = "ptn-tpl-title";
    var inp = el("input", "ptn-input"); inp.id = "ptn-tpl-title"; inp.type = "text"; inp.maxLength = 80; inp.value = tplDefaultTitle();
    box.appendChild(lab); box.appendChild(inp);
    box.appendChild(el("p", "ptn-hint", "Gespeichert werden Namen, Worte, Fotos/Logo, Motiv, Farbe, Baumanzahl und Pflanzort. Geschenk, Format und Versand wählst du jedes Mal neu."));
    var err = el("p", "ptn-crop-error"); err.style.display = "none"; box.appendChild(err);
    var btn = el("button", "ptn-sheet-primary", "Vorlage speichern"); btn.type = "button";
    box.appendChild(btn);
    sh.body.appendChild(box);
    on(btn, "click", function () {
      if (btn.disabled) return;
      var design; try { design = L.payload(); } catch (e) { design = null; }
      if (!design) return;
      if (window.__ptnPro) design.pro_mode = 1;  /* Claude 28.10.2026: Profimodus mit der Vorlage merken */
      var t; try { t = { token: tplToken(), owner: tplToken(), title: (inp.value || tplDefaultTitle()).slice(0, 80) }; } catch (e) { err.textContent = e.message; err.style.display = ""; return; }
      btn.disabled = true; btn.textContent = "Wird gespeichert …"; err.style.display = "none";
      tplPost("save", { token: t.token, owner: t.owner, title: t.title, design: design }).then(function (r) {
        t.title = r.title; t.created_at = r.created_at;
        tplRemember(t);
        track("ptn_template_save", {});
        tplShare(box, t);
      }, function (e) {
        btn.disabled = false; btn.textContent = "Vorlage speichern";
        err.textContent = e.message; err.style.display = "";
      });
    });
  }
  function tplOpenFromHash() {
    var m = /[?&]vorlage=([a-f0-9]{64})/.exec(location.search) || /#ptn-vorlage=([a-f0-9]{64})/.exec(location.hash) || earlyTpl;
    earlyTpl = null;
    if (!m) return;
    try { history.replaceState(null, "", location.pathname + location.search.replace(/[?&]vorlage=[a-f0-9]{64}/, "").replace(/^&/, "?")); } catch (e) {}
    var token = m[1];
    loading.style.display = "";
    tplPost("load", { token: token }).then(function (r) {
      return Promise.resolve(window.PTGuidedSession.template(r.design)).then(function () {
        tplRemember({ token: token, title: r.title, created_at: r.created_at });
        loading.style.display = "none";
        flash("Deine Vorlage „" + r.title + "“ ist geladen – prüfe kurz alles und wähle dein Geschenk.");
      });
    })["catch"](function (e) { restoringOff(); loading.style.display = "none"; renderStart(); flash((e && e.message) || "Die Vorlage konnte nicht geladen werden."); });
  }



  /* ---------- Grusskarte: eigenes Fenster, KI-Vorschlag fuer Text und Bild, alles anpassbar ---------- */
  var greetUI = null, greetPrevT = 0, greetPrevKey = "", greetSrc = "";
  function greetSnap() {
    if (BIRTH) return { sender: "", recipient: bGiven(B.name), message: "Zur Geburt am " + bDateText(bData().date) };
    return { sender: ui.sender || "", recipient: ui.recipient || "", message: ui.message || "" };
  }
  /* Text und Bild werden im Hintergrund vorbereitet: 3 s nachdem Anlass/Widmung bzw. Namen feststehen.
     Aufrufe laufen nacheinander (die Engine verwirft sonst laufende Ergebnisse) und nur bei echter Aenderung. */
  var greetChain = Promise.resolve(), greetImgKey = "", greetTxtKey = "", greetPrepT = 0;
  function greetPrepare(part) {
    greetChain = greetChain.then(function () {
      try { return Promise.resolve(L.prepareGreeting(greetSnap(), part))["catch"](function () {}); } catch (e) { return null; }
    });
    return greetChain;
  }
  function greetPrepNow() {
    if (!L || !L.prepareGreeting) return;
    var st = L.state();
    if (BIRTH) {
      if (!bReady()) return;
      if (!st.greetingImageEdited || bGreetAutoImg) bGreetMotifPhoto(false);
      var bk = [bGiven(B.name), bData().date].join("|");
      if (bk !== greetTxtKey && !st.greetingEdited) { greetTxtKey = bk; greetPrepare({ part: "text" }); }
      return;
    }
    /* Bild nur pro Anlass neu (Kosten), Text bei jeder Aenderung von Namen oder Widmung */
    var imgKey = ui.occasion ? ui.occasion.key : (ui.message || "").replace(/\s+/g, " ");
    if (imgKey && imgKey !== greetImgKey && !st.greetingImageEdited) {
      greetImgKey = imgKey;
      greetPrepare({ part: "image" });
    }
    var txtKey = [ui.sender, ui.recipient, ui.message].join("|");
    if ((ui.sender || ui.recipient) && txtKey !== greetTxtKey && !st.greetingEdited) {
      greetTxtKey = txtKey;
      greetPrepare({ part: "text" });
    }
  }
  function scheduleGreetPrep(ms) {
    clearTimeout(greetPrepT);
    greetPrepT = setTimeout(greetPrepNow, ms === undefined ? 3000 : ms);
  }
  function greetStatus(st) {
    if (BIRTH && st.greetingBusy && !st.greetingImageBusy) return "Dein Textvorschlag wird formuliert …";
    if (BIRTH && bGreetAutoImg && st.greetingImageMode === "upload") return "Text und " + (bData().motif === "fuchs" ? "Fuchs" : "Reh") + " der Urkunde sind übernommen – du kannst beides ändern.";
    if (st.greetingImageBusy) return "Dein passendes Bild wird gerade gemalt … das dauert einen Moment.";
    if (st.greetingBusy) return "Dein Textvorschlag wird formuliert …";
    if (st.greetingImageMode === "upload") return "Dein eigenes Foto ist gewählt.";
    if (st.greetingImageMode === "motif") return "Dein ausgewähltes Motiv ist übernommen.";
    return "Text und Bild sind passend zum Anlass vorbereitet – du kannst beides ändern.";
  }
  function greetRefreshPreview(delay) {
    clearTimeout(greetPrevT);
    greetPrevT = setTimeout(function () {
      if (!L || L.state().greetingBusy || !L.renderScene || !L.state().greetingText) return;
      var st = L.state();
      var key = [st.greetingText, st.greetingImageMode, st.greetingMotif, String(st.greetingImage || "").length].join("|");
      if (key === greetPrevKey && greetSrc) { greetShow(); return; }
      L.renderScene(true).then(function (url) {
        if (!url) return;
        greetPrevKey = key; greetSrc = url; greetShow();
      })["catch"](function () {});
    }, delay === undefined ? 400 : delay);
  }
  function greetShow() {
    if (greetSrc && cardPic.getAttribute("src") !== greetSrc) cardPic.src = greetSrc;
    var imgs = document.querySelectorAll("[data-greet-preview]");
    for (var i = 0; i < imgs.length; i++) if (greetSrc && imgs[i].getAttribute("src") !== greetSrc) imgs[i].src = greetSrc;
    applyLook();
  }
  function onGreetChange() {
    var st = L.state();
    if (greetUI) {
      if (greetUI.text && document.activeElement !== greetUI.text && !st.greetingEdited && greetUI.text.value !== st.greetingText) greetUI.text.value = st.greetingText || "";
      greetUI.status.textContent = greetStatus(st);
      greetUI.regen.disabled = !!st.greetingBusy;
      if (greetUI.aiImg) greetUI.aiImg.style.display = BIRTH ? (bGreetAutoImg ? "none" : "") : ((st.greetingImageMode === "upload" || st.greetingImageMode === "motif") ? "none" : "");
      if (greetUI.aiImg) greetUI.aiImg.disabled = !!st.greetingImageBusy;
      if (st.greetingBusy) addCls(greetUI.wrap, "is-busy"); else rmCls(greetUI.wrap, "is-busy");
    }
    greetRefreshPreview(250);
  }
  function greetSheet() {
    var st = L.state();
    try { L.onGreeting(onGreetChange); } catch (e) {}
    var sh = sheet("Deine Grußkarte", "ptn-sheet--greet");
    var wrap = el("div", "ptn-greet");
    var pv = el("div", "ptn-greet-preview");
    var pimg = el("img"); pimg.setAttribute("data-greet-preview", "1"); pimg.alt = "Vorschau deiner Grußkarte";
    if (greetSrc) pimg.src = greetSrc;
    var ppic = el("span", "ptn-greet-pic" + (L.state().paper === "grass" ? " is-grass" : ""));
    ppic.appendChild(pimg); ppic.appendChild(el("span", "ptn-cardgrass"));
    pv.appendChild(ppic);
    pv.appendChild(el("span", "ptn-greet-wait", "Vorschau wird erstellt …"));
    var gz = el("button", "ptn-zoom ptn-greet-zoom", "\ud83d\udd0d"); gz.type = "button"; gz.setAttribute("aria-label", "Gru\u00dfkarte gro\u00df ansehen");
    on(gz, "click", function () { if (greetSrc) lightbox(greetSrc, "Deine Gru\u00dfkarte"); });
    on(pimg, "click", function () { if (greetSrc) lightbox(greetSrc, "Deine Gru\u00dfkarte"); });
    pv.appendChild(gz);
    wrap.appendChild(pv);
    var status = el("p", "ptn-hint ptn-greet-status", greetStatus(st));
    status.setAttribute("role", "status");
    wrap.appendChild(status);
    /* Text */
    var tl = el("label", "ptn-field-label", "Text der Karte"); tl.htmlFor = "ptn-greet-text";
    var ta = el("textarea", "ptn-input ptn-greet-text"); ta.id = "ptn-greet-text"; ta.rows = 6; ta.maxLength = 700; ta.value = st.greetingText || "";
    on(ta, "input", function () {
      var v = L.greetingText(ta.value);
      if (v !== ta.value) ta.value = v;
      greetRefreshPreview(800); saveDraft();
    });
    var regen = el("button", "ptn-link ptn-greet-link", "↻ Neuen Text vorschlagen"); regen.type = "button";
    on(regen, "click", function () { greetPrepare({ part: "text" }); onGreetChange(); track("ptn_greet_regen", { part: "text" }); });
    wrap.appendChild(tl); wrap.appendChild(ta); wrap.appendChild(regen);
    /* Tastatur: Vorschau einklappen und das Textfeld sichtbar halten */
    var taBlurT = 0;
    function taIntoView() {
      if (document.activeElement !== ta) return;
      var d = ta.getBoundingClientRect().top - sh.body.getBoundingClientRect().top - 30;
      sh.body.scrollTop = Math.max(0, sh.body.scrollTop + d);
    }
    on(ta, "focus", function () {
      clearTimeout(taBlurT);
      addCls(wrap, "is-typing"); addCls(sh.el, "is-typing");
      setTimeout(taIntoView, 60); setTimeout(taIntoView, 350); setTimeout(taIntoView, 700);
    });
    on(ta, "blur", function () {
      taBlurT = setTimeout(function () { rmCls(wrap, "is-typing"); rmCls(sh.el, "is-typing"); }, 150);
    });
    if (window.visualViewport) window.visualViewport.addEventListener("resize", function () { setTimeout(taIntoView, 50); });
    /* Bild */
    wrap.appendChild(el("span", "ptn-field-label ptn-greet-imglabel", "Bild auf der Karte"));
    var acts = el("div", "ptn-greet-acts");
    var aiImg = el("button", "ptn-mini", "↻ Neues Bild vorschlagen"); aiImg.type = "button";
    if (BIRTH) aiImg.textContent = "↻ " + (bData().motif === "fuchs" ? "Fuchs" : "Reh") + " der Urkunde";
    on(aiImg, "click", function () { if (BIRTH) { bGreetMotifPhoto(true); track("ptn_greet_regen", { part: "birth-motif" }); return; } greetPrepare({ part: "image" }); onGreetChange(); track("ptn_greet_regen", { part: "image" }); });
    var motifB = el("button", "ptn-mini", "Motiv wählen"); motifB.type = "button";
    var upB = el("button", "ptn-mini", "Eigenes Foto"); upB.type = "button";
    on(upB, "click", function () {
      cropSheet("greeting", { box: { width: 1620, height: 660 }, title: "Foto für die Grußkarte", hint: "So erscheint dein Foto als Bild auf der Karte. Ziehe es an die gewünschte Stelle.",
        apply: function (data) { try { L.greetingPhoto(data); } catch (e) {} onGreetChange(); saveDraft(); } });
    });
    acts.appendChild(aiImg); acts.appendChild(motifB); acts.appendChild(upB);
    wrap.appendChild(acts);
    var mbox = el("div", "ptn-greet-motifs"); mbox.style.display = "none";
    on(motifB, "click", function () {
      if (mbox.style.display === "none") { mbox.style.display = ""; drawGM(); } else mbox.style.display = "none";
    });
    var gmGroup = "flowers";
    function drawGM() {
      clear(mbox);
      var all = []; try { all = L.motifs() || []; } catch (e) {}
      var now = L.state();
      var tabs = el("div", "ptn-tabs");
      MOTIF_GROUPS.forEach(function (g) {
        var t = el("button", "ptn-tab" + (gmGroup === g[0] ? " is-on" : ""), g[1]); t.type = "button";
        on(t, "click", function () { gmGroup = g[0]; drawGM(); });
        tabs.appendChild(t);
      });
      var grid = el("div", "ptn-motifs");
      all.forEach(function (m) {
        if (m.group !== gmGroup) return;
        var sel = now.greetingImageMode === "motif" && now.greetingMotif === m.key;
        var b = el("button", "ptn-motif" + (sel ? " is-on" : "")); b.type = "button"; b.setAttribute("aria-label", m.label);
        var im = el("img"); im.src = m.image; im.alt = ""; im.setAttribute("loading", "lazy");
        b.appendChild(im); b.appendChild(el("span", "", m.label));
        on(b, "click", function () { try { L.greetingMotif(m.key); } catch (e) {} drawGM(); onGreetChange(); saveDraft(); });
        grid.appendChild(b);
      });
      mbox.appendChild(tabs); mbox.appendChild(grid);
    }
    wrap.appendChild(mbox);
    var done = el("button", "ptn-sheet-primary", "Fertig"); done.type = "button";
    /* Ein Tipp genuegt: bei offener Tastatur verschiebt das Schliessen sonst das Layout unter dem Finger */
    var doneFired = false;
    function doneNow(e) { if (e) e.preventDefault(); if (doneFired) return; doneFired = true; sh.close(); }
    done.addEventListener("touchstart", doneNow, false);
    on(done, "click", doneNow);
    wrap.appendChild(done);
    sh.body.appendChild(wrap);
    greetUI = { wrap: wrap, text: ta, status: status, regen: regen, aiImg: aiImg };
    var oldClose = sh.close;
    sh.close = function () { greetUI = null; oldClose(); renderStep(); applyLook(); };
    var x = sh.el.querySelector(".ptn-sheet-close"); if (x) on(x, "click", function () { greetUI = null; renderStep(); applyLook(); });
    on(sh.el, "click", function (e) { if (e.target === sh.el) { greetUI = null; renderStep(); applyLook(); } });
    onGreetChange();
    greetRefreshPreview(0);
  }
  /* ---------- Extras (Geschenkverpackung, Stecker, Lesezeichen …) mit Bild, Lupe und Lesezeichen-Motiv ---------- */
  var CDN = "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/";
  var BOOKMARK_IMG = { eule: CDN + "DSC_5751-2.jpg?v=1790595580", ginkgo: CDN + "DSC_5752-2.jpg?v=1790595659", libelle: CDN + "DSC_5753-2.jpg?v=1790595722" };
  var BOOKMARKS = [["eule", "Eule"], ["ginkgo", "Ginkgo"], ["libelle", "Libelle"]];
  function zoomOverlay(src, title) {
    var ov = el("div", "ptn-zoomov");
    ov.setAttribute("role", "dialog"); ov.setAttribute("aria-label", title || "Gro\u00dfansicht");
    var fig = el("figure", "ptn-zoomov-fig");
    var im = el("img"); im.src = src; im.alt = title || "";
    fig.appendChild(im);
    if (title) fig.appendChild(el("figcaption", "", title));
    var x = el("button", "ptn-zoomov-x", "\u00d7"); x.type = "button"; x.setAttribute("aria-label", "Schlie\u00dfen");
    ov.appendChild(fig); ov.appendChild(x);
    function close() { if (ov.parentNode) ov.parentNode.removeChild(ov); document.removeEventListener("keydown", esc, true); }
    function esc(e) { if (e.keyCode === 27) { e.stopPropagation(); close(); } }
    on(ov, "click", close);
    document.addEventListener("keydown", esc, true);
    document.body.appendChild(ov);
  }
  function currentBookmark() { try { return (L && L.state().bookmark) || "eule"; } catch (e) { return "eule"; } }
  /* list: [{key,title,price,image,selected}], opts: { isOn(key), toggle(key,on) } */
  function buildExtras(list, opts) {
    var wrap = el("div", "ptn-extras");
    list.forEach(function (x) {
      var onx = opts.isOn(x.key);
      var item = el("div", "ptn-extra" + (onx ? " is-on" : ""));
      var row = el("div", "ptn-extra-row");
      var img = x.key === "bookmark" ? BOOKMARK_IMG[currentBookmark()] || x.image : x.image;
      var th = el("button", "ptn-extra-thumb"); th.type = "button"; th.setAttribute("aria-label", x.title + " vergr\u00f6\u00dfern");
      if (img) { var ti = el("img"); ti.src = shopImg(img, 200); ti.alt = ""; ti.setAttribute("loading", "lazy"); th.appendChild(ti); }
      th.appendChild(el("span", "ptn-extra-zoom", "\ud83d\udd0d"));
      on(th, "click", function (e) { e.preventDefault(); e.stopPropagation(); if (img) zoomOverlay(shopImg(img, 1400), x.title); });
      var tg = el("button", "ptn-extra-main"); tg.type = "button";
      tg.setAttribute("role", "switch"); tg.setAttribute("aria-checked", onx ? "true" : "false");
      var tt = el("span", "ptn-extra-text");
      tt.appendChild(el("strong", "", x.title));
      tt.appendChild(el("span", "ptn-extra-price", "+ " + euro(x.price)));
      tg.appendChild(tt);
      tg.appendChild(el("span", "ptn-extra-check", onx ? "\u2713" : "+"));
      on(tg, "click", function () { opts.toggle(x.key, !opts.isOn(x.key)); });
      row.appendChild(th); row.appendChild(tg);
      item.appendChild(row);
      if (x.key === "bookmark" && onx) {
        var bm = el("div", "ptn-bookmarks");
        bm.appendChild(el("p", "ptn-bookmarks-q", "Welches Motiv?"));
        var grid = el("div", "ptn-bookmarks-grid");
        var cur = currentBookmark();
        BOOKMARKS.forEach(function (b) {
          var t = el("button", "ptn-bookmark" + (cur === b[0] ? " is-on" : "")); t.type = "button";
          t.setAttribute("aria-pressed", cur === b[0] ? "true" : "false");
          var bi = el("img"); bi.src = shopImg(BOOKMARK_IMG[b[0]], 300); bi.alt = "Lesezeichen " + b[1]; bi.setAttribute("loading", "lazy");
          t.appendChild(bi); t.appendChild(el("span", "", b[1]));
          var z = el("span", "ptn-extra-zoom ptn-bookmark-zoom", "\ud83d\udd0d");
          on(z, "click", function (e) { e.stopPropagation(); zoomOverlay(shopImg(BOOKMARK_IMG[b[0]], 1400), "Lesezeichen " + b[1]); });
          t.appendChild(z);
          on(t, "click", function () { try { L.bookmark(b[0]); } catch (e) {} track("ptn_bookmark", { motif: b[0] }); if (opts.changed) opts.changed(); });
          grid.appendChild(t);
        });
        bm.appendChild(grid);
        item.appendChild(bm);
      }
      wrap.appendChild(item);
    });
    return wrap;
  }
  /* im Gestalter: Extras unter Geschenk/Format */
  function formatExtras(st) {
    var list = (st && st.extras) || [];
    if (!list.length) return;
    var sec = el("div", "ptn-extras-sec");
    function draw() {
      clear(sec);
      var cur = []; try { cur = L.state().extras || []; } catch (e) {}
      sec.appendChild(el("p", "ptn-field-label", "Dazu passend (optional)"));
      sec.appendChild(buildExtras(cur, {
        isOn: function (k) { for (var i = 0; i < cur.length; i++) if (cur[i].key === k) return !!cur[i].selected; return false; },
        toggle: function (k, v) { try { L.extra(k, v); } catch (e) {} track("ptn_extra", { key: k, on: v }); draw(); updateBar(); saveDraft(); },
        changed: function () { draw(); saveDraft(); }
      }));
    }
    draw();
    body.appendChild(sec);
  }
  function lightbox(src, label) {
    var lb = el("div", "ptn-lightbox");
    lb.setAttribute("role", "dialog"); lb.setAttribute("aria-label", label || "Gro\u00dfansicht");
    var im = el("img"); im.src = src; im.alt = label || "";
    var x = el("button", "ptn-zoom ptn-lightbox-x", "\ud83d\udd0d"); x.type = "button"; x.setAttribute("aria-label", "Gro\u00dfansicht schlie\u00dfen");
    lb.appendChild(im); lb.appendChild(x);
    dialog.appendChild(lb);
    on(lb, "click", function () { if (lb.parentNode) lb.parentNode.removeChild(lb); });
  }
  function formatGreeting(st) {
    var sec = el("div", "ptn-greetrow" + (st.greeting ? " is-on" : ""));
    if (!st.greeting) {
      var add = el("button", "ptn-greetadd"); add.type = "button";
      add.appendChild(el("strong", "", "+ Persönliche Grußkarte dazu"));
      add.appendChild(el("small", "", "Mit passendem Bild und Text zum Anlass – alles anpassbar · +" + euro(st.greetingPrice || 3.5)));
      on(add, "click", function () {
        L.greeting(true); greetPrepNow(); track("ptn_greet_on", {});
        updateBar(); saveDraft(); renderStep(); applyLook(); greetSheet();
      });
      sec.appendChild(add);
    } else {
      var th = el("img", "ptn-greetthumb"); th.setAttribute("data-greet-preview", "1"); th.alt = "";
      if (greetSrc) th.src = greetSrc;
      var tx = el("div", "ptn-greetinfo");
      tx.appendChild(el("strong", "", "Grußkarte · +" + euro(st.greetingPrice || 3.5)));
      var ed = el("button", "ptn-link", "Bearbeiten"); ed.type = "button";
      on(ed, "click", function () { greetSheet(); });
      var rm = el("button", "ptn-link", "Entfernen"); rm.type = "button";
      on(rm, "click", function () { L.greeting(false); track("ptn_greet_off", {}); updateBar(); saveDraft(); renderStep(); applyLook(); });
      tx.appendChild(ed); tx.appendChild(rm);
      sec.appendChild(th); sec.appendChild(tx);
      greetRefreshPreview(100);
    }
    body.appendChild(sec);
  }

  function previewControls(st) {
    var row = el("div", "ptn-pvrow");
    var seg = el("div", "ptn-pvseg");
    [[false, BIRTH ? "Urkunde" : "Zertifikat"], [true, "Infoblatt"]].forEach(function (o) {
      var sel = !!ui.info === o[0];
      var b = el("button", "ptn-pvbtn" + (sel ? " is-on" : ""), o[1]); b.type = "button"; b.setAttribute("aria-pressed", String(sel));
      on(b, "click", function () { ui.info = o[0]; applyLook(); renderStep(); track("ptn_info_flip", { on: ui.info }); });
      seg.appendChild(b);
    });
    row.appendChild(seg);
    if (!st.gift && st.delivery === "print") {
      var rp = el("button", "ptn-pvreplay", "\u21bb Mappe \u00f6ffnen"); rp.type = "button";
      on(rp, "click", function () { ui.info = false; applyLook(); playFolder(); track("ptn_fold_replay", {}); });
      row.appendChild(rp);
    }
    body.appendChild(row);
  }
  var FRAMES = [["nature", "Natur", "#b79768"], ["black", "Schwarz", "#252525"], ["white", "Weiß", "#f9f9f5"], ["silver", "Silber", "#a4a6a9"]];
  function afterLook() { applyLook(); renderStep(); updateBar(); saveDraft(); }
  function formatFrames(st) {
    var sec = el("div", "ptn-sec ptn-sec--tight");
    sec.appendChild(el("span", "ptn-field-label", "Farbe des Bilderrahmens"));
    var row = el("div", "ptn-frames");
    FRAMES.forEach(function (f) {
      var sel = st.frame === f[0];
      var b = el("button", "ptn-frameopt" + (sel ? " is-on" : "")); b.type = "button"; b.setAttribute("aria-pressed", String(sel));
      var dot = el("span", "ptn-frameopt-dot"); dot.style.backgroundColor = f[2];
      b.appendChild(dot); b.appendChild(el("span", "", f[1]));
      on(b, "click", function () { L.frame(f[0]); track("ptn_frame", { frame: f[0] }); afterLook(); });
      row.appendChild(b);
    });
    sec.appendChild(row);
    body.appendChild(sec);
  }
  function formatPaper(st) {
    var digital = !st.gift && st.delivery === "digital";
    var sec = el("div", "ptn-sec ptn-sec--tight");
    sec.appendChild(el("span", "ptn-field-label", digital ? "Optik deiner PDF" : "Papier"));
    var seg = el("div", "ptn-verb ptn-paperseg");
    [["white", "Weiß", digital ? "kostenlos" : "FSC-Papier"], ["grass", "Graspapier", digital ? "kostenlos" : "+ " + euro(1)]].forEach(function (o) {
      var sel = (st.paper || "white") === o[0];
      var b = el("button", "ptn-seg ptn-seg--" + o[0] + (sel ? " is-on" : "")); b.type = "button"; b.setAttribute("aria-pressed", String(sel));
      var sw = el("span", "ptn-papersw ptn-papersw--" + o[0]);
      var tx = el("span", "ptn-paper-tx");
      tx.appendChild(el("strong", "", o[1])); tx.appendChild(el("small", "", o[2]));
      b.appendChild(sw); b.appendChild(tx);
      on(b, "click", function () { L.paper(o[0]); track("ptn_paper", { paper: o[0], delivery: st.delivery }); afterLook(); });
      seg.appendChild(b);
    });
    sec.appendChild(seg);
    if ((st.paper || "white") === "grass") {
      sec.appendChild(el("p", "ptn-hint", digital
        ? "Du bekommst deine PDF in Graspapier-Optik – und zusätzlich eine weiße PDF zum Selbstdrucken."
        : "Dein Zertifikat wird statt auf weißem Papier auf umweltschonendem Graspapier gedruckt."));
    }
    body.appendChild(sec);
  }

  /* ---------- Geschenke: Kategorien, Detailfenster mit Bildern, Varianten und Etikett ---------- */
  var giftCat = BIRTH ? "birth-picks" : "beliebte-geschenke", giftCache = {}, prodCache = {};
  /* Geburtsurkunde: ausgewaehlte Geschenke fuer Babys und Kleinkinder (Auswahl wie im alten Gestalter, ergaenzt) */
  var BIRTH_PICKS = [
    ["holzbuch-mit-schnecke-am-faden", "Ab 1 Jahr"],
    ["spieluhr-mit-beweglichen-bienen", "Spieluhr fürs Kinderzimmer"],
    ["ferdy-der-kleine-fuchs-im-winter", "Pappebuch · 1–4 Jahre"],
    ["benni-der-kleine-bar-im-herbst", "Pappebuch · 1–4 Jahre"],
    ["henry-der-kleine-hase-im-fruhling", "Pappebuch · ab 18 Monaten"],
    ["frosch-aus-holz-zum-nachziehen", "Ab 18 Monaten"],
    ["langer-tatzelwurm-zum-nachziehen", "Nachziehtier aus Holz"],
    ["drehdose-mit-sommerlichen-motiv", "Spieldose fürs Kinderzimmer"],
    ["das-ist-mein-baum", "Bilderbuch"],
    ["gluckwunsch-bar", "Bilderbuch"],
    ["puzzle-schafe-aus-holz", "Holzpuzzle"]
  ];
  function bJson(url) {
    return new Promise(function (res) {
      var x = new XMLHttpRequest();
      x.open("GET", url, true); x.timeout = 15000; x.setRequestHeader("Accept", "application/json");
      x.onload = function () { var d = null; try { d = JSON.parse(x.responseText); } catch (e) {} res(d); };
      x.onerror = x.ontimeout = function () { res(null); };
      x.send();
    });
  }
  function bGiftPicks() {
    return Promise.all([bJson("/collections/fur-kinder-co/products.json?limit=250"), bJson("/collections/alle-kinderbucher/products.json?limit=250")]).then(function (r) {
      var all = [].concat((r[0] && r[0].products) || [], (r[1] && r[1].products) || []), items = [];
      BIRTH_PICKS.forEach(function (pk) {
        for (var i = 0; i < all.length; i++) {
          var p = all[i];
          if (p.handle.indexOf(pk[0]) !== 0) continue;
          var tags = p.tags || [];
          if (typeof tags === "string") tags = tags.split(/,\s*/);
          if (tags.indexOf("pt-wizard-gift") < 0 && tags.indexOf("pt-wizard-label") < 0) break;
          var it = null; try { it = L.giftItem ? L.giftItem(p, false) : null; } catch (e) {}
          if (it) { it.note = pk[1]; items.push(it); }
          break;
        }
      });
      if (!items.length) throw new Error("leer");
      return { items: items, hasNext: false };
    });
  }
  function loadProduct(handle) {
    if (prodCache[handle]) return prodCache[handle];
    prodCache[handle] = new Promise(function (res, rej) {
      var x = new XMLHttpRequest();
      x.open("GET", "/products/" + encodeURIComponent(handle) + ".js", true);
      x.setRequestHeader("Accept", "application/json");
      x.timeout = 20000;
      x.onload = function () { try { res(JSON.parse(x.responseText)); } catch (e) { rej(e); } };
      x.onerror = x.ontimeout = function () { rej(new Error("load")); };
      x.send();
    });
    prodCache[handle]["catch"](function () { delete prodCache[handle]; });
    return prodCache[handle];
  }
  /* Produktbeschreibung sicher als Text-Absaetze darstellen */
  function safeDesc(html, target) {
    var tmp = document.createElement("div");
    try { tmp.innerHTML = String(html || "").replace(/<(script|style|iframe|object|embed)[\s\S]*?<\/\1>/gi, ""); } catch (e) { tmp.textContent = ""; }
    var blocks = tmp.querySelectorAll("p, li, h2, h3, h4");
    var parts = [];
    if (blocks.length) { for (var i = 0; i < blocks.length; i++) { var t = (blocks[i].textContent || "").replace(/\s+/g, " ").trim(); if (t) parts.push([blocks[i].tagName, t]); } }
    else { (tmp.textContent || "").split(/\n\s*\n/).forEach(function (t) { t = t.replace(/\s+/g, " ").trim(); if (t) parts.push(["P", t]); }); }
    var ul = null;
    parts.forEach(function (p) {
      if (p[0] === "LI") { if (!ul) { ul = el("ul", "ptn-gd-list"); target.appendChild(ul); } ul.appendChild(el("li", "", p[1])); }
      else { ul = null; target.appendChild(el(/^H/.test(p[0]) ? "h4" : "p", "", p[1])); }
    });
  }
  function shopImg(u, w) {
    if (!u) return "";
    u = String(u); if (u.indexOf("//") === 0) u = "https:" + u;
    return u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=" + (w || 800);
  }
  /* Preis des Geschenks selbst (ohne Baum); die Baumpflanzung zeigt die Leiste im Gesamtpreis */
  function giftBase(v) { return v && typeof v.base === "number" ? v.base : (v ? v.price : 0); }
  function giftDetail(item, preVariant) {
    var sh = sheet(item.title, "ptn-sheet--gift");
    var wrap = el("div", "ptn-gd");
    var gal = el("div", "ptn-gd-gallery");
    var trk = el("div", "ptn-gd-track");
    var dots = el("div", "ptn-gd-dots");
    gal.appendChild(trk); gal.appendChild(dots);
    wrap.appendChild(gal);
    var priceEl = el("p", "ptn-gd-price");
    wrap.appendChild(priceEl);
    var varBox = el("div", "ptn-gd-variants");
    wrap.appendChild(varBox);
    var labelNote = el("p", "ptn-gd-note"); labelNote.style.display = "none";
    wrap.appendChild(labelNote);
    wrap.appendChild(el("p", "ptn-gd-note", BIRTH ? "Mit Baumpflanzung · die Geburtsurkunde liegt gedruckt bei." : "Mit Baumpflanzung · das Zertifikat liegt gedruckt bei."));
    var desc = el("div", "ptn-gd-desc");
    desc.appendChild(el("p", "ptn-hint", "Details werden geladen …"));
    wrap.appendChild(desc);
    var cta = el("button", "ptn-sheet-primary", "Dieses Geschenk wählen"); cta.type = "button";
    wrap.appendChild(cta);
    sh.body.appendChild(wrap);
    var vs = item.variants || [];
    var chosen = null;
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(preVariant)) chosen = vs[i];
    if (!chosen) for (var j = 0; j < vs.length; j++) if (vs[j].available) { chosen = vs[j]; break; }
    var slides = [];
    function setImages(urls) {
      clear(trk); clear(dots); slides = [];
      urls.forEach(function (u, k) {
        var s = el("div", "ptn-gd-slide");
        var im = el("img"); im.src = shopImg(u, 900); im.alt = item.title + " – Bild " + (k + 1);
        if (k > 0) im.setAttribute("loading", "lazy");
        s.appendChild(im); trk.appendChild(s); slides.push(s);
        var d = el("button", "ptn-gd-dot" + (k === 0 ? " is-on" : "")); d.type = "button"; d.setAttribute("aria-label", "Bild " + (k + 1));
        on(d, "click", function () { trk.scrollLeft = s.offsetLeft; });
        dots.appendChild(d);
      });
      dots.style.display = urls.length > 1 ? "" : "none";
    }
    on(trk, "scroll", function () {
      var k = Math.round(trk.scrollLeft / Math.max(1, trk.clientWidth));
      var ds = dots.querySelectorAll(".ptn-gd-dot");
      for (var i = 0; i < ds.length; i++) ds[i].className = "ptn-gd-dot" + (i === k ? " is-on" : "");
    });
    function showVariant(v) {
      chosen = v;
      priceEl.textContent = v ? euro(giftBase(v)) + (v.price - giftBase(v) > 0.005 ? " · Baumpflanzung mit " + (BIRTH ? "Urkunde" : "Zertifikat") + " + " + euro(v.price - giftBase(v)) : " · Baumpflanzung inklusive") : "";
      cta.disabled = !(v && v.available);
      cta.textContent = v && !v.available ? "Diese Variante ist ausverkauft" : "Dieses Geschenk wählen · " + (v ? euro(giftBase(v)) : "");
      var bs = varBox.querySelectorAll(".ptn-gd-var");
      for (var i = 0; i < bs.length; i++) bs[i].className = "ptn-gd-var" + (bs[i].getAttribute("data-id") === String(v && v.id) ? " is-on" : "") + (bs[i].getAttribute("data-off") ? " is-off" : "");
      if (v && v.image && slides.length) {
        var want = String(v.image).split("?")[0].split("/").pop();
        for (var s = 0; s < slides.length; s++) {
          var src = slides[s].firstChild.getAttribute("src").split("?")[0].split("/").pop();
          if (src === want) { trk.scrollLeft = slides[s].offsetLeft; break; }
        }
      }
    }
    if (vs.length > 1) {
      varBox.appendChild(el("span", "ptn-field-label", "Variante"));
      var row = el("div", "ptn-gd-varrow");
      vs.forEach(function (v) {
        var b = el("button", "ptn-gd-var", v.title || "Standard"); b.type = "button";
        b.setAttribute("data-id", String(v.id));
        if (!v.available) { b.setAttribute("data-off", "1"); b.title = "Ausverkauft"; }
        on(b, "click", function () { showVariant(v); });
        row.appendChild(b);
      });
      varBox.appendChild(row);
    }
    setImages(item.image ? [item.image] : []);
    showVariant(chosen);
    loadProduct(item.handle).then(function (pr) {
      var imgs = (pr.images || []).slice(0, 12);
      if (imgs.length) setImages(imgs);
      clear(desc);
      safeDesc(pr.description, desc);
      if ((pr.tags || []).indexOf("pt-wizard-label") >= 0) {
        labelNote.style.display = "";
        labelNote.textContent = "Mit persönlichem Etikett: Namen und Worte vom Zertifikat werden übernommen – nach der Auswahl kannst du das Etikett anpassen.";
      }
      showVariant(chosen);
    })["catch"](function () { clear(desc); desc.appendChild(el("p", "ptn-hint", "Die Details konnten gerade nicht geladen werden.")); });
    on(cta, "click", function () {
      if (!chosen || !chosen.available) return;
      try {
        L.selectGift(item.handle, chosen.id);
        track("ptn_gift", { handle: item.handle, variant: chosen.id });
        sh.close(); renderStep(); updateBar(); applyLook(); saveDraft();
        /* Etikett-Geschenk: direkt zum Etikett scrollen, damit man es sieht */
        setTimeout(function () {
          var lb = body.querySelector(".ptn-labelbox");
          if (!lb) return;
          var d = lb.getBoundingClientRect().top - mainCol.getBoundingClientRect().top - 12;
          try { mainCol.scrollTo({ top: mainCol.scrollTop + d, behavior: "smooth" }); } catch (e2) { mainCol.scrollTop = mainCol.scrollTop + d; }
        }, 450);
      } catch (e) { flash(e && e.message); }
    });
    track("ptn_gift_detail", { handle: item.handle });
  }
  function giftItemFromState() {
    var ex = null; try { ex = L.exportState(); } catch (e) {}
    if (!ex || !ex.gift) return null;
    var st = L.state();
    var d = st.giftDetails || {};
    return { handle: ex.gift.handle, title: ex.gift.title, image: ex.gift.image, variants: d.variants || [], selected: d.selected || ex.variant };
  }
  function renderSelectedGift(st) {
    var it = giftItemFromState();
    var g = el("div", "ptn-giftbox");
    var top = el("div", "ptn-giftbox-top");
    if (it && it.image) { var im = el("img", "ptn-giftbox-img"); im.src = shopImg(it.image, 200); im.alt = ""; top.appendChild(im); }
    var tx = el("div", "ptn-giftbox-tx");
    tx.appendChild(el("strong", "", st.gift));
    var vsel = null;
    if (it) for (var i = 0; i < it.variants.length; i++) if (String(it.variants[i].id) === String(it.selected)) vsel = it.variants[i];
    if (vsel && it.variants.length > 1) tx.appendChild(el("span", "", "Variante: " + vsel.title));
    tx.appendChild(el("span", "", BIRTH ? "Mit Baumpflanzung · Geburtsurkunde liegt gedruckt bei" : "Mit Baumpflanzung · Zertifikat liegt gedruckt bei"));
    var acts = el("div", "ptn-giftbox-acts");
    if (it) {
      var det = el("button", "ptn-link", it.variants.length > 1 ? "Details & Varianten" : "Details & Bilder"); det.type = "button";
      on(det, "click", function () { giftDetail(it, it.selected); });
      acts.appendChild(det);
    }
    if (!isGiftPage) {
      var rm = el("button", "ptn-link", "Geschenk entfernen"); rm.type = "button";
      on(rm, "click", function () { L.removeGift(); renderStep(); updateBar(); applyLook(); saveDraft(); });
      acts.appendChild(rm);
    }
    tx.appendChild(acts);
    top.appendChild(tx);
    g.appendChild(top);
    /* Etikett (z. B. Buecher): Editor aus der bestehenden Engine */
    var lab = el("div", "ptn-labelbox");
    try { if (window.PTGuidedGiftMedia && window.PTGuidedGiftMedia.panel) window.PTGuidedGiftMedia.panel(lab); } catch (e) {}
    if (lab.firstChild) {
      var det2 = lab.querySelector("details");
      /* Etikett direkt zeigen; Eingabefelder erst nach "Etikett anpassen" (wieder zuklappbar) */
      if (det2) {
        det2.open = true;
        var bodyL = det2.querySelector(".ptg-label-body");
        var prevL = det2.querySelector(".ptg-label-preview");
        if (bodyL && prevL) {
          var edit = el("div", "ptn-label-edit"); edit.style.display = ui.labelOpen ? "" : "none";
          var kids = []; for (var c = bodyL.firstChild; c; c = c.nextSibling) if (c !== prevL) kids.push(c);
          kids.forEach(function (k) { edit.appendChild(k); });
          var colorIn = edit.querySelector("#ptg-label-color");
          if (colorIn) { var cl = edit.querySelector('label[for="ptg-label-color"]'); if (cl) { cl.className += " ptn-hide"; cl.style.setProperty("display", "none", "important"); } colorIn.style.setProperty("display", "none", "important"); }
          var tog = el("button", "ptn-label-toggle", ui.labelOpen ? "Fertig" : "Etikett anpassen"); tog.type = "button";
          on(tog, "click", function () {
            ui.labelOpen = !ui.labelOpen;
            edit.style.display = ui.labelOpen ? "" : "none";
            tog.textContent = ui.labelOpen ? "Fertig" : "Etikett anpassen";
            if (!ui.labelOpen) { try { saveDraft(); } catch (e) {} }
          });
          bodyL.appendChild(edit);
          bodyL.appendChild(tog);
          if (lblLimit(lab) && !ui.labelOpen) tog.click();
        }
      }
      g.appendChild(lab);
    }
    body.appendChild(g);
  }
  function renderGiftIdeas() {
    var box = el("div", "ptn-gifts");
    addCls(box, "ptn-gifts--ad");  /* Claude 02.11.2026 (Leslie): Geschenk-Angebot deutlicher */
    box.appendChild(el("p", "ptn-gifts-h", BIRTH ? "🎁 Noch ein kleines Geschenk fürs Kind dazu?" : "🎁 Noch ein Geschenk zum Baum dazu?"));
    box.appendChild(el("p", "ptn-gifts-sub", BIRTH ? "Ganz freiwillig: Such dir unten ein Geschenk aus – die Urkunde liegt dann gedruckt dabei, alles in einem Paket." : "Ganz freiwillig: Such dir unten ein Geschenk aus – das Zertifikat liegt dann gedruckt dabei, alles in einem Paket."));
    var cats = []; try { cats = L.categories() || []; } catch (e) {}
    if (BIRTH) {
      cats = [{ key: "birth-picks", label: "Zur Geburt empfohlen" }, { key: "fur-kinder-co", label: "Spielzeug & mehr" }, { key: "alle-kinderbucher", label: "Kinderbücher" }];
      if (!L.giftItem) cats.shift();
      if (giftCat === "birth-picks" && !L.giftItem) giftCat = "fur-kinder-co";
      box.appendChild(el("p", "ptn-hint ptn-gift-birthhint", "Die Urkunde liegt dann gedruckt beim Geschenk – zusammen in einem Paket."));
    }
    var tabs = el("div", "ptn-tabs ptn-gift-tabs");
    var row = el("div", "ptn-gift-row");
    box.appendChild(tabs); box.appendChild(row);
    body.appendChild(box);
    if (!L.catalog) { box.style.display = "none"; return; }
    function drawTabs() {
      clear(tabs);
      cats.forEach(function (c) {
        var t = el("button", "ptn-tab" + (c.key === giftCat ? " is-on" : ""), c.label); t.type = "button";
        on(t, "click", function () { giftCat = c.key; drawTabs(); load(1, true); });
        tabs.appendChild(t);
      });
    }
    function card(it) {
      var v = null;
      for (var i = 0; i < it.variants.length; i++) { if (it.variants[i].available) { v = it.variants[i]; break; } }
      if (!v) return null;
      var b = el("button", "ptn-gift"); b.type = "button";
      if (it.image) { var img = el("img"); img.src = shopImg(it.image, 300); img.alt = ""; img.setAttribute("loading", "lazy"); b.appendChild(img); }
      b.appendChild(el("span", "ptn-gift-title", it.title));
      if (it.note) b.appendChild(el("span", "ptn-gift-note", it.note));
      b.appendChild(el("span", "ptn-gift-price", (it.variants.length > 1 ? "ab " : "") + euro(giftBase(v))));
      b.appendChild(el("span", "ptn-gift-more", "Ansehen ›"));
      on(b, "click", function () { giftDetail(it, v.id); });
      return b;
    }
    var nextPage = 0, loadingMore = false;
    /* Endlos: naechste Seite erst laden, wenn man sich dem Ende der Reihe naehert */
    on(row, "scroll", function () {
      if (!nextPage || loadingMore) return;
      if (row.scrollLeft + row.clientWidth > row.scrollWidth - 320) load(nextPage, false);
    });
    function load(page, reset) {
      var key = giftCat + ":" + page;
      var catAtStart = giftCat;
      loadingMore = true; nextPage = 0;
      if (reset) { clear(row); row.appendChild(el("p", "ptn-hint ptn-gift-wait", "Geschenkideen werden geladen …")); row.scrollLeft = 0; }
      var p = giftCache[key] || (giftCache[key] = giftCat === "birth-picks" ? bGiftPicks() : L.catalog(giftCat, page));
      p.then(function (res) {
        loadingMore = false;
        if (catAtStart !== giftCat) return;
        var w = row.querySelector(".ptn-gift-wait"); if (w) row.removeChild(w);
        var more = row.querySelector(".ptn-gift-next"); if (more) row.removeChild(more);
        var n = 0;
        ((res && res.items) || []).forEach(function (it) { var c = card(it); if (c) { row.appendChild(c); n++; } });
        if (res && res.hasNext) {
          nextPage = page + 1;
          var nx = el("button", "ptn-gift ptn-gift-next", "Weitere Geschenke \u2026"); nx.type = "button";
          on(nx, "click", function () { if (nextPage && !loadingMore) load(nextPage, false); });
          row.appendChild(nx);
          if (row.scrollWidth <= row.clientWidth + 40) load(nextPage, false);
        }
        if (!n && reset) row.appendChild(el("p", "ptn-hint", "In dieser Kategorie ist gerade nichts verfügbar."));
      })["catch"](function () { loadingMore = false; delete giftCache[key]; if (!reset) { nextPage = page; return; } clear(row); row.appendChild(el("p", "ptn-hint", "Geschenkideen konnten nicht geladen werden.")); });
    }
    drawTabs();
    load(1, true);
  }



  /* ---------- Overlay-Fenster (innerhalb des Popups) ---------- */
  function sheet(title, cls) {
    var wrap = el("div", "ptn-sheet " + (cls || ""));
    var box = el("div", "ptn-sheet-box");
    var hd = el("div", "ptn-sheet-head");
    hd.appendChild(el("h3", "ptn-sheet-title", title));
    var x = el("button", "ptn-close ptn-sheet-close", "×"); x.type = "button"; x.setAttribute("aria-label", "Schließen");
    hd.appendChild(x);
    var content = el("div", "ptn-sheet-body");
    box.appendChild(hd); box.appendChild(content); wrap.appendChild(box);
    dialog.appendChild(wrap);
    function close() { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
    on(x, "click", close);
    on(wrap, "click", function (e) { if (e.target === wrap) close(); });
    return { el: wrap, body: content, close: close };
  }

  /* ---------- Pflanzort-Infos mit Karte (Leaflet/OpenStreetMap wie im Original) ---------- */
  var leafletP = null, MAPB = [[47.6, 5.8], [54.9, 14.6]];
  function loadLeaflet() {
    if (window.L && window.L.map) return Promise.resolve(window.L);
    if (leafletP) return leafletP;
    leafletP = new Promise(function (res, rej) {
      var l = document.createElement("link"); l.rel = "stylesheet"; l.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"; document.head.appendChild(l);
      var sc = document.createElement("script"); sc.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
      sc.onload = function () { if (window.L && window.L.map) res(window.L); else { leafletP = null; rej(new Error("x")); } };
      sc.onerror = function () { leafletP = null; rej(new Error("Karte nicht verfügbar")); };
      document.head.appendChild(sc);
    });
    return leafletP;
  }
  function drawMap(container, selected) {
    container.appendChild(el("p", "ptn-hint ptn-map-wait", "Karte wird geladen …"));
    loadLeaflet().then(function (Lf) {
      if (!container.parentNode) return;
      clear(container);
      var m = Lf.map(container, { scrollWheelZoom: false, dragging: false, touchZoom: false, doubleClickZoom: false, boxZoom: false, keyboard: false, zoomControl: false, attributionControl: true });
      Lf.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 17, attribution: "&copy; OpenStreetMap" }).addTo(m);
      m.fitBounds(MAPB, { padding: [10, 10] });
      FORESTS.forEach(function (fo) {
        var hi = !selected || fo.key === selected;
        Lf.circleMarker(fo.pos, { radius: hi ? 9 : 5, color: "#fff", weight: hi ? 3 : 1, fillColor: hi ? "#255536" : "#82907c", fillOpacity: 1 })
          .addTo(m).bindTooltip(fo.place, { permanent: hi, direction: fo.dir, className: "ptn-map-tip" });
      });
      setTimeout(function () { try { m.invalidateSize(); m.fitBounds(MAPB, { padding: [10, 10] }); } catch (e) {} }, 80);
    })["catch"](function () { clear(container); container.appendChild(el("p", "ptn-hint ptn-map-wait", "Die Karte kann gerade nicht geladen werden.")); });
  }
  function forestSheet(fo) {
    var sh = sheet(fo ? fo.title : "Unsere Pflanzorte", "ptn-sheet--forest");
    var map = el("div", "ptn-map");
    sh.body.appendChild(map);
    if (fo) {
      sh.body.appendChild(el("p", "ptn-sheet-kicker", fo.site));
      sh.body.appendChild(el("p", "", fo.body));
      sh.body.appendChild(el("p", "ptn-sheet-tree", fo.tree));
      sh.body.appendChild(el("p", "ptn-hint", "Die genaue Baumposition, GPS-Koordinaten und die Zertifikats-ID werden nach dem Kauf ergänzt."));
      var a = el("a", "ptn-sheet-link", "Pflanzbericht ansehen ↗"); a.href = fo.report; a.target = "_blank"; a.rel = "noopener";
      sh.body.appendChild(a);
      var sel = L.state().forest === fo.key;
      var pick = el("button", "ptn-sheet-primary", sel ? "Ausgewählt ✓ – zurück" : "Diesen Pflanzort wählen"); pick.type = "button";
      on(pick, "click", function () { L.forest(fo.key); sh.close(); renderStep(); updateBar(); saveDraft(); });
      sh.body.appendChild(pick);
    } else {
      FORESTS.forEach(function (x) {
        var r = el("button", "ptn-sheet-forest");
        r.type = "button";
        r.appendChild(el("strong", "", x.title));
        r.appendChild(el("span", "", x.site));
        r.appendChild(el("small", "", "Mehr erfahren ›"));
        on(r, "click", function () { sh.close(); forestSheet(x); });
        sh.body.appendChild(r);
      });
      sh.body.appendChild(el("p", "ptn-hint", "Die Markierungen zeigen je eine Pflanzfläche der Region."));
    }
    drawMap(map, fo ? fo.key : null);
    track("ptn_forest_info", { forest: fo ? fo.key : "all" });
  }

  /* ---------- Foto oder Logo statt Text ---------- */
  var IMG_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><rect x="3" y="4.5" width="18" height="15" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="9" cy="10" r="1.8" fill="currentColor"/><path d="M4.5 18l5-5 3.5 3.5 2.5-2.5 4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  function photoSlot(slot, f) {
    if (ui.photos[slot]) {
      f.input.style.display = "none";
      addCls(f.wrap, "has-photo");
      var chip = el("div", "ptn-photochip");
      var im = el("img"); im.src = ui.photos[slot]; im.alt = "Dein Bild";
      chip.appendChild(im);
      var ch = el("button", "ptn-photochip-edit", "Bild ändern"); ch.type = "button";
      on(ch, "click", function () { cropSheet(slot); });
      var rm = el("button", "ptn-photochip-x", "×"); rm.type = "button";
      rm.setAttribute("aria-label", "Bild entfernen und wieder Text verwenden"); rm.title = "Wieder Text verwenden";
      on(rm, "click", function () { delete ui.photos[slot]; if (ui.photoSrc) delete ui.photoSrc[slot]; L.photo(slot, ""); renderStep(); updateBar(); refreshNavLock(); saveDraft(); });
      chip.appendChild(ch); chip.appendChild(rm);
      f.box.appendChild(chip);
    } else {
      addCls(f.wrap, "has-photo-btn");
      var up = el("button", "ptn-photobtn"); up.type = "button";
      up.innerHTML = IMG_ICON + "<span>Bild</span>";
      up.setAttribute("aria-label", "Foto oder Logo statt Text verwenden");
      up.title = "Foto oder Logo statt Text";
      on(up, "click", function (e) { e.preventDefault(); cropSheet(slot); });
      f.box.appendChild(up);
    }
    return f.wrap;
  }

  function cropSheet(slot, opts) {
    opts = opts || {};
    var box = opts.box || (L.boxes && L.boxes[slot]) || { width: 1600, height: 600 };
    var sh = sheet(opts.title || (slot === "message" ? "Bild statt Widmung" : (slot === "sender" ? "Bild statt Absender" : "Bild statt Empf\u00e4nger")), "ptn-sheet--crop");
    if (opts.hint) sh.body.appendChild(el("p", "ptn-hint", opts.hint));
    else {
      /* deutlicher Hinweis (Wunsch Leslie): Verschieben per Ziehen, Groesse per Regler */
      var hint = el("p", "ptn-crop-hint", "\u270B Bild mit Finger oder Maus verschieben – nach oben, unten, links oder rechts. In der Mitte rastet es ein. Mit „Größe“ verkleinern oder vergrößern.");
      hint.style.cssText = "margin:0 0 12px;padding:10px 12px;border-radius:10px;background:#fff1d6;border-left:4px solid #e8a93b;color:#1b3324;font-weight:600;font-size:16px;line-height:1.4";
      sh.body.appendChild(hint);
      sh.body.appendChild(el("p", "ptn-hint", "Die Fläche entspricht genau dem Platz auf dem Zertifikat."));
    }
    var frame = el("div", "ptn-crop-frame");
    var cv = el("canvas", "ptn-crop-canvas"); cv.width = box.width; cv.height = box.height;
    frame.appendChild(cv);
    /* Claude 26.10.2026: Einrasten in der Mitte (waagerecht/senkrecht) mit Hilfslinien – nur Anzeige, nicht im Bild */
    frame.style.position = "relative";
    var gV = el("span", "ptn-crop-guide"), gH = el("span", "ptn-crop-guide");
    gV.style.cssText = "position:absolute;top:0;bottom:0;left:50%;width:0;margin-left:-1px;border-left:2px dashed #e8a93b;display:none;pointer-events:none";
    gH.style.cssText = "position:absolute;left:0;right:0;top:50%;height:0;margin-top:-1px;border-top:2px dashed #e8a93b;display:none;pointer-events:none";
    frame.appendChild(gV); frame.appendChild(gH);
    var lastMx = 0, lastMy = 0;
    var ctx = cv.getContext("2d");
    var file = el("input"); file.type = "file"; file.accept = "image/jpeg,image/png,image/webp"; file.className = "ptn-file";
    var pickBtn = el("button", "ptn-sheet-secondary", "Foto / Logo auswählen"); pickBtn.type = "button";
    on(pickBtn, "click", function () { file.click(); });
    var controls = el("div", "ptn-crop-controls"); controls.style.display = "none";
    var modes = el("div", "ptn-crop-modes");
    var mContain = el("button", "ptn-mini is-on", "Ganzes Bild"); mContain.type = "button";
    var mCover = el("button", "ptn-mini", "Fläche füllen"); mCover.type = "button";
    var mCenter = el("button", "ptn-mini", "Zentrieren"); mCenter.type = "button";
    modes.appendChild(mContain); modes.appendChild(mCover); modes.appendChild(mCenter);
    var zl = el("label", "ptn-crop-zoom");
    zl.appendChild(el("span", "ptn-field-label", "Größe"));
    /* Claude 26.10.2026: ab 20 % (vorher ab 100 %) – Logos lassen sich so auch kleiner als die volle Fläche setzen */
    var range = el("input"); range.type = "range"; range.min = "0.2"; range.max = "3"; range.step = "0.01"; range.value = "1";
    zl.appendChild(range);
    controls.appendChild(modes); controls.appendChild(zl);
    var err = el("p", "ptn-crop-error"); err.style.display = "none";
    var ok = el("button", "ptn-sheet-primary", "Bild übernehmen"); ok.type = "button"; ok.disabled = true;
    sh.body.appendChild(frame); sh.body.appendChild(pickBtn); sh.body.appendChild(file); sh.body.appendChild(controls); sh.body.appendChild(err); sh.body.appendChild(ok);
    var img = new Image(), mode = "contain", zoom = 1, dx = 0, dy = 0;
    function draw() {
      ctx.clearRect(0, 0, cv.width, cv.height);
      if (!img.naturalWidth) return;
      var cont = Math.min(cv.width / img.naturalWidth, cv.height / img.naturalHeight);
      var cov = Math.max(cv.width / img.naturalWidth, cv.height / img.naturalHeight);
      var sc = (mode === "cover" ? cov : cont) * zoom;
      var w = img.naturalWidth * sc, h = img.naturalHeight * sc;
      var mx = Math.abs(w - cv.width) / 2, my = Math.abs(h - cv.height) / 2;
      dx = Math.max(-mx, Math.min(mx, dx));
      dy = Math.max(-my, Math.min(my, dy));
      lastMx = mx; lastMy = my;
      ctx.drawImage(img, (cv.width - w) / 2 + dx, (cv.height - h) / 2 + dy, w, h);
      mContain.className = "ptn-mini" + (mode === "contain" ? " is-on" : "");
      mCover.className = "ptn-mini" + (mode === "cover" ? " is-on" : "");
    }
    function reset(m) { mode = m; zoom = 1; dx = 0; dy = 0; range.value = "1"; draw(); }
    on(mContain, "click", function () { reset("contain"); });
    on(mCover, "click", function () { reset("cover"); });
    on(mCenter, "click", function () { dx = 0; dy = 0; draw(); });
    on(range, "input", function () { zoom = Number(range.value) || 1; draw(); });
    on(range, "change", function () { zoom = Number(range.value) || 1; draw(); });
    function showErr(t) { err.textContent = t; err.style.display = ""; }
    on(file, "change", function () {
      var fl = file.files && file.files[0];
      if (!fl) return;
      if ((fl.type && !/^image\/(jpeg|png|webp)$/.test(fl.type)) || fl.size > 15 * 1024 * 1024) { showErr("Bitte wähle ein JPG, PNG oder WebP bis 15 MB."); return; }
      err.style.display = "none";
      pickBtn.textContent = "Bild wird geladen …";
      var rd = new FileReader();
      rd.onload = function () {
        var raw = new Image();
        raw.onload = function () {
          var k = Math.min(1, 1600 / Math.max(raw.naturalWidth, raw.naturalHeight));
          var c2 = document.createElement("canvas");
          c2.width = Math.max(1, Math.round(raw.naturalWidth * k)); c2.height = Math.max(1, Math.round(raw.naturalHeight * k));
          c2.getContext("2d").drawImage(raw, 0, 0, c2.width, c2.height);
          img = new Image();
          img.onload = function () { controls.style.display = ""; pickBtn.textContent = "Anderes Bild wählen"; ok.disabled = false; frame.className = "ptn-crop-frame has-img"; reset("contain"); };
          img.src = c2.toDataURL(fl.type === "image/png" ? "image/png" : "image/jpeg", 0.9);
        };
        raw.onerror = function () { pickBtn.textContent = "Foto / Logo auswählen"; showErr("Das Bild konnte nicht geöffnet werden. Bitte versuche ein JPG oder PNG."); };
        raw.src = String(rd.result);
      };
      rd.onerror = function () { pickBtn.textContent = "Foto / Logo auswählen"; showErr("Die Datei konnte nicht gelesen werden."); };
      rd.readAsDataURL(fl);
    });
    var drag2 = null;
    function startD(x, y) { if (img.naturalWidth) drag2 = { x: x, y: y, dx: dx, dy: dy }; }
    function moveD(x, y) {
      if (!drag2) return;
      var r = cv.getBoundingClientRect();
      if (!r.width) return;
      dx = drag2.dx + (x - drag2.x) * cv.width / r.width;
      dy = drag2.dy + (y - drag2.y) * cv.height / r.height;
      var snapX = lastMx > 1 && Math.abs(dx) < cv.width * 0.025, snapY = lastMy > 1 && Math.abs(dy) < cv.height * 0.06;
      if (snapX) dx = 0;
      if (snapY) dy = 0;
      gV.style.display = snapX ? "" : "none";
      gH.style.display = snapY ? "" : "none";
      draw();
    }
    function endD() { drag2 = null; gV.style.display = "none"; gH.style.display = "none"; }
    var passive = false;
    try { var opt = Object.defineProperty({}, "passive", { get: function () { passive = true; return true; } }); window.addEventListener("ptntest", null, opt); } catch (e) {}
    cv.addEventListener("touchstart", function (e) { if (e.touches.length === 1) startD(e.touches[0].clientX, e.touches[0].clientY); }, passive ? { passive: true } : false);
    cv.addEventListener("touchmove", function (e) { if (drag2 && e.touches.length === 1) { e.preventDefault(); moveD(e.touches[0].clientX, e.touches[0].clientY); } }, passive ? { passive: false } : false);
    cv.addEventListener("touchend", endD, false);
    on(cv, "mousedown", function (e) { startD(e.clientX, e.clientY); e.preventDefault(); });
    on(document, "mousemove", function (e) { moveD(e.clientX, e.clientY); });
    on(document, "mouseup", endD);
    on(ok, "click", function () {
      if (!img.naturalWidth) return;
      var data = cv.toDataURL("image/png");
      if (opts.apply) { opts.apply(data); sh.close(); return; }
      ui.photos[slot] = data;
      ui.photoSrc = ui.photoSrc || {};
      ui.photoSrc[slot] = { src: img.src, mode: mode, zoom: zoom, dx: dx, dy: dy };
      try { L.photo(slot, data); } catch (e) {}
      track("ptn_photo", { slot: slot });
      sh.close(); renderStep(); updateBar(); refreshNavLock(); saveDraft(); fitSoon();
    });
    /* Claude 26.10.2026 (Wunsch Leslie): "Bild ändern" zeigt das bisherige Bild in gleicher Lage zum Nachjustieren,
       dazu "Bild entfernen". Ohne gemerktes Original (alte Entwuerfe/Bestellungen): durchsichtigen Rand des fertigen
       Bildes abschneiden und Groesse/Lage so setzen, dass es exakt wie vorher sitzt. */
    if (opts.apply || !ui.photos[slot]) return;
    var del = el("button", "ptn-link ptn-crop-del", "Bild entfernen und wieder Text verwenden"); del.type = "button";
    del.style.cssText = "display:block;margin:12px auto 0;color:#8a2b20;text-decoration:underline;background:none;border:0;font-size:15px;cursor:pointer";
    on(del, "click", function () { delete ui.photos[slot]; if (ui.photoSrc) delete ui.photoSrc[slot]; try { L.photo(slot, ""); } catch (e) {} sh.close(); renderStep(); updateBar(); refreshNavLock(); saveDraft(); fitSoon(); });
    sh.body.appendChild(del);
    function loadPrev(src, p) {
      var im = new Image();
      im.onload = function () {
        img = im; controls.style.display = ""; pickBtn.textContent = "Anderes Bild wählen"; ok.disabled = false; frame.className = "ptn-crop-frame has-img";
        mode = p.mode === "cover" ? "cover" : "contain"; zoom = Number(p.zoom) || 1; dx = Number(p.dx) || 0; dy = Number(p.dy) || 0;
        range.value = String(Math.max(0.2, Math.min(3, zoom))); draw();
      };
      im.src = src;
    }
    var prev = ui.photoSrc && ui.photoSrc[slot];
    if (prev && prev.src) { loadPrev(prev.src, prev); return; }
    var flat = new Image();
    flat.onload = function () {
      var W = cv.width, H = cv.height, tc = document.createElement("canvas"); tc.width = W; tc.height = H;
      var tx = tc.getContext("2d"); tx.drawImage(flat, 0, 0, W, H);
      var d = null; try { d = tx.getImageData(0, 0, W, H).data; } catch (e) {}
      var x0 = W, y0 = H, x1 = -1, y1 = -1, x, y;
      if (d) for (y = 0; y < H; y++) for (x = 0; x < W; x++) if (d[(y * W + x) * 4 + 3] > 8) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      if (x1 < 0) { loadPrev(flat.src, { mode: "contain", zoom: 1 }); return; }
      var w = x1 - x0 + 1, h = y1 - y0 + 1, oc = document.createElement("canvas"); oc.width = w; oc.height = h;
      oc.getContext("2d").drawImage(tc, x0, y0, w, h, 0, 0, w, h);
      var cont = Math.min(W / w, H / h);
      loadPrev(oc.toDataURL("image/png"), { mode: "contain", zoom: 1 / cont, dx: x0 + w / 2 - W / 2, dy: y0 + h / 2 - H / 2 });
    };
    flat.src = ui.photos[slot];
  }

  /* ---------- Team-Korrektur: Laden, Speichern, Uebersicht ---------- */
  function staffReq(method, path, data, done) {
    var x = new XMLHttpRequest();
    x.open(method, STAFF_API + path, true);
    if (data) x.setRequestHeader("Content-Type", "application/json");
    x.timeout = 240000;
    x.onload = function () {
      var j = null; try { j = JSON.parse(x.responseText); } catch (e) {}
      if (x.status >= 200 && x.status < 300 && j && j.ok) done(null, j);
      else done(new Error((j && (typeof j.detail === "string" ? j.detail : j.message)) || ("Fehler " + x.status)));
    };
    x.onerror = function () { done(new Error("Keine Verbindung zum Server.")); };
    x.ontimeout = function () { done(new Error("Der Server antwortet nicht – bitte noch einmal versuchen.")); };
    x.send(data ? JSON.stringify(data) : null);
  }
  var staffNoteEl = null;
  function staffNote(msg, bad) {
    if (!staffNoteEl) { staffNoteEl = el("div", "ptn-staffnote"); document.body.appendChild(staffNoteEl); }
    staffNoteEl.textContent = msg || "";
    staffNoteEl.className = "ptn-staffnote" + (bad ? " is-bad" : "");
    staffNoteEl.style.display = msg ? "" : "none";
  }
  function staffCss() {
    var css = ".ptn-staffnote{position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:2147483000;max-width:92vw;padding:14px 20px;border-radius:12px;background:#1b3324;color:#f4efe2;font:600 17px/1.4 system-ui,sans-serif;box-shadow:0 8px 30px rgba(0,0,0,.35)}" +
      ".ptn-staffnote.is-bad{background:#7a1f1f}" +
      ".ptn-staffbar{margin:0 0 10px;padding:9px 12px;border-radius:10px;background:#e8a93b;color:#1b3324;font-size:15px;line-height:1.35}" +
      ".ptn-staff-sum{display:grid;grid-template-columns:auto 1fr;gap:4px 12px;margin:0 0 14px;padding:12px 14px;border-radius:12px;background:rgba(27,51,36,.07);font-size:16px}" +
      ".ptn-staff-sum b{font-weight:700;opacity:.7}.ptn-staff-sum span{white-space:pre-line;word-break:break-word}" +
      ".ptn-staff-btn{display:inline-block;padding:11px 16px;border-radius:12px;border:2px solid #1b3324;background:#fff;color:#1b3324;font:700 16px/1.2 system-ui,sans-serif!important;letter-spacing:0;text-transform:none;text-decoration:none;cursor:pointer;text-align:center}" +
      ".ptn-staff-btn.is-main{background:#1b3324;color:#fff}" +
      ".ptn-staff-docs{display:flex;flex-wrap:wrap;gap:12px;margin:6px 0 14px}" +
      ".ptn-staff-doc{flex:1 1 170px;display:flex;flex-direction:column;gap:6px;padding:12px;border-radius:14px;background:#fff;border:1px solid rgba(27,51,36,.18);color:#1b3324}" +
      ".ptn-staff-doc img{width:100%;height:170px;object-fit:contain;background:#f3f1ea;border-radius:8px}" +
      ".ptn-staff-doc strong{font-size:17px}.ptn-staff-doc small{font-size:14px;opacity:.75}" +
      ".ptn-staff-acts{display:flex;flex-wrap:wrap;gap:10px;margin-top:6px}";
    var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);
    /* Cookie-Hinweis ist bei offenem Gestalter (ptn-lock) ausgeblendet, sperrt als modaler Dialog aber die Seite:
       im Team-Modus solange ptn-lock wegnehmen, damit er sichtbar beantwortet werden kann */
    cookieLift();
  }
  /* Claude 29.10.2026: gilt fuer alle (Weiterschenken ?ptv=, /#gestalten ...): solange der Cookie-Hinweis modal offen ist, ptn-lock wegnehmen -> sichtbar + beantwortbar */
  function cookieLift() {
    if (cookieLift.on) return; cookieLift.on = 1;
    var de = document.documentElement, lifted = false;
    setInterval(function () {
      var c = " " + de.className + " ";
      if (c.indexOf(" pt-cookie-modal-open ") >= 0 && c.indexOf(" ptn-lock ") >= 0) { lifted = true; rmCls(de, "ptn-lock"); }
      else if (lifted && c.indexOf(" pt-cookie-modal-open ") < 0) { lifted = false; if (opened) addCls(de, "ptn-lock"); }
    }, 300);
  }
  cookieLift();
  function staffLoad() {
    try { if (window.PTGuidedSession && window.PTGuidedSession.clear) window.PTGuidedSession.clear(); } catch (e) {}
    staffCss();
    staffNote("Bestelltes Zertifikat wird geladen …");
    staffReq("GET", "staff_edit_info?t=" + encodeURIComponent(STAFF), null, function (err, j) {
      if (err) { staffNote("Team-Korrektur nicht möglich: " + err.message, true); return; }
      staff.info = j;
      Promise.resolve(L.importState(j.state)).then(function () {
        var ex = null; try { ex = L.exportState(); } catch (e) {}
        adoptState(ex);
        ui.verbManual = false;
        ui.photoSrc = (j.state && j.state._pt_photo_src) || {};
        if (j.has_greet) { try { L.greeting(true); } catch (e) {} }
        staffNote("");
        addCls(modal, "ptn-staff");
        topTitle.textContent = "Team-Korrektur";
        var sb = el("div", "ptn-staffbar");
        sb.appendChild(el("strong", "", "Team-Korrektur"));
        sb.appendChild(el("span", "", " · " + (j.order_name ? "Bestellung " + j.order_name + " · " : "") + "Code " + j.code));
        mainCol.insertBefore(sb, nav);
        /* Claude 28.10.2026: Versandseite "Aendern" bei Grusskarte/Etikett -> direkt in den Speichern-Schritt */
        var sTo = (/[?&]pt_staff_to=(greet|label)/.exec(location.search || "") || [])[1] || "";
        if (sTo === "label") staff.toLabel = true;
        openModal(sTo ? stepIx("staff") : 0);
        if (sTo === "greet" && j.has_greet) setTimeout(function () { try { greetSheet(); } catch (e2) {} }, 400);
      }, function (e) { staffNote("Das bestellte Zertifikat konnte nicht geladen werden: " + ((e && e.message) || e), true); });
    });
  }
  function staffBackUrl() {
    var inf = staff.info || {};
    if (STAFF && inf.order_id) return STAFF_API + "staff_order?order=" + encodeURIComponent(inf.order_id);
    return STAFF_API + "staff_admin";
  }
  /* Claude 28.10.2026: Etikett als SVG wie der Server-Druck (3000x2000, gleiche Groessen/Lagen, nur verkleinern) */
  var LBL_MAX = [30, 30, 45];
  var LBL_PT = "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/Planet-Tree_Partnerlogo_2000px_PNG.png?v=1763296351";
  var LBL_FOREST = { by: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/logo_stadt-alzenau.png?v=1763339207",
    mv: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/logo_mv.png?v=1761496369", rp: "https://cdn.shopify.com/s/files/1/0505/0685/8683/files/logo_rp.png?v=1761496369" };
  function lblSvg(lines, claim, border, forest) {
    var NS = "http://www.w3.org/2000/svg";
    var mk = function (tag, at) { var e = document.createElementNS(NS, tag); for (var k in at) if (Object.prototype.hasOwnProperty.call(at, k)) e.setAttribute(k, at[k]); return e; };
    var v = mk("svg", { viewBox: "0 0 3000 2000", "class": "ptn-lblsvg", role: "img", "aria-label": "Etikett" });
    v.appendChild(mk("rect", { width: 3000, height: 2000, rx: 40, fill: /^#[0-9a-f]{6}$/i.test(border || "") ? border : "#337451" }));
    v.appendChild(mk("rect", { x: 260, y: 260, width: 2480, height: 1480, rx: 22, fill: "#fff" }));
    var cv = null; try { cv = document.createElement("canvas").getContext("2d"); } catch (e) {}
    [[lines[0], 420, 255, 700], [claim, 640, 200, 400], [lines[1], 885, 290, 700], [lines[2], 1125, 200, 400]].forEach(function (r) {
      var t = String(r[0] || "").replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "");
      if (!t) return;
      var fs = r[2];
      if (cv) { cv.font = r[3] + " " + fs + 'px "Amatic SC",Arial,sans-serif'; var w = cv.measureText(t).width; if (w > 2320) fs = fs * 2320 / w; }
      var tx = mk("text", { x: 1500, y: r[1], dy: ".35em", "text-anchor": "middle", "font-family": "Amatic SC,Arial,sans-serif", "font-weight": r[3], "font-size": fs, fill: "#162716" });
      tx.textContent = t; v.appendChild(tx);
    });
    var img = function (h, x, y, w, hh) { var i = mk("image", { x: x, y: y, width: w, height: hh, preserveAspectRatio: "xMidYMax meet" }); i.setAttributeNS("http://www.w3.org/1999/xlink", "href", h); i.setAttribute("href", h); v.appendChild(i); };
    img(LBL_PT, 370, 1270, 520, 450);
    img(LBL_FOREST[String(forest || "").toLowerCase()] || LBL_FOREST.by, 1630, 1310, 1000, 390);
    return v;
  }
  /* Gestalter: Etikett-Felder begrenzen; zu lange Widmung nicht aufs Etikett (sonst winzige Schrift) */
  function lblLimit(box) {
    var M = { line1: 30, line2: 30, claim: 40, line3: 45 }, over = false;
    ["line1", "line2", "claim", "line3"].forEach(function (k) {
      var inp = box.querySelector("#ptg-label-" + k);
      if (!inp || inp.getAttribute("data-ptn-lim")) return;
      inp.setAttribute("data-ptn-lim", "1");
      inp.maxLength = M[k];
      var cnt = el("span", "ptn-lblcnt", "");
      inp.parentNode.insertBefore(cnt, inp.nextSibling);
      var upd = function () { var n = inp.value.length; cnt.textContent = n + "/" + M[k] + " Zeichen"; cnt.className = "ptn-lblcnt" + (n > M[k] ? " is-over" : ""); };
      if (k === "line3" && inp.value.length > M[k]) {
        inp.value = "";
        var ev; try { ev = new Event("input", { bubbles: true }); } catch (e) { ev = document.createEvent("Event"); ev.initEvent("input", true, true); }
        inp.dispatchEvent(ev);
        inp.parentNode.insertBefore(el("p", "ptn-hint ptn-lblhint", "Deine Widmung ist fürs Etikett zu lang – dort stehen nur die Namen. Wenn du magst, trag hier eine kurze Zeile ein (bis " + M[k] + " Zeichen)."), inp);
        over = true;
      } else if (inp.value.length > M[k]) over = true;
      on(inp, "input", upd); upd();
    });
    return over;
  }
  function staffOne(v) { return String(v || "").replace(/\s*\n\s*/g, " ").replace(/^\s+|\s+$/g, ""); }
  function staffLabelInit() {
    if (staff.labelTouched && staff.label) return;
    var inf = staff.info || {}, l = inf.label || ["", "", ""], st = inf.state || {};
    /* Etikett folgt geaenderten Namen, solange es vorher genau die Namen zeigte */
    staff.label = [
      staffOne(l[0]) === staffOne(st.sender) ? staffOne(ui.sender) : (l[0] || ""),
      staffOne(l[1]) === staffOne(st.recipient) ? staffOne(ui.recipient) : (l[1] || ""),
      l[2] || ""
    ];
  }
  function stepStaff() {
    if (staff.result) { staffResult(); return; }
    var inf = staff.info || {};
    head("Änderungen speichern", "Das Zertifikat wird mit demselben Code, QR-Code und Pflanzort neu erstellt und ersetzt die Datei in der Bestellung.");
    var sum = el("div", "ptn-staff-sum");
    var rows = BIRTH ? [["Kind", bData().name], ["Geburt", bDateText(bData().date)]] :
      [["Von", ui.photos.sender ? "(Bild)" : ui.sender], ["", (ui.verb === "haben" ? "haben " : "hat ") + claimPhrase(claimNow())], ["Für", ui.photos.recipient ? "(Bild)" : ui.recipient], ["Widmung", ui.photos.message ? "(Bild)" : ui.message]];
    rows.forEach(function (r) { sum.appendChild(el("b", "", r[0])); sum.appendChild(el("span", "", r[1] || "–")); });
    body.appendChild(sum);
    if (inf.has_label) {
      staffLabelInit();
      var sec = el("div", "ptn-sec ptn-staff-label");
      sec.appendChild(el("span", "ptn-field-label", "Etikett am Geschenk"));
      /* Claude 28.10.2026: Vorschau wie gedruckt, Zeilen begrenzt */
      var pv = el("div", "ptn-lblprev");
      var lclaim = inf.label_claim || ((ui.verb === "haben" ? "haben" : "hat") + " einen Baum gepflanzt für");
      var paint = function () { pv.innerHTML = ""; pv.appendChild(lblSvg(staff.label, lclaim, inf.label_border, inf.label_forest)); };
      paint();
      sec.appendChild(pv);
      ["Zeile 1 · Von", "Zeile 2 · Für", "Zeile 3 · Anlass (optional)"].forEach(function (lab, i) {
        var cnt = el("span", "ptn-lblcnt", "");
        var upd = function () { var n = String(staff.label[i] || "").length; cnt.textContent = n + "/" + LBL_MAX[i]; cnt.className = "ptn-lblcnt" + (n > LBL_MAX[i] ? " is-over" : ""); };
        var f = field(lab, staff.label[i], "", function (v) { staff.label[i] = v; staff.labelTouched = true; upd(); paint(); }, { maxLength: LBL_MAX[i] });
        upd(); f.wrap.appendChild(cnt); sec.appendChild(f.wrap);
      });
      body.appendChild(sec);
      if (staff.toLabel) {
        staff.toLabel = false;
        setTimeout(function () { try { sec.scrollIntoView({ block: "start", behavior: "smooth" }); } catch (e) {} addCls(sec, "is-target"); var f0 = sec.querySelector("input, textarea"); if (f0) try { f0.focus({ preventScroll: true }); } catch (e3) { f0.focus(); } }, 350);
      }
    }
    if (inf.has_greet) {
      var gs = el("div", "ptn-sec");
      gs.appendChild(el("span", "ptn-field-label", "Grußkarte"));
      var gb = el("button", "ptn-staff-btn", "Grußkarte ansehen & ändern"); gb.type = "button";
      on(gb, "click", function () { greetSheet(); });
      gs.appendChild(gb); body.appendChild(gs);
    }
    if (!inf.has_label && !inf.has_greet) body.appendChild(el("p", "ptn-hint", "Zu dieser Position gehören kein Etikett und keine Grußkarte."));
    body.appendChild(el("p", "ptn-hint", "Pflanzort, Anzahl der Bäume, Format, Papier, Rahmen und Geschenk bleiben wie bestellt. Der Kunde bekommt keine E-Mail."));
  }
  function staffSave() {
    if (staff.saving || !L) return;
    if (!canAdvance(0)) { goStep(0); flash(BIRTH ? "Bitte Namen und Geburtsdatum des Kindes eintragen." : "Bitte beide Namen eintragen (oder ein Bild wählen)."); return; }
    if (BIRTH && bProblem()) { goStep(1); flash(bProblem()[1]); return; }
    if (staff.info && staff.info.has_label) staffLabelInit();
    var data;
    try {
      data = { t: STAFF, payload: (function () { var pl = L.payload(); pl._pt_photo_src = ui.photoSrc || {}; return pl; })(), guided: L.exportState(),
        label: staff.label ? { line1: staff.label[0], line2: staff.label[1], line3: staff.label[2] } : null };
    } catch (e) { flash("Die Gestaltung konnte nicht gelesen werden."); return; }
    staff.saving = true; ui.busy = true; barNext.disabled = true; barNext.textContent = "Wird neu erstellt …";
    staffReq("POST", "staff_edit_save", data, function (err, j) {
      staff.saving = false; ui.busy = false; barNext.disabled = false;
      if (err) { updateBar(); flash(err.message); return; }
      staff.result = j;
      goStep(STEPS.length - 1);
    });
  }
  function staffResult() {
    var r = staff.result, lk = r.links || {}, inf = staff.info || {};
    if (ISSUE) head("Ausgestellt – Zertifikat " + r.code, "Echter Code mit Baum-Nr. und GPS, ohne Bestellung. Lade hier herunter, was du brauchst.");
    else head("Fertig – die neuen Dokumente", "Zertifikat " + r.code + (inf.order_id ? " ist in der Bestellung ersetzt" : " ist ersetzt") + " (gleicher Code, QR-Code und Pflanzort). Lade hier herunter, was du brauchst.");
    var grid = el("div", "ptn-staff-docs");
    function doc(title, sub, href, img) {
      if (!href) return;
      var c = el("div", "ptn-staff-doc");
      if (img) { var im = el("img"); im.src = img; im.alt = title; c.appendChild(im); }
      c.appendChild(el("strong", "", title));
      c.appendChild(el("small", "", sub));
      var a = el("a", "ptn-staff-btn is-main", "⬇ Herunterladen"); a.href = href; a.target = "_blank"; a.rel = "noopener";
      c.appendChild(a);
      grid.appendChild(c);
    }
    doc(BIRTH ? "Urkunde" : "Zertifikat", "PDF zum Drucken · Code " + r.code, lk.cert_pdf, lk.cert_png);
    if (inf.has_label) doc("Etikett", "PNG zum Drucken", lk.label_png, lk.label_png);
    if (inf.has_greet) doc("Grußkarte", "PNG zum Drucken", lk.greet_png, lk.greet_png);
    body.appendChild(grid);
    var acts = el("div", "ptn-staff-acts");
    if (lk.cert_view) { var v = el("a", "ptn-staff-btn", "PDF ansehen"); v.href = lk.cert_view; v.target = "_blank"; v.rel = "noopener"; acts.appendChild(v); }
    if (ISSUE) {
      if (r.edit_url) { var ed = el("a", "ptn-staff-btn", "Ändern"); ed.href = r.edit_url; acts.appendChild(ed); }
      var more = el("button", "ptn-staff-btn", "Weiteres Zertifikat"); more.type = "button";
      on(more, "click", issueAnother); acts.appendChild(more);
      if (r.hub_url) { var hub = el("a", "ptn-staff-btn", "Zur Team-Zentrale"); hub.href = r.hub_url; acts.appendChild(hub); }
      body.appendChild(acts);
      body.appendChild(el("p", "ptn-hint", "„Weiteres Zertifikat“ behält die Gestaltung (z. B. Logo) – nur den Namen der beschenkten Person neu eintragen."));
      return;
    }
    var again = el("button", "ptn-staff-btn", "Nochmal ändern"); again.type = "button";
    on(again, "click", function () { staff.result = null; goStep(0); });
    acts.appendChild(again);
    var back = el("a", "ptn-staff-btn", inf.order_id ? "Zur Bestellübersicht" : "Zur Team-Zentrale"); back.href = staffBackUrl();
    acts.appendChild(back);
    body.appendChild(acts);
    body.appendChild(el("p", "ptn-hint", inf.order_id ? "Die Links in der Shopify-Bestellung („Fertiges Zertifikat“ usw.) zeigen ab sofort auf die neuen Dateien. Die alten Dateien liegen als Sicherung auf dem Server." : "Die alte Datei liegt als Sicherung auf dem Server."));
  }

  /* ---------- Team-Ausstellung: Laden, Vorlage speichern, Ausstellen ---------- */
  function staffBanner(title, sub) {
    if (staff.bar && staff.bar.parentNode) staff.bar.parentNode.removeChild(staff.bar);
    var sb = el("div", "ptn-staffbar");
    sb.appendChild(el("strong", "", title));
    sb.appendChild(el("span", "", " · " + sub));
    mainCol.insertBefore(sb, nav);
    staff.bar = sb;
  }
  function issueLoad() {
    try { if (window.PTGuidedSession && window.PTGuidedSession.clear) window.PTGuidedSession.clear(); } catch (e) {}
    staffCss();
    staffNote(ISSUE_TPL ? "Vorlage wird geladen …" : "Team-Ausstellung wird vorbereitet …");
    staffReq("GET", "staff_issue_info?t=" + encodeURIComponent(ISSUE) + (ISSUE_TPL ? "&tpl=" + ISSUE_TPL : ""), null, function (err, j) {
      if (err) { staffNote("Team-Ausstellung nicht möglich: " + err.message, true); return; }
      staff.info = j;
      function go() {
        staffNote("");
        addCls(modal, "ptn-staff");
        topTitle.textContent = "Team-Ausstellung";
        staffBanner("Team-Ausstellung", staff.tpl ? "Vorlage „" + staff.tpl.name + "“" : "ohne Bestellung");
        /* Beispieltexte der Engine (Lotta/Paul, "Alles Liebe ...") weg: was leer ist, bleibt auf dem Zertifikat leer */
        ["sender", "recipient", "message"].forEach(function (k) { if (!ui[k] && !ui.photos[k]) { try { L.text(k, ""); } catch (e) {} } });
        openModal(0);
      }
      if (!j.template) { go(); return; }
      staff.tpl = { id: j.template.id, name: j.template.name };
      staff.tplName = j.template.name;
      var st = j.template.payload || {};
      st._pt_guided_state = j.template.guided || null;
      Promise.resolve(L.importState(st)).then(function () {
        var ex = null; try { ex = L.exportState(); } catch (e) {}
        adoptState(ex);
        ui.verbManual = false;
        ui.photoSrc = st._pt_photo_src || {};
        go();
      }, function (e) { staffNote("Die Vorlage konnte nicht geladen werden: " + ((e && e.message) || e), true); });
    });
  }
  function forestTitle(k) { for (var i = 0; i < FORESTS.length; i++) if (FORESTS[i].key === k) return FORESTS[i].title; return k || ""; }
  function stepIssue() {
    if (staff.result) { staffResult(); return; }
    var ex = null; try { ex = L.exportState(); } catch (e) {}
    ex = ex || {};
    head("Zertifikat ausstellen", "Echter Zertifikatscode mit Baum-Nr. und GPS – ohne Shopify-Bestellung, Rechnung oder E-Mail.");
    var sum = el("div", "ptn-staff-sum");
    var rows = BIRTH ? [["Kind", bData().name], ["Geburt", bDateText(bData().date)]] :
      [["Von", ui.photos.sender ? "(Bild/Logo)" : ui.sender], ["", (ui.verb === "haben" ? "haben " : "hat ") + claimPhrase(claimNow())],
       ["Für", ui.photos.recipient ? "(Bild/Logo)" : ui.recipient], ["Widmung", ui.photos.message ? "(Bild)" : ui.message]];
    rows.push(["Pflanzort", forestTitle(ex.forest)]);
    rows.push(["Bäume", String(BIRTH ? 1 : (ex.trees || 1))]);
    rows.forEach(function (r) { sum.appendChild(el("b", "", r[0])); sum.appendChild(el("span", "", r[1] || "–")); });
    body.appendChild(sum);
    var nf = field("Notiz (nur intern, z. B. Ticket oder Firma)", staff.note || "", "z. B. Ticket 46593", function (v) { staff.note = v; }, { maxLength: 200 });
    body.appendChild(nf.wrap);
    var sec = el("div", "ptn-sec");
    sec.appendChild(el("span", "ptn-field-label", "Als Kundenvorlage speichern"));
    sec.appendChild(el("p", "ptn-hint", "Speichert die ganze Gestaltung – auch ein Logo mit Größe und Position – für spätere Zertifikate dieses Kunden."));
    var tf = field("Name der Vorlage", staff.tplName || "", "z. B. Werbe-Schmiede Hanau", function (v) { staff.tplName = v; }, { maxLength: 80 });
    sec.appendChild(tf.wrap);
    var acts = el("div", "ptn-staff-acts");
    var b1 = el("button", "ptn-staff-btn", staff.tpl ? "Vorlage aktualisieren" : "Als Vorlage speichern"); b1.type = "button";
    on(b1, "click", function () { issueTplSave(false, b1); });
    acts.appendChild(b1);
    if (staff.tpl) {
      var b2 = el("button", "ptn-staff-btn", "Als neue Vorlage speichern"); b2.type = "button";
      on(b2, "click", function () { issueTplSave(true, b2); });
      acts.appendChild(b2);
    }
    sec.appendChild(acts);
    if (staff.tplMsg) sec.appendChild(el("p", "ptn-hint", staff.tplMsg));
    body.appendChild(sec);
  }
  function issueData() {
    var pl = L.payload(); pl._pt_photo_src = ui.photoSrc || {};
    return { t: ISSUE, payload: pl, guided: L.exportState() };
  }
  function issueCheck() {
    if (!canAdvance(0)) { goStep(0); flash(BIRTH ? "Bitte Namen und Geburtsdatum des Kindes eintragen." : "Bitte beide Namen eintragen (oder ein Bild/Logo wählen)."); return false; }
    if (BIRTH && bProblem()) { goStep(1); flash(bProblem()[1]); return false; }
    return true;
  }
  function issueTplSave(asNew, btn) {
    if (staff.saving || !L) return;
    var name = String(staff.tplName || "").replace(/^\s+|\s+$/g, "");
    if (!name) { flash("Bitte einen Namen für die Vorlage eingeben."); return; }
    var data;
    try { data = issueData(); } catch (e) { flash("Die Gestaltung konnte nicht gelesen werden."); return; }
    data.id = staff.tpl && !asNew ? staff.tpl.id : 0;
    data.as_new = !!asNew;
    data.name = name;
    staff.saving = true;
    var label = btn.textContent; btn.disabled = true; btn.textContent = "Wird gespeichert …";
    staffReq("POST", "staff_template_save", data, function (err, j) {
      staff.saving = false; btn.disabled = false; btn.textContent = label;
      if (err) { flash(err.message); return; }
      staff.tpl = { id: j.id, name: j.name }; staff.tplName = j.name;
      staff.tplMsg = "✓ Vorlage „" + j.name + "“ gespeichert – sie steht jetzt in der Team-Zentrale.";
      staffBanner("Team-Ausstellung", "Vorlage „" + j.name + "“");
      renderStep(); updateBar();
    });
  }
  function issueSave() {
    if (staff.saving || !L || !issueCheck()) return;
    var data;
    try { data = issueData(); } catch (e) { flash("Die Gestaltung konnte nicht gelesen werden."); return; }
    data.note = staff.note || "";
    data.tpl = staff.tpl ? staff.tpl.id : 0;
    staff.saving = true; ui.busy = true; barNext.disabled = true; barNext.textContent = "Wird ausgestellt …";
    staffReq("POST", "staff_issue_save", data, function (err, j) {
      staff.saving = false; ui.busy = false; barNext.disabled = false;
      if (err) { updateBar(); flash(err.message); return; }
      staff.result = j;
      goStep(STEPS.length - 1);
    });
  }
  function issueAnother() {
    staff.result = null;
    if (!ui.photos.recipient) { ui.recipient = ""; try { L.text("recipient", ""); } catch (e) {} }
    goStep(0);
    var ins = body.querySelectorAll(".ptn-input");
    if (ins[1]) { try { ins[1].focus(); } catch (e) {} }
  }

  /* ---------- Leiste ---------- */
  function updateBar() {
    scheduleGreetPrep();
    try { applyLook(); } catch (e) {}
    var st = L ? L.state() : null;
    clear(barPrice);
    barPrice.appendChild(el("small", "", st ? (st.gift ? "Geschenk mit Baum" : (st.deliveryLabel || "")) : ""));
    barPrice.appendChild(el("strong", "", st ? euro(st.total) : "ab 15,00 €"));
    if (STAFF) { clear(barPrice); barPrice.appendChild(el("small", "", "Team-Korrektur")); barPrice.appendChild(el("strong", "", (staff.info && (staff.info.order_name || staff.info.code)) || "")); }
    if (ISSUE) { clear(barPrice); barPrice.appendChild(el("small", "", "Team-Ausstellung")); var tn = staff.tpl ? staff.tpl.name : "Neu"; barPrice.appendChild(el("strong", "", tn.length > 22 ? tn.slice(0, 21) + "…" : tn)); }
    var last = ui.step === STEPS.length - 1;
    var editing = false;
    try { editing = !!(window.PTGuidedSession && window.PTGuidedSession.editBundle && window.PTGuidedSession.editBundle()); } catch (e) {}
    barNext.textContent = ui.busy ? barNext.textContent : (last ? (ISSUE ? (staff.result ? "Weiteres Zertifikat" : "Zertifikat ausstellen") : STAFF ? (staff.result ? "Nochmal ändern" : "Speichern & neu erstellen") : editing ? "Warenkorb aktualisieren" : "In den Warenkorb") : "Weiter");
    if (QUICK && !last && STEPS[ui.step + 1] && STEPS[ui.step + 1].key === "quick" && !ui.busy) barNext.textContent = "Weiter zur Übersicht";
    var blocked = !canAdvance(ui.step);
    /* nie optisch gesperrt: bei fehlenden Angaben springt "Weiter" ins leere Feld */
    if (STEPS[ui.step].key === "quick" && !ui.busy) barNext.textContent = editing ? "Warenkorb aktualisieren" : "In den Warenkorb";  /* Leslie 28.10.: Warenkorb statt direkt zur Kasse (mehrere Geschenke) */
    if (QUICK && ui.qEdit && STEPS[ui.step].key !== "quick" && !ui.busy) { barNext.textContent = "\u00dcbernehmen \u2713"; last = false; }
    barNext.className = "ptn-next" + (last || STEPS[ui.step].key === "quick" ? " is-buy" : "");
    barNext.disabled = ui.busy;
    barBack.style.visibility = ui.step === 0 ? "hidden" : "visible";
  }
  on(barBack, "click", function () { if (QUICK && ui.qEdit) { ui.qEdit = false; ui.qPart = null; goStep(stepIx("quick")); return; } if (ui.step > 0) goStep(ui.step - 1); });
  /* "Weiter" ist nie hart deaktiviert: Ist ein Pflichtfeld leer, springt der Fokus dorthin.
     Bei offener Tastatur halten wir den Fokus, damit sie nicht zuklappt und wieder aufgeht. */
  function nextAction() {
    if (ui.busy) return;
    if (!canAdvance(ui.step)) { focusMissing(); return; }
    if (STEPS[ui.step].key === "quick") { var ed = false; try { ed = !!(window.PTGuidedSession && (window.PTGuidedSession.editBundle && window.PTGuidedSession.editBundle() || window.PTGuidedSession.customer && window.PTGuidedSession.customer())); } catch (e) {}
      track("ptn_quick_checkout", { edit: ed, to: "cart" }); buy("cart"); return; }
    if (QUICK && ui.qEdit) { ui.qEdit = false; ui.qPart = null; goStep(stepIx("quick")); return; }
    if (ui.step < STEPS.length - 1) { goStep(ui.step + 1); return; }
    buy("cart");
  }
  function focusMissing() {
    var ins = body.querySelectorAll(".ptn-input");
    var target = null;
    if (STEPS[ui.step].key === "child") {
      var bp = bProblem();
      if (bp && bp[0] === "name") target = ins[0];
      else if (bp && bp[0] === "date") { target = ins[1]; flash(bp[1]); }
    }
    if (STEPS[ui.step].key === "names") {
      if (!ui.photos.sender && !ui.sender.replace(/\s/g, "")) target = ins[0];
      else if (!ui.photos.recipient && !ui.recipient.replace(/\s/g, "")) target = ins[1];
    }
    if (target && target.style.display !== "none") {
      try { target.focus(); } catch (e) {}
      addCls(target, "is-nudge");
      setTimeout(function () { rmCls(target, "is-nudge"); }, 700);
      fitSoon();
    }
  }
  function inputFocused() {
    var a = document.activeElement;
    return !!(a && mainCol.contains(a) && /^(INPUT|TEXTAREA)$/.test(a.tagName));
  }
  var nextTouch = false;
  barNext.addEventListener("touchstart", function (e) {
    nextTouch = inputFocused();
    if (nextTouch) e.preventDefault();
  }, false);
  barNext.addEventListener("touchend", function (e) {
    if (!nextTouch) return;
    nextTouch = false;
    e.preventDefault();
    nextAction();
  }, false);
  on(barNext, "mousedown", function (e) { if (inputFocused()) e.preventDefault(); });
  on(barNext, "click", nextAction);
  function buy(kind) {
    if (ISSUE) { if (staff.result) issueAnother(); else issueSave(); return; }
    if (STAFF) { if (staff.result) { staff.result = null; goStep(0); } else staffSave(); return; }
    if (!L || ui.busy) return;
    if (!canAdvance(0)) { goStep(0); flash(BIRTH ? "Bitte trage zuerst Namen und Geburtsdatum des Kindes ein." : "Bitte trage zuerst beide Namen ein."); return; }
    if (BIRTH && bProblem()) { goStep(1); flash(bProblem()[1]); return; }
    ui.busy = true;
    barNext.disabled = true;
    barNext.textContent = kind === "paypal" ? "PayPal …" : "Wird vorbereitet …";
    track("ptn_buy", { method: kind });
    /* PayPal kann abgebrochen werden, ohne dass das Versprechen scheitert: dann wieder freigeben */
    function release() { if (!ui.busy) return; ui.busy = false; barNext.disabled = false; updateBar(); }
    Promise.resolve(kind === "paypal" ? L.paypal() : L.cart()).then(function () {
      if (kind === "paypal") setTimeout(release, 1200);
    }, function (e) {
      release();
      flash((e && e.message) || "Das hat gerade nicht geklappt. Bitte noch einmal versuchen.");
    });
    if (kind === "paypal") {
      /* PayPal-Fenster beobachten: wird es ohne Zahlung geschlossen, Buttons sofort wieder freigeben */
      var seen = false, ticks = 0;
      var iv = setInterval(function () {
        ticks++;
        var dlg = document.querySelector(".ptq-paypalFinalModal");
        var openNow = !!(dlg && (dlg.open || dlg.hasAttribute("open") || (" " + dlg.className + " ").indexOf(" is-open ") >= 0));
        if (openNow) seen = true;
        if ((seen && !openNow) || !ui.busy || ticks > 1200) { clearInterval(iv); release(); }
        else if (!seen && ticks > 150) { clearInterval(iv); release(); }
      }, 400);
    }
  }
  var flashT = 0;
  function flash(msg) {
    if (!msg) return;
    flashEl.textContent = msg; flashEl.style.display = "";
    clearTimeout(flashT); flashT = setTimeout(function () { flashEl.style.display = "none"; }, 6000);
  }

  /* ---------- Zoom ---------- */
  on(zoomBtn, "click", function () {
    if ((" " + modal.className + " ").indexOf(" is-zoom ") >= 0) { zoomOff(); return; }
    addCls(modal, "is-zoom"); carPaint();
    fit();
  });
  on(paper, "click", function () {
    if (ui.front && ui.front !== "cert") { setFront("cert"); return; }
    if ((" " + modal.className + " ").indexOf(" is-zoom ") >= 0) { rmCls(modal, "is-zoom"); fit(); }
  });

  /* ---------- Engine ---------- */
  function adoptState(s) {
    if (!s) return;
    ui.sender = s.sender || ""; ui.recipient = s.recipient || ""; ui.message = s.message || "";
    ui.verb = s.verb === "haben" ? "haben" : "hat";
    if (ui.verb === "haben") ui.verbManual = true;
    ui.photos = {};
    if (s.photos) for (var k in s.photos) if (s.photos.hasOwnProperty(k) && s.photos[k]) ui.photos[k] = s.photos[k];
    try { ui.lang = (L && L.langValue && L.langValue()) || "de"; } catch (e) { ui.lang = "de"; }
    /* Claude 03.11.2026 (Leslie): Weihnachts-Gestaltung nach Vorlage, Entwurf oder Aendern wiedererkennen; Kundenaenderungen (z. B. Verzierung entfernt) bleiben, xmasDesign wendet nichts neu an */
    try {
      var xc = claimNow(), xst = L.state();
      var xIs = (xc.key === "custom" && xc.custom === XMAS_DESIGN.claim) || (xst.deco === XMAS_DESIGN.deco && (String(xst.border || "").toLowerCase() === XMAS_DESIGN.border || /^xmas-/.test(xst.motif || "")));
      if (xIs) ui.occasion = occasionByKey("weihnachten");
      else if (isXmasOcc(ui.occasion)) ui.occasion = null;
      ui.xmasOn = isXmasOcc(ui.occasion);
    } catch (e) {}
  }
  function boot() {
    if (L || !window.PTGuidedLight) return;
    L = window.PTGuidedLight;
    if (window.PTGuidedUI) {
      window.PTGuidedUI.restore = function (state, step) { if (window.__ptnPro && QUICK) setPro(); adoptState(state); openModal(QUICK && canAdvance(0) ? stepIx("quick") : 0); };
      window.PTGuidedUI.open = function () { openModal(0); };
    }
    try { L.init(host.getAttribute("data-host-variant-id") || undefined); } catch (e) {}
    if (liveBox) liveBox.appendChild(L.stage); else paper.appendChild(L.stage);
    try { var ex = L.exportState && L.exportState(); if (ex && (ex.sender || ex.recipient || (ex.photos && (ex.photos.sender || ex.photos.recipient)))) adoptState(ex); } catch (e) {}
    /* Claude 28.10.2026 (Leslie): neue Gestaltung -> Forst zufaellig statt immer Bayern. Entwuerfe, Vorlagen, Aenderungen und Karten-Auswahl setzen ihn danach wieder. */
    try {
      var exr = L.exportState && L.exportState();
      if (!STAFF_ON && exr && !exr.sender && !exr.recipient && !location.hash && !/[?&](vorlage|edit_bundle|clone_bundle|customer_edit)=/.test(location.search || "")) {
        var fks = ["by", "mv", "rp"]; L.forest(fks[Math.floor(Math.random() * fks.length)]);
      }
    } catch (e) {}
    L.text("sender", ui.sender);
    L.text("recipient", ui.recipient);
    if (ui.message) L.text("message", ui.message);
    L.verb(ui.verb);
    if (BIRTH) {
      try { L.lang("de"); L.trees(1); L.text("sender", ""); L.text("message", "zur Geburt"); } catch (e) {}
      bEngine();
      var bForestOrig = L.forest;
      L.forest = function () { var r = bForestOrig.apply(L, arguments); bRender(); return r; };
      var bGpOrig = L.greetingPhoto, bGmOrig = L.greetingMotif;
      L.greetingPhoto = function () { if (!bGreetSetting) bGreetAutoImg = false; return bGpOrig.apply(L, arguments); };
      L.greetingMotif = function () { bGreetAutoImg = false; return bGmOrig.apply(L, arguments); };
      bCanvas();
      bRender();
    }
    try { L.onGreeting(onGreetChange); } catch (e) {}
    L.refresh();
    loading.style.display = "none";
    renderStart();
    track("ptn_ready", { gift_page: isGiftPage });
    heroIdle();
    if (buybox) buybox.ready();
    if (liveBox) {
      for (var li = 0; li < liveFields.length; li++) { var lk = liveFields[li].getAttribute("data-ptn-livefield"); if (BIRTH) { if (liveFields[li].value && lk === "bname" && !B.name) bSet("name", liveFields[li].value); if (liveFields[li].value && lk === "bdate" && !B.date) bSet("date", bParseDate(liveFields[li].value)); continue; } if (liveFields[li].value && !ui[lk]) { ui[lk] = liveFields[li].value; L.text(lk, ui[lk]); } }
      if (ui.sender) autoVerb();
      if (pendingLang) { var plg = pendingLang; pendingLang = ""; setLang(plg); }
      if (pendingOccasion && liveBox) { var plo = pendingOccasion; pendingOccasion = null; applyOccasionLive(plo); }
      liveSync();
    }
    /* Alte Links von anderen Seiten (/#pt-inline-personalizer, /#pt-quick-b2c) oeffnen direkt den Gestalter */
    if (!pendingOccasion && !pendingOpen && /^#(pt-inline-personalizer|pt-quick-b2c|ptn|gestalten)$/.test(location.hash || "")) {
      try { if (history.replaceState) history.replaceState(history.state, "", location.pathname + location.search); } catch (e) {}
      pendingOpen = "hash";
    }
    if (pendingOccasion) { var po = pendingOccasion; pendingOccasion = null; pendingOpen = null; chooseOccasion(po); }
    else if (pendingOpen) { var pp = pendingOpen; pendingOpen = null; openStart(pp); }
    var tw = 0;
    (function waitSession() {
      if (window.PTGuidedSession && window.PTGuidedSession.template) { tplOpenFromHash(); return; }
      if (++tw < 100) setTimeout(waitSession, 100);
    })();
    if (STAFF) staffLoad();
    else if (ISSUE) issueLoad();
  }
  window.PTNeu = { open: function (occ) { var o = occasionByKey(occ); if (o) chooseOccasion(o); else openStart("api"); } };
  /* Claude 24.10.2026: Auf Startseite/Zertifikatseite (statischer Hero mit Musterbild) startet die Engine erst bei der ersten
     Beruehrung (pointerdown/touchstart/keydown/focusin, vor dem Klick). Spart Vorschau-Rendern + ~350 KB, wenn niemand gestaltet.
     Sofort-Start bleibt bei Hash/Vorlage/Bearbeiten-Links und gespeicherten Entwuerfen (ptq_*). */
  var lazyBoot = staticHero && !BIRTH && !location.hash && !/[?&](vorlage|edit_bundle|clone_bundle|ptq_project|geschenk|occasion|anlass|pt_staff_edit|pt_staff_issue)=/.test(location.search) && !(function () {
    try { for (var i = 0; i < localStorage.length; i++) if (/^ptq_(cert_)?project/.test(localStorage.key(i) || "")) return true; } catch (e) {}
    return false;
  })();
  var touched = !lazyBoot, wakeEvs = ["pointerdown", "touchstart", "keydown", "focusin", "click"];
  function bootGate() { if (touched) boot(); }
  function wake() {
    if (touched || !wakeEvs) return; touched = true;
    for (var wi = 0; wi < wakeEvs.length; wi++) document.removeEventListener(wakeEvs[wi], wake, true);
    if (window.PTGuidedLight) boot();
  }
  if (lazyBoot) for (var ei = 0; ei < wakeEvs.length; ei++) document.addEventListener(wakeEvs[ei], wake, true);
  window.PTCustomUIReady = bootGate;
  window.addEventListener("pt:guided-ready", bootGate);
  renderStart();
  if (window.PTGuidedLight) bootGate();
  var tries = 0;
  (function wait() {
    if (L) return;
    if (window.PTGuidedLight) { bootGate(); return; }
    if (++tries < 150) setTimeout(wait, 100);
    else loading.textContent = "Der Gestalter konnte nicht geladen werden. Bitte Seite neu laden.";
  })();
})();
